var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPakWithKashmir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 586,
    viewBox: "0 0 750 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.463 290.573L317.568 290.156L315.482 285.709L318.29 281.679L323.185 282.096L325.271 286.543L322.463 290.573Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.064 294.983L308.17 294.566L306.083 290.118L308.892 286.088L313.786 286.505L315.872 290.952L313.064 294.983Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321.582 300.918L316.688 300.501L314.601 296.054L317.41 292.023L322.304 292.44L324.39 296.888L321.582 300.918Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.981 296.509L326.087 296.092L324 291.644L326.809 287.614L331.703 288.031L333.789 292.478L330.981 296.509Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331.862 286.164L326.967 285.747L324.881 281.3L327.689 277.269L332.584 277.686L334.67 282.134L331.862 286.164Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M323.344 280.229L318.449 279.812L316.363 275.365L319.171 271.334L324.066 271.751L326.152 276.198L323.344 280.229Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M313.945 284.638L309.05 284.221L306.964 279.774L309.772 275.743L314.667 276.16L316.753 280.608L313.945 284.638Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.665 299.392L298.77 298.975L296.684 294.528L299.492 290.497L304.387 290.914L306.473 295.361L303.665 299.392Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312.183 305.327L307.288 304.91L305.202 300.463L308.01 296.433L312.905 296.85L314.991 301.297L312.183 305.327Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M320.701 311.262L315.806 310.846L313.72 306.398L316.528 302.368L321.423 302.785L323.509 307.232L320.701 311.262Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M330.1 306.853L325.206 306.436L323.119 301.989L325.928 297.959L330.822 298.376L332.908 302.823L330.1 306.853Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M339.499 302.444L334.605 302.027L332.518 297.58L335.327 293.549L340.221 293.966L342.307 298.414L339.499 302.444Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M340.381 292.099L335.486 291.682L333.4 287.235L336.208 283.205L341.103 283.622L343.189 288.069L340.381 292.099Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M341.261 281.755L336.367 281.338L334.281 276.891L337.089 272.86L341.983 273.277L344.07 277.724L341.261 281.755Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M332.743 275.819L327.849 275.402L325.763 270.955L328.571 266.925L333.465 267.342L335.552 271.789L332.743 275.819Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M324.225 269.884L319.331 269.467L317.244 265.02L320.053 260.989L324.947 261.406L327.033 265.854L324.225 269.884Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M314.826 274.293L309.931 273.876L307.845 269.429L310.653 265.399L315.548 265.816L317.634 270.263L314.826 274.293Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M305.427 278.703L300.532 278.286L298.446 273.839L301.254 269.808L306.149 270.225L308.235 274.672L305.427 278.703Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M304.546 289.047L299.651 288.63L297.565 284.183L300.373 280.153L305.268 280.57L307.354 285.017L304.546 289.047Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M294.265 303.801L289.371 303.384L287.284 298.937L290.093 294.907L294.987 295.323L297.074 299.771L294.265 303.801Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M302.784 309.736L297.889 309.32L295.803 304.872L298.611 300.842L303.506 301.259L305.592 305.706L302.784 309.736Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M311.302 315.672L306.407 315.255L304.321 310.808L307.129 306.777L312.024 307.194L314.11 311.641L311.302 315.672Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M319.82 321.607L314.925 321.19L312.839 316.743L315.647 312.713L320.542 313.13L322.628 317.577L319.82 321.607Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M329.219 317.198L324.324 316.781L322.238 312.334L325.046 308.304L329.941 308.72L332.027 313.168L329.219 317.198Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M338.618 312.789L333.724 312.372L331.638 307.924L334.446 303.894L339.34 304.311L341.427 308.758L338.618 312.789Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M348.017 308.379L343.123 307.962L341.036 303.515L343.845 299.485L348.739 299.902L350.826 304.349L348.017 308.379Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M348.899 298.035L344.004 297.618L341.918 293.171L344.726 289.14L349.621 289.557L351.707 294.004L348.899 298.035Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M349.779 287.69L344.885 287.273L342.799 282.826L345.607 278.795L350.501 279.212L352.588 283.66L349.779 287.69Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M350.66 277.345L345.766 276.928L343.679 272.481L346.488 268.451L351.382 268.868L353.469 273.315L350.66 277.345Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M342.142 271.41L337.248 270.993L335.161 266.546L337.97 262.516L342.864 262.932L344.95 267.38L342.142 271.41Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M333.624 265.475L328.73 265.058L326.643 260.611L329.452 256.58L334.346 256.997L336.432 261.444L333.624 265.475Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M325.106 259.539L320.212 259.122L318.125 254.675L320.934 250.645L325.828 251.062L327.914 255.509L325.106 259.539Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M315.707 263.949L310.813 263.532L308.726 259.085L311.535 255.054L316.429 255.471L318.515 259.918L315.707 263.949Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M306.308 268.358L301.413 267.941L299.327 263.494L302.135 259.463L307.03 259.88L309.116 264.328L306.308 268.358Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M296.908 272.767L292.014 272.35L289.928 267.903L292.736 263.873L297.63 264.29L299.717 268.737L296.908 272.767Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M296.027 283.112L291.132 282.695L289.046 278.248L291.854 274.217L296.749 274.634L298.835 279.082L296.027 283.112Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.146 293.457L290.252 293.04L288.165 288.592L290.974 284.562L295.868 284.979L297.955 289.426L295.146 293.457Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M284.866 308.21L279.971 307.794L277.885 303.346L280.693 299.316L285.588 299.733L287.674 304.18L284.866 308.21Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M293.384 314.146L288.489 313.729L286.403 309.282L289.211 305.251L294.106 305.668L296.192 310.115L293.384 314.146Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M301.902 320.081L297.008 319.664L294.922 315.217L297.73 311.187L302.625 311.604L304.711 316.051L301.902 320.081Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M310.421 326.017L305.526 325.6L303.44 321.152L306.248 317.122L311.143 317.539L313.229 321.986L310.421 326.017Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.939 331.952L314.044 331.535L311.958 327.088L314.766 323.057L319.661 323.474L321.747 327.921L318.939 331.952Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M328.338 327.543L323.443 327.126L321.357 322.678L324.165 318.648L329.06 319.065L331.146 323.512L328.338 327.543Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M337.737 323.133L332.842 322.716L330.756 318.269L333.564 314.239L338.459 314.656L340.545 319.103L337.737 323.133Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M347.136 318.724L342.242 318.307L340.156 313.86L342.964 309.83L347.858 310.246L349.945 314.694L347.136 318.724Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M356.536 314.315L351.641 313.898L349.555 309.45L352.363 305.42L357.258 305.837L359.344 310.284L356.536 314.315Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M357.417 303.97L352.523 303.553L350.436 299.106L353.245 295.075L358.139 295.492L360.226 299.94L357.417 303.97Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M358.298 293.625L353.403 293.208L351.317 288.761L354.125 284.731L359.02 285.148L361.106 289.595L358.298 293.625Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M359.179 283.281L354.285 282.864L352.199 278.417L355.007 274.386L359.901 274.803L361.988 279.25L359.179 283.281Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M360.06 272.936L355.166 272.519L353.079 268.072L355.888 264.042L360.782 264.458L362.869 268.906L360.06 272.936Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M351.542 267.001L346.647 266.584L344.561 262.137L347.369 258.106L352.264 258.523L354.35 262.97L351.542 267.001Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M343.024 261.065L338.129 260.648L336.043 256.201L338.851 252.171L343.746 252.588L345.832 257.035L343.024 261.065Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M334.506 255.13L329.611 254.713L327.525 250.266L330.333 246.236L335.228 246.652L337.314 251.1L334.506 255.13Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M325.987 249.195L321.093 248.778L319.007 244.331L321.815 240.3L326.709 240.717L328.796 245.164L325.987 249.195Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M316.588 253.604L311.693 253.187L309.607 248.74L312.415 244.71L317.31 245.126L319.396 249.574L316.588 253.604Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M307.189 258.013L302.295 257.596L300.208 253.149L303.017 249.119L307.911 249.536L309.997 253.983L307.189 258.013Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M297.789 262.423L292.895 262.006L290.808 257.559L293.617 253.528L298.511 253.945L300.598 258.392L297.789 262.423Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M288.39 266.832L283.496 266.415L281.409 261.968L284.218 257.937L289.112 258.354L291.199 262.802L288.39 266.832Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M287.509 277.177L282.614 276.76L280.528 272.312L283.337 268.282L288.231 268.699L290.317 273.146L287.509 277.177Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M286.628 287.521L281.734 287.104L279.647 282.657L282.456 278.627L287.35 279.044L289.437 283.491L286.628 287.521Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M285.747 297.866L280.852 297.449L278.766 293.002L281.574 288.971L286.469 289.388L288.555 293.835L285.747 297.866Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M275.467 312.62L270.572 312.203L268.486 307.756L271.295 303.725L276.189 304.142L278.275 308.589L275.467 312.62Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M283.985 318.555L279.091 318.138L277.004 313.691L279.813 309.661L284.707 310.078L286.793 314.525L283.985 318.555Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M292.503 324.49L287.608 324.074L285.522 319.626L288.331 315.596L293.225 316.013L295.312 320.46L292.503 324.49Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M301.022 330.426L296.127 330.009L294.041 325.562L296.849 321.531L301.744 321.948L303.83 326.395L301.022 330.426Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M309.54 336.361L304.645 335.944L302.559 331.497L305.367 327.467L310.262 327.883L312.348 332.331L309.54 336.361Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M318.058 342.297L313.163 341.88L311.077 337.432L313.885 333.402L318.78 333.819L320.866 338.266L318.058 342.297Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M327.457 337.887L322.562 337.47L320.476 333.023L323.284 328.993L328.179 329.41L330.265 333.857L327.457 337.887Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M336.856 333.478L331.962 333.061L329.875 328.614L332.684 324.583L337.578 325L339.664 329.447L336.856 333.478Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M346.255 329.069L341.361 328.652L339.274 324.204L342.083 320.174L346.977 320.591L349.063 325.038L346.255 329.069Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M355.655 324.659L350.76 324.242L348.674 319.795L351.482 315.765L356.377 316.182L358.463 320.629L355.655 324.659Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M365.054 320.25L360.159 319.833L358.073 315.386L360.881 311.356L365.776 311.772L367.862 316.22L365.054 320.25Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M365.935 309.905L361.041 309.489L358.954 305.041L361.763 301.011L366.657 301.428L368.744 305.875L365.935 309.905Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M366.816 299.561L361.921 299.144L359.835 294.697L362.644 290.666L367.538 291.083L369.624 295.53L366.816 299.561Z",
    fill: "#EF4444"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M367.697 289.216L362.803 288.799L360.717 284.352L363.525 280.322L368.419 280.738L370.506 285.186L367.697 289.216Z",
    fill: "#22C55E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M368.578 278.871L363.684 278.454L361.597 274.007L364.406 269.977L369.3 270.394L371.387 274.841L368.578 278.871Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M369.459 268.527L364.565 268.11L362.478 263.663L365.287 259.632L370.181 260.049L372.268 264.496L369.459 268.527Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M360.941 262.591L356.046 262.175L353.96 257.727L356.769 253.697L361.663 254.114L363.749 258.561L360.941 262.591Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M352.423 256.656L347.528 256.239L345.442 251.792L348.25 247.762L353.145 248.178L355.231 252.626L352.423 256.656Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M343.904 250.721L339.01 250.304L336.924 245.857L339.732 241.826L344.626 242.243L346.713 246.69L343.904 250.721Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M335.386 244.785L330.492 244.369L328.406 239.921L331.214 235.891L336.108 236.308L338.195 240.755L335.386 244.785Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M317.469 243.259L312.575 242.843L310.489 238.395L313.297 234.365L318.191 234.782L320.278 239.229L317.469 243.259Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M308.07 247.669L303.175 247.252L301.089 242.805L303.897 238.774L308.792 239.191L310.878 243.638L308.07 247.669Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M298.671 252.078L293.776 251.661L291.69 247.214L294.498 243.183L299.393 243.6L301.479 248.048L298.671 252.078Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M289.271 256.487L284.377 256.07L282.29 251.623L285.099 247.593L289.993 248.01L292.08 252.457L289.271 256.487Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M279.872 260.897L274.978 260.48L272.891 256.033L275.7 252.002L280.594 252.419L282.681 256.866L279.872 260.897Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M278.991 271.241L274.096 270.824L272.01 266.377L274.818 262.347L279.713 262.764L281.799 267.211L278.991 271.241Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M278.11 281.586L273.216 281.169L271.129 276.722L273.938 272.691L278.832 273.108L280.918 277.556L278.11 281.586Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M277.229 291.931L272.334 291.514L270.248 287.066L273.056 283.036L277.951 283.453L280.037 287.9L277.229 291.931Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M276.348 302.275L271.453 301.858L269.367 297.411L272.175 293.381L277.07 293.797L279.156 298.245L276.348 302.275Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M266.068 317.029L261.173 316.612L259.087 312.165L261.895 308.135L266.79 308.552L268.876 312.999L266.068 317.029Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M274.586 322.964L269.691 322.548L267.605 318.1L270.413 314.07L275.308 314.487L277.394 318.934L274.586 322.964Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M283.104 328.9L278.209 328.483L276.123 324.036L278.931 320.005L283.826 320.422L285.912 324.869L283.104 328.9Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M291.622 334.835L286.727 334.418L284.641 329.971L287.449 325.941L292.344 326.357L294.43 330.805L291.622 334.835Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M300.14 340.771L295.246 340.354L293.159 335.906L295.968 331.876L300.862 332.293L302.949 336.74L300.14 340.771Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M308.659 346.706L303.764 346.289L301.678 341.842L304.486 337.811L309.381 338.228L311.467 342.675L308.659 346.706Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M317.177 352.641L312.282 352.224L310.196 347.777L313.004 343.747L317.899 344.164L319.985 348.611L317.177 352.641Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M326.576 348.232L321.681 347.815L319.595 343.368L322.403 339.337L327.298 339.754L329.384 344.201L326.576 348.232Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.975 343.823L331.081 343.406L328.994 338.958L331.803 334.928L336.697 335.345L338.783 339.792L335.975 343.823Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M345.374 339.413L340.48 338.996L338.393 334.549L341.202 330.519L346.096 330.936L348.183 335.383L345.374 339.413Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M354.774 335.004L349.879 334.587L347.793 330.14L350.602 326.109L355.496 326.526L357.582 330.973L354.774 335.004Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M364.173 330.595L359.278 330.178L357.192 325.731L360 321.7L364.895 322.117L366.981 326.564L364.173 330.595Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M373.572 326.185L368.678 325.769L366.592 321.321L369.4 317.291L374.294 317.708L376.381 322.155L373.572 326.185Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M374.453 315.841L369.559 315.424L367.472 310.976L370.281 306.946L375.175 307.363L377.262 311.81L374.453 315.841Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M375.334 305.496L370.44 305.079L368.353 300.632L371.162 296.601L376.056 297.018L378.143 301.466L375.334 305.496Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M376.215 295.151L371.321 294.734L369.235 290.287L372.043 286.257L376.938 286.674L379.024 291.121L376.215 295.151Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M377.096 284.807L372.202 284.39L370.116 279.943L372.924 275.912L377.818 276.329L379.905 280.776L377.096 284.807Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M377.978 274.462L373.083 274.045L370.997 269.598L373.805 265.568L378.7 265.984L380.786 270.432L377.978 274.462Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M378.859 264.117L373.964 263.701L371.878 259.253L374.686 255.223L379.581 255.64L381.667 260.087L378.859 264.117Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M370.34 258.182L365.446 257.765L363.36 253.318L366.168 249.288L371.063 249.705L373.149 254.152L370.34 258.182Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M361.822 252.247L356.928 251.83L354.842 247.383L357.65 243.352L362.544 243.769L364.631 248.216L361.822 252.247Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M353.304 246.311L348.409 245.895L346.323 241.447L349.131 237.417L354.026 237.834L356.112 242.281L353.304 246.311Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M344.786 240.376L339.891 239.959L337.805 235.512L340.613 231.482L345.508 231.898L347.594 236.346L344.786 240.376Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M335.19 232.144L332.823 231.942L331.815 229.792L333.172 227.843L335.539 228.045L336.548 230.195L335.19 232.144Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M299.551 241.733L294.657 241.316L292.571 236.869L295.379 232.839L300.273 233.256L302.36 237.703L299.551 241.733Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M290.152 246.143L285.258 245.726L283.171 241.279L285.98 237.248L290.874 237.665L292.96 242.112L290.152 246.143Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M280.753 250.552L275.859 250.135L273.772 245.688L276.581 241.657L281.475 242.074L283.561 246.522L280.753 250.552Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M270.473 265.306L265.578 264.889L263.492 260.442L266.3 256.411L271.195 256.828L273.281 261.276L270.473 265.306Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M269.592 275.651L264.697 275.234L262.611 270.786L265.42 266.756L270.314 267.173L272.4 271.62L269.592 275.651Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M268.711 285.995L263.816 285.578L261.73 281.131L264.538 277.101L269.433 277.518L271.519 281.965L268.711 285.995Z",
    fill: "#EF4444"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M267.83 296.34L262.935 295.923L260.849 291.476L263.657 287.445L268.552 287.862L270.638 292.309L267.83 296.34Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M266.949 306.684L262.054 306.267L259.968 301.82L262.776 297.79L267.671 298.207L269.757 302.654L266.949 306.684Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M256.669 321.438L251.774 321.022L249.688 316.574L252.496 312.544L257.391 312.961L259.477 317.408L256.669 321.438Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M265.187 327.374L260.292 326.957L258.206 322.51L261.014 318.479L265.909 318.896L267.995 323.343L265.187 327.374Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M273.705 333.309L268.81 332.892L266.724 328.445L269.532 324.415L274.427 324.831L276.513 329.279L273.705 333.309Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M282.223 339.244L277.328 338.828L275.242 334.38L278.05 330.35L282.945 330.767L285.031 335.214L282.223 339.244Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M290.741 345.18L285.846 344.763L283.76 340.316L286.568 336.285L291.463 336.702L293.549 341.149L290.741 345.18Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M299.259 351.115L294.365 350.698L292.279 346.251L295.087 342.221L299.981 342.638L302.068 347.085L299.259 351.115Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M307.777 357.05L302.883 356.634L300.797 352.186L303.605 348.156L308.5 348.573L310.586 353.02L307.777 357.05Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M316.296 362.986L311.401 362.569L309.315 358.122L312.123 354.091L317.018 354.508L319.104 358.955L316.296 362.986Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M325.695 358.576L320.8 358.16L318.714 353.712L321.522 349.682L326.417 350.099L328.503 354.546L325.695 358.576Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M335.094 354.167L330.199 353.75L328.113 349.303L330.921 345.273L335.816 345.69L337.902 350.137L335.094 354.167Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M344.493 349.758L339.599 349.341L337.513 344.894L340.321 340.863L345.215 341.28L347.302 345.727L344.493 349.758Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M353.893 345.349L348.998 344.932L346.912 340.484L349.72 336.454L354.615 336.871L356.701 341.318L353.893 345.349Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M363.292 340.939L358.398 340.522L356.311 336.075L359.12 332.045L364.014 332.462L366.101 336.909L363.292 340.939Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M372.691 336.53L367.796 336.113L365.71 331.666L368.519 327.635L373.413 328.052L375.499 332.499L372.691 336.53Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M382.09 332.121L377.196 331.704L375.11 327.257L377.918 323.226L382.813 323.643L384.899 328.09L382.09 332.121Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M382.971 321.776L378.077 321.359L375.991 316.912L378.799 312.882L383.693 313.298L385.78 317.746L382.971 321.776Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M383.852 311.431L378.958 311.015L376.871 306.567L379.68 302.537L384.574 302.954L386.66 307.401L383.852 311.431Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M384.734 301.087L379.839 300.67L377.753 296.223L380.561 292.192L385.456 292.609L387.542 297.056L384.734 301.087Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M385.614 290.742L380.72 290.325L378.634 285.878L381.442 281.848L386.336 282.264L388.423 286.712L385.614 290.742Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M386.496 280.397L381.601 279.98L379.515 275.533L382.323 271.503L387.218 271.92L389.304 276.367L386.496 280.397Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M387.377 270.053L382.482 269.636L380.396 265.189L383.204 261.158L388.099 261.575L390.185 266.022L387.377 270.053Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M388.257 259.708L383.363 259.291L381.277 254.844L384.085 250.814L388.98 251.231L391.066 255.678L388.257 259.708Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M379.739 253.773L374.845 253.356L372.759 248.909L375.567 244.878L380.461 245.295L382.548 249.743L379.739 253.773Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M371.221 247.838L366.327 247.421L364.241 242.974L367.049 238.943L371.943 239.36L374.03 243.807L371.221 247.838Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M362.703 241.902L357.809 241.485L355.722 237.038L358.531 233.008L363.425 233.425L365.512 237.872L362.703 241.902Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M354.185 235.967L349.29 235.55L347.204 231.103L350.012 227.072L354.907 227.489L356.993 231.936L354.185 235.967Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M345.667 230.031L340.772 229.615L338.686 225.167L341.494 221.137L346.389 221.554L348.475 226.001L345.667 230.031Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M280.557 237.911L278.19 237.709L277.181 235.559L278.539 233.61L280.906 233.811L281.915 235.962L280.557 237.911Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M272.237 244.619L267.339 244.202L265.252 239.752L268.062 235.72L272.959 236.137L275.046 240.587L272.237 244.619Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M261.955 259.371L257.06 258.954L254.974 254.507L257.782 250.476L262.677 250.893L264.763 255.34L261.955 259.371Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M261.074 269.715L256.179 269.298L254.093 264.851L256.901 260.821L261.796 261.238L263.882 265.685L261.074 269.715Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M260.193 280.06L255.298 279.643L253.212 275.196L256.02 271.165L260.915 271.582L263.001 276.03L260.193 280.06Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M259.312 290.405L254.417 289.988L252.331 285.54L255.139 281.51L260.034 281.927L262.12 286.374L259.312 290.405Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M258.43 300.749L253.536 300.332L251.45 295.885L254.258 291.855L259.153 292.271L261.239 296.719L258.43 300.749Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M257.55 311.094L252.655 310.677L250.569 306.23L253.377 302.199L258.272 302.616L260.358 307.063L257.55 311.094Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M247.269 325.848L242.375 325.431L240.288 320.983L243.097 316.953L247.991 317.37L250.077 321.817L247.269 325.848Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M255.787 331.783L250.893 331.366L248.806 326.919L251.615 322.889L256.509 323.305L258.596 327.753L255.787 331.783Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M264.305 337.718L259.411 337.302L257.325 332.854L260.133 328.824L265.028 329.241L267.114 333.688L264.305 337.718Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M272.823 343.654L267.929 343.237L265.843 338.789L268.651 334.759L273.545 335.176L275.632 339.623L272.823 343.654Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M281.341 349.589L276.447 349.172L274.361 344.725L277.169 340.695L282.063 341.111L284.15 345.559L281.341 349.589Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M289.86 355.524L284.965 355.108L282.879 350.66L285.687 346.63L290.582 347.047L292.668 351.494L289.86 355.524Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M298.379 361.46L293.484 361.043L291.398 356.596L294.206 352.565L299.101 352.982L301.187 357.429L298.379 361.46Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M306.897 367.395L302.002 366.978L299.916 362.531L302.724 358.501L307.619 358.917L309.705 363.365L306.897 367.395Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M315.415 373.33L310.52 372.914L308.434 368.466L311.242 364.436L316.137 364.853L318.223 369.3L315.415 373.33Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M324.814 368.921L319.919 368.504L317.833 364.057L320.641 360.027L325.536 360.443L327.622 364.891L324.814 368.921Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M334.213 364.512L329.318 364.095L327.232 359.648L330.04 355.617L334.935 356.034L337.021 360.481L334.213 364.512Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M343.612 360.102L338.718 359.686L336.631 355.238L339.44 351.208L344.334 351.625L346.42 356.072L343.612 360.102Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M353.012 355.693L348.117 355.276L346.031 350.829L348.839 346.799L353.734 347.216L355.82 351.663L353.012 355.693Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M362.411 351.284L357.516 350.867L355.43 346.42L358.238 342.389L363.133 342.806L365.219 347.253L362.411 351.284Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M371.81 346.875L366.916 346.458L364.829 342.01L367.638 337.98L372.532 338.397L374.619 342.844L371.81 346.875Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M381.209 342.465L376.315 342.048L374.228 337.601L377.037 333.571L381.931 333.988L384.017 338.435L381.209 342.465Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M390.609 338.056L385.714 337.639L383.628 333.192L386.436 329.162L391.331 329.578L393.417 334.026L390.609 338.056Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M391.49 327.711L386.595 327.295L384.509 322.847L387.317 318.817L392.212 319.234L394.298 323.681L391.49 327.711Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M392.371 317.367L387.477 316.95L385.39 312.503L388.199 308.472L393.093 308.889L395.179 313.336L392.371 317.367Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M393.252 307.022L388.357 306.605L386.271 302.158L389.08 298.127L393.974 298.544L396.06 302.992L393.252 307.022Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M394.133 296.677L389.238 296.26L387.152 291.813L389.96 287.783L394.855 288.2L396.941 292.647L394.133 296.677Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M395.014 286.333L390.12 285.916L388.034 281.469L390.842 277.438L395.736 277.855L397.823 282.302L395.014 286.333Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M395.895 275.988L391.001 275.571L388.914 271.124L391.723 267.094L396.617 267.511L398.703 271.958L395.895 275.988Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M396.777 265.644L391.882 265.227L389.796 260.78L392.604 256.749L397.499 257.166L399.585 261.613L396.777 265.644Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M397.657 255.299L392.763 254.882L390.677 250.435L393.485 246.404L398.379 246.821L400.466 251.269L397.657 255.299Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M389.139 249.364L384.244 248.947L382.158 244.5L384.966 240.469L389.861 240.886L391.947 245.333L389.139 249.364Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M380.621 243.428L375.726 243.011L373.64 238.564L376.448 234.534L381.343 234.951L383.429 239.398L380.621 243.428Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M372.103 237.493L367.208 237.076L365.122 232.629L367.93 228.598L372.825 229.015L374.911 233.462L372.103 237.493Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M363.585 231.557L358.69 231.141L356.604 226.693L359.412 222.663L364.307 223.08L366.393 227.527L363.585 231.557Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M355.066 225.622L350.172 225.205L348.085 220.758L350.894 216.728L355.788 217.145L357.874 221.592L355.066 225.622Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M346.548 219.687L341.653 219.27L339.567 214.823L342.375 210.792L347.27 211.209L349.356 215.656L346.548 219.687Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M252.556 263.78L247.661 263.363L245.575 258.916L248.383 254.885L253.278 255.302L255.364 259.75L252.556 263.78Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M251.674 274.125L246.78 273.708L244.694 269.26L247.502 265.23L252.397 265.647L254.483 270.094L251.674 274.125Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M250.794 284.469L245.899 284.052L243.813 279.605L246.621 275.575L251.516 275.992L253.602 280.439L250.794 284.469Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M249.912 294.814L245.018 294.397L242.932 289.95L245.74 285.919L250.635 286.336L252.721 290.783L249.912 294.814Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M249.031 305.158L244.137 304.741L242.051 300.294L244.859 296.264L249.753 296.681L251.84 301.128L249.031 305.158Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M248.15 315.503L243.256 315.086L241.17 310.639L243.978 306.609L248.872 307.026L250.959 311.473L248.15 315.503Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M237.87 330.257L232.975 329.84L230.889 325.393L233.697 321.362L238.592 321.779L240.678 326.227L237.87 330.257Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M246.388 336.192L241.494 335.776L239.408 331.328L242.216 327.298L247.11 327.715L249.197 332.162L246.388 336.192Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M254.907 342.128L250.012 341.711L247.926 337.263L250.734 333.233L255.629 333.65L257.715 338.097L254.907 342.128Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M263.425 348.063L258.53 347.646L256.444 343.199L259.252 339.169L264.147 339.585L266.233 344.033L263.425 348.063Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M271.943 353.998L267.048 353.581L264.962 349.134L267.77 345.104L272.665 345.521L274.751 349.968L271.943 353.998Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M280.461 359.934L275.566 359.517L273.48 355.07L276.288 351.039L281.183 351.456L283.269 355.903L280.461 359.934Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M288.979 365.869L284.084 365.452L281.998 361.005L284.806 356.975L289.701 357.391L291.787 361.839L288.979 365.869Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M297.497 371.804L292.603 371.388L290.516 366.94L293.325 362.91L298.219 363.327L300.306 367.774L297.497 371.804Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M306.015 377.74L301.121 377.323L299.034 372.876L301.843 368.845L306.737 369.262L308.824 373.709L306.015 377.74Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M314.533 383.675L309.639 383.258L307.553 378.811L310.361 374.781L315.255 375.197L317.342 379.645L314.533 383.675Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M323.933 379.266L319.038 378.849L316.952 374.402L319.76 370.371L324.655 370.788L326.741 375.235L323.933 379.266Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M333.332 374.856L328.437 374.44L326.351 369.992L329.159 365.962L334.054 366.379L336.14 370.826L333.332 374.856Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M342.731 370.447L337.837 370.03L335.75 365.583L338.559 361.553L343.453 361.97L345.539 366.417L342.731 370.447Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M352.131 366.038L347.236 365.621L345.15 361.174L347.958 357.143L352.853 357.56L354.939 362.007L352.131 366.038Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M361.53 361.629L356.635 361.212L354.549 356.765L357.357 352.734L362.252 353.151L364.338 357.598L361.53 361.629Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M370.929 357.219L366.034 356.802L363.948 352.355L366.756 348.325L371.651 348.742L373.737 353.189L370.929 357.219Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M380.328 352.81L375.434 352.393L373.347 347.946L376.156 343.915L381.05 344.332L383.137 348.779L380.328 352.81Z",
    fill: "#3B82F6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M389.728 348.401L384.833 347.984L382.747 343.536L385.555 339.506L390.45 339.923L392.536 344.37L389.728 348.401Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M399.127 343.991L394.232 343.574L392.146 339.127L394.954 335.097L399.849 335.514L401.935 339.961L399.127 343.991Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M400.008 333.647L395.113 333.23L393.027 328.783L395.835 324.752L400.73 325.169L402.816 329.616L400.008 333.647Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M400.889 323.302L395.994 322.885L393.908 318.438L396.716 314.408L401.611 314.825L403.697 319.272L400.889 323.302Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M401.77 312.957L396.875 312.541L394.789 308.093L397.597 304.063L402.492 304.48L404.578 308.927L401.77 312.957Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M402.651 302.613L397.756 302.196L395.67 297.749L398.478 293.718L403.373 294.135L405.459 298.582L402.651 302.613Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M403.532 292.268L398.637 291.851L396.551 287.404L399.359 283.374L404.254 283.79L406.34 288.238L403.532 292.268Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M404.413 281.923L399.518 281.507L397.432 277.059L400.24 273.029L405.135 273.446L407.221 277.893L404.413 281.923Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M405.294 271.579L400.399 271.162L398.313 266.715L401.122 262.684L406.016 263.101L408.102 267.549L405.294 271.579Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M406.175 261.234L401.28 260.817L399.194 256.37L402.002 252.34L406.897 252.757L408.983 257.204L406.175 261.234Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M407.056 250.89L402.161 250.473L400.075 246.026L402.883 241.995L407.778 242.412L409.864 246.859L407.056 250.89Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M398.538 244.954L393.644 244.537L391.557 240.09L394.366 236.06L399.26 236.477L401.346 240.924L398.538 244.954Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M390.02 239.019L385.125 238.602L383.039 234.155L385.847 230.124L390.742 230.541L392.828 234.988L390.02 239.019Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M381.502 233.083L376.607 232.667L374.521 228.219L377.329 224.189L382.224 224.606L384.31 229.053L381.502 233.083Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M372.984 227.148L368.089 226.731L366.003 222.284L368.811 218.254L373.706 218.671L375.792 223.118L372.984 227.148Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M364.465 221.213L359.571 220.796L357.485 216.349L360.293 212.318L365.188 212.735L367.274 217.182L364.465 221.213Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M355.947 215.278L351.052 214.861L348.966 210.413L351.775 206.383L356.669 206.8L358.755 211.247L355.947 215.278Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M347.429 209.342L342.534 208.925L340.448 204.478L343.256 200.448L348.151 200.865L350.237 205.312L347.429 209.342Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M244.037 257.844L239.142 257.428L237.056 252.98L239.864 248.95L244.759 249.367L246.845 253.814L244.037 257.844Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M243.156 268.189L238.261 267.772L236.175 263.325L238.983 259.295L243.878 259.711L245.964 264.159L243.156 268.189Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M242.275 278.534L237.38 278.117L235.294 273.67L238.102 269.639L242.997 270.056L245.083 274.503L242.275 278.534Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M241.394 288.879L236.499 288.462L234.413 284.014L237.221 279.984L242.116 280.401L244.202 284.848L241.394 288.879Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M240.513 299.223L235.618 298.806L233.532 294.359L236.34 290.328L241.235 290.745L243.321 295.193L240.513 299.223Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M239.632 309.568L234.737 309.151L232.651 304.704L235.459 300.673L240.354 301.09L242.44 305.537L239.632 309.568Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M238.751 319.912L233.856 319.495L231.77 315.048L234.578 311.018L239.473 311.435L241.559 315.882L238.751 319.912Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M228.47 334.666L223.576 334.249L221.49 329.802L224.298 325.772L229.192 326.189L231.279 330.636L228.47 334.666Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M236.988 340.602L232.094 340.185L230.008 335.737L232.816 331.707L237.71 332.124L239.797 336.571L236.988 340.602Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M245.507 346.537L240.613 346.12L238.526 341.673L241.335 337.643L246.229 338.059L248.315 342.507L245.507 346.537Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M254.025 352.472L249.131 352.055L247.044 347.608L249.853 343.578L254.747 343.995L256.834 348.442L254.025 352.472Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M262.543 358.408L257.649 357.991L255.562 353.544L258.371 349.513L263.265 349.93L265.352 354.377L262.543 358.408Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M271.062 364.343L266.167 363.926L264.081 359.479L266.889 355.449L271.784 355.865L273.87 360.313L271.062 364.343Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M279.58 370.278L274.685 369.861L272.599 365.414L275.407 361.384L280.302 361.801L282.388 366.248L279.58 370.278Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M288.098 376.214L283.203 375.797L281.117 371.35L283.925 367.319L288.82 367.736L290.906 372.183L288.098 376.214Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M296.616 382.149L291.722 381.732L289.636 377.285L292.444 373.255L297.338 373.671L299.425 378.119L296.616 382.149Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M305.134 388.084L300.24 387.667L298.154 383.22L300.962 379.19L305.856 379.607L307.943 384.054L305.134 388.084Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M313.652 394.02L308.758 393.603L306.672 389.156L309.48 385.125L314.375 385.542L316.461 389.989L313.652 394.02Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M323.051 389.61L318.157 389.193L316.071 384.746L318.879 380.716L323.773 381.133L325.86 385.58L323.051 389.61Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M332.451 385.201L327.556 384.784L325.47 380.337L328.278 376.307L333.173 376.723L335.259 381.171L332.451 385.201Z",
    fill: "#F59E0B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M341.85 380.792L336.955 380.375L334.869 375.928L337.677 371.897L342.572 372.314L344.658 376.761L341.85 380.792Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M351.25 376.382L346.355 375.966L344.269 371.518L347.077 367.488L351.972 367.905L354.058 372.352L351.25 376.382Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M360.649 371.973L355.754 371.556L353.668 367.109L356.476 363.079L361.371 363.496L363.457 367.943L360.649 371.973Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M370.048 367.564L365.153 367.147L363.067 362.7L365.875 358.669L370.77 359.086L372.856 363.533L370.048 367.564Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M379.447 363.155L374.552 362.738L372.466 358.291L375.274 354.26L380.169 354.677L382.255 359.124L379.447 363.155Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M388.847 358.745L383.952 358.328L381.866 353.881L384.674 349.851L389.569 350.268L391.655 354.715L388.847 358.745Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M398.245 354.336L393.351 353.919L391.264 349.472L394.073 345.441L398.967 345.858L401.054 350.305L398.245 354.336Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M407.645 349.927L402.751 349.51L400.664 345.063L403.473 341.032L408.367 341.449L410.454 345.896L407.645 349.927Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M408.526 339.582L403.632 339.165L401.545 334.718L404.354 330.688L409.248 331.104L411.334 335.552L408.526 339.582Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M409.408 329.237L404.513 328.821L402.427 324.373L405.235 320.343L410.13 320.76L412.216 325.207L409.408 329.237Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M410.288 318.893L405.394 318.476L403.307 314.029L406.116 309.998L411.01 310.415L413.097 314.862L410.288 318.893Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M411.17 308.548L406.275 308.131L404.189 303.684L406.997 299.654L411.892 300.07L413.978 304.518L411.17 308.548Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M412.051 298.203L407.156 297.787L405.07 293.339L407.878 289.309L412.773 289.726L414.859 294.173L412.051 298.203Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M412.931 287.859L408.037 287.442L405.95 282.995L408.759 278.964L413.654 279.381L415.74 283.828L412.931 287.859Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M413.813 277.514L408.918 277.097L406.832 272.65L409.64 268.62L414.535 269.037L416.621 273.484L413.813 277.514Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M414.694 267.17L409.799 266.753L407.713 262.306L410.521 258.275L415.416 258.692L417.502 263.139L414.694 267.17Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M415.575 256.825L410.68 256.408L408.594 251.961L411.402 247.93L416.297 248.347L418.383 252.795L415.575 256.825Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M416.456 246.48L411.561 246.063L409.475 241.616L412.283 237.586L417.178 238.003L419.264 242.45L416.456 246.48Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M407.937 240.545L403.043 240.128L400.956 235.681L403.765 231.65L408.659 232.067L410.745 236.514L407.937 240.545Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M399.42 234.61L394.525 234.193L392.439 229.746L395.247 225.715L400.142 226.132L402.228 230.579L399.42 234.61Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M390.901 228.674L386.006 228.257L383.92 223.81L386.728 219.78L391.623 220.197L393.709 224.644L390.901 228.674Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M382.383 222.739L377.488 222.322L375.402 217.875L378.21 213.844L383.105 214.261L385.191 218.708L382.383 222.739Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M373.865 216.804L368.97 216.387L366.884 211.939L369.692 207.909L374.587 208.326L376.673 212.773L373.865 216.804Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M365.346 210.868L360.452 210.451L358.366 206.004L361.174 201.974L366.068 202.391L368.155 206.838L365.346 210.868Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M356.828 204.933L351.933 204.516L349.847 200.069L352.655 196.038L357.55 196.455L359.636 200.902L356.828 204.933Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M347.991 198.317L343.845 197.964L342.077 194.197L344.456 190.783L348.602 191.136L350.369 194.903L347.991 198.317Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M234.561 262.091L229.846 261.689L227.837 257.405L230.542 253.522L235.257 253.924L237.267 258.208L234.561 262.091Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M233.757 272.598L228.862 272.182L226.776 267.734L229.584 263.704L234.479 264.121L236.565 268.568L233.757 272.598Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M232.876 282.943L227.981 282.526L225.895 278.079L228.703 274.049L233.598 274.466L235.684 278.913L232.876 282.943Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M231.995 293.288L227.1 292.871L225.014 288.424L227.822 284.393L232.717 284.81L234.803 289.257L231.995 293.288Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M231.114 303.632L226.219 303.215L224.133 298.768L226.941 294.738L231.836 295.155L233.922 299.602L231.114 303.632Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M230.233 313.977L225.338 313.56L223.252 309.113L226.06 305.083L230.955 305.499L233.041 309.947L230.233 313.977Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M229.351 324.322L224.457 323.905L222.371 319.457L225.179 315.427L230.074 315.844L232.16 320.291L229.351 324.322Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M219.072 339.076L214.177 338.659L212.091 334.211L214.899 330.181L219.794 330.598L221.88 335.045L219.072 339.076Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M227.589 345.011L222.695 344.594L220.609 340.147L223.417 336.116L228.312 336.533L230.398 340.98L227.589 345.011Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M236.108 350.946L231.213 350.529L229.127 346.082L231.935 342.052L236.83 342.469L238.916 346.916L236.108 350.946Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M244.626 356.882L239.732 356.465L237.645 352.017L240.454 347.987L245.348 348.404L247.434 352.851L244.626 356.882Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M253.144 362.817L248.25 362.4L246.163 357.953L248.972 353.922L253.866 354.339L255.953 358.787L253.144 362.817Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M261.662 368.752L256.768 368.335L254.681 363.888L257.49 359.858L262.384 360.275L264.471 364.722L261.662 368.752Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M270.18 374.688L265.286 374.271L263.2 369.824L266.008 365.793L270.902 366.21L272.989 370.657L270.18 374.688Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M278.698 380.623L273.804 380.206L271.718 375.759L274.526 371.728L279.42 372.145L281.507 376.593L278.698 380.623Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M287.217 386.558L282.322 386.141L280.236 381.694L283.044 377.664L287.939 378.081L290.025 382.528L287.217 386.558Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 392.494L290.84 392.077L288.754 387.63L291.562 383.599L296.457 384.016L298.543 388.463L295.735 392.494Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M304.253 398.429L299.358 398.012L297.272 393.565L300.081 389.534L304.975 389.951L307.061 394.399L304.253 398.429Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M312.772 404.364L307.877 403.947L305.791 399.5L308.599 395.47L313.494 395.887L315.58 400.334L312.772 404.364Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M322.171 399.955L317.276 399.538L315.19 395.091L317.998 391.06L322.893 391.477L324.979 395.925L322.171 399.955Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M331.57 395.546L326.675 395.129L324.589 390.682L327.397 386.651L332.292 387.068L334.378 391.515L331.57 395.546Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M340.969 391.136L336.074 390.719L333.988 386.272L336.796 382.242L341.691 382.659L343.777 387.106L340.969 391.136Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M350.369 386.727L345.474 386.31L343.388 381.863L346.196 377.833L351.091 378.249L353.177 382.697L350.369 386.727Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M359.768 382.318L354.873 381.901L352.787 377.454L355.595 373.423L360.49 373.84L362.576 378.287L359.768 382.318Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M369.167 377.909L364.273 377.492L362.186 373.045L364.995 369.014L369.889 369.431L371.976 373.878L369.167 377.909Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M378.566 373.499L373.671 373.082L371.585 368.635L374.394 364.605L379.288 365.022L381.374 369.469L378.566 373.499Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M387.966 369.09L383.071 368.673L380.985 364.226L383.793 360.195L388.688 360.612L390.774 365.06L387.966 369.09Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M397.364 364.681L392.47 364.264L390.384 359.817L393.192 355.786L398.086 356.203L400.173 360.65L397.364 364.681Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M406.764 360.271L401.869 359.854L399.783 355.407L402.591 351.377L407.486 351.794L409.572 356.241L406.764 360.271Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M416.163 355.862L411.269 355.445L409.182 350.998L411.991 346.968L416.885 347.384L418.972 351.832L416.163 355.862Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M417.044 345.517L412.15 345.101L410.063 340.653L412.872 336.623L417.766 337.04L419.852 341.487L417.044 345.517Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M417.926 335.173L413.031 334.756L410.945 330.309L413.753 326.278L418.648 326.695L420.734 331.142L417.926 335.173Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M418.806 324.828L413.912 324.411L411.826 319.964L414.634 315.934L419.528 316.351L421.615 320.798L418.806 324.828Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M419.688 314.483L414.793 314.067L412.707 309.619L415.515 305.589L420.41 306.006L422.496 310.453L419.688 314.483Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M420.569 304.139L415.674 303.722L413.588 299.275L416.396 295.244L421.291 295.661L423.377 300.108L420.569 304.139Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M421.45 293.794L416.555 293.377L414.469 288.93L417.277 284.9L422.172 285.317L424.258 289.764L421.45 293.794Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M422.331 283.449L417.436 283.033L415.35 278.585L418.158 274.555L423.053 274.972L425.139 279.419L422.331 283.449Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M423.212 273.105L418.317 272.688L416.231 268.241L419.039 264.21L423.934 264.627L426.02 269.075L423.212 273.105Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M424.093 262.76L419.198 262.343L417.112 257.896L419.921 253.866L424.815 254.283L426.901 258.73L424.093 262.76Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M424.974 252.416L420.079 251.999L417.993 247.552L420.801 243.521L425.696 243.938L427.782 248.385L424.974 252.416Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M425.855 242.071L420.96 241.654L418.874 237.207L421.682 233.176L426.577 233.593L428.663 238.04L425.855 242.071Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M417.337 236.136L412.442 235.719L410.356 231.272L413.164 227.241L418.059 227.658L420.145 232.105L417.337 236.136Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M408.818 230.2L403.923 229.783L401.837 225.336L404.645 221.306L409.54 221.723L411.626 226.17L408.818 230.2Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M400.3 224.265L395.406 223.848L393.32 219.401L396.128 215.371L401.022 215.787L403.109 220.235L400.3 224.265Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M391.782 218.33L386.887 217.913L384.801 213.465L387.609 209.435L392.504 209.852L394.59 214.299L391.782 218.33Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M383.264 212.394L378.369 211.977L376.283 207.53L379.091 203.5L383.986 203.917L386.072 208.364L383.264 212.394Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M374.746 206.459L369.851 206.042L367.765 201.595L370.573 197.565L375.468 197.981L377.554 202.429L374.746 206.459Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M366.228 200.524L361.333 200.107L359.247 195.66L362.055 191.629L366.95 192.046L369.036 196.493L366.228 200.524Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M357.709 194.588L352.815 194.171L350.728 189.724L353.537 185.694L358.431 186.111L360.518 190.558L357.709 194.588Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M348.113 186.356L345.747 186.154L344.738 184.004L346.096 182.055L348.463 182.257L349.471 184.407L348.113 186.356Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M225.16 266.494L220.452 266.093L218.445 261.815L221.146 257.938L225.854 258.339L227.861 262.617L225.16 266.494Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M224.358 277.008L219.463 276.591L217.377 272.144L220.186 268.113L225.08 268.53L227.166 272.978L224.358 277.008Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M223.477 287.353L218.583 286.936L216.496 282.488L219.305 278.458L224.199 278.875L226.286 283.322L223.477 287.353Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M222.596 297.697L217.701 297.28L215.615 292.833L218.424 288.802L223.318 289.219L225.404 293.667L222.596 297.697Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M221.715 308.042L216.82 307.625L214.734 303.178L217.542 299.147L222.437 299.564L224.523 304.011L221.715 308.042Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M220.834 318.386L215.939 317.97L213.853 313.522L216.661 309.492L221.556 309.909L223.642 314.356L220.834 318.386Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M219.953 328.731L215.058 328.314L212.972 323.867L215.78 319.836L220.675 320.253L222.761 324.701L219.953 328.731Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M209.672 343.485L204.778 343.068L202.691 338.621L205.5 334.59L210.394 335.007L212.48 339.454L209.672 343.485Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M218.191 349.42L213.296 349.003L211.21 344.556L214.018 340.526L218.913 340.943L220.999 345.39L218.191 349.42Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M226.708 355.356L221.814 354.939L219.728 350.491L222.536 346.461L227.43 346.878L229.517 351.325L226.708 355.356Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M235.226 361.291L230.332 360.874L228.246 356.427L231.054 352.396L235.949 352.813L238.035 357.261L235.226 361.291Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M243.745 367.226L238.85 366.809L236.764 362.362L239.572 358.332L244.467 358.749L246.553 363.196L243.745 367.226Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M252.263 373.162L247.369 372.745L245.282 368.298L248.091 364.267L252.985 364.684L255.071 369.131L252.263 373.162Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M260.782 379.097L255.887 378.68L253.801 374.233L256.609 370.202L261.504 370.619L263.59 375.067L260.782 379.097Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M269.299 385.032L264.405 384.615L262.319 380.168L265.127 376.138L270.022 376.555L272.108 381.002L269.299 385.032Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M277.818 390.968L272.923 390.551L270.837 386.104L273.645 382.073L278.54 382.49L280.626 386.937L277.818 390.968Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M286.336 396.903L281.441 396.486L279.355 392.039L282.163 388.008L287.058 388.425L289.144 392.873L286.336 396.903Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M294.854 402.838L289.96 402.421L287.873 397.974L290.682 393.944L295.576 394.361L297.663 398.808L294.854 402.838Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M303.372 408.774L298.478 408.357L296.391 403.91L299.2 399.879L304.094 400.296L306.18 404.743L303.372 408.774Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M311.89 414.709L306.996 414.292L304.909 409.845L307.718 405.815L312.612 406.231L314.699 410.679L311.89 414.709Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M321.29 410.3L316.395 409.883L314.309 405.436L317.117 401.405L322.012 401.822L324.098 406.269L321.29 410.3Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M330.689 405.89L325.794 405.473L323.708 401.026L326.516 396.996L331.411 397.413L333.497 401.86L330.689 405.89Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M340.088 401.481L335.194 401.064L333.107 396.617L335.916 392.586L340.81 393.003L342.896 397.451L340.088 401.481Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M349.487 397.072L344.593 396.655L342.507 392.208L345.315 388.177L350.209 388.594L352.296 393.041L349.487 397.072Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M358.887 392.662L353.992 392.246L351.906 387.798L354.714 383.768L359.609 384.185L361.695 388.632L358.887 392.662Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M368.286 388.253L363.391 387.836L361.305 383.389L364.113 379.359L369.008 379.776L371.094 384.223L368.286 388.253Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M377.685 383.844L372.791 383.427L370.704 378.98L373.513 374.949L378.407 375.366L380.493 379.814L377.685 383.844Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M387.085 379.435L382.19 379.018L380.104 374.571L382.912 370.54L387.807 370.957L389.893 375.404L387.085 379.435Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M396.484 375.025L391.589 374.608L389.503 370.161L392.311 366.131L397.206 366.548L399.292 370.995L396.484 375.025Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M405.883 370.616L400.989 370.199L398.902 365.752L401.711 361.722L406.605 362.138L408.691 366.586L405.883 370.616Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M415.283 366.207L410.388 365.79L408.302 361.343L411.11 357.312L416.005 357.729L418.091 362.176L415.283 366.207Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M424.682 361.797L419.787 361.381L417.701 356.933L420.509 352.903L425.404 353.32L427.49 357.767L424.682 361.797Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M425.563 351.453L420.668 351.036L418.582 346.589L421.39 342.558L426.285 342.975L428.371 347.422L425.563 351.453Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M426.444 341.108L421.55 340.691L419.463 336.244L422.272 332.214L427.166 332.631L429.252 337.078L426.444 341.108Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M427.325 330.764L422.43 330.347L420.344 325.899L423.152 321.869L428.047 322.286L430.133 326.733L427.325 330.764Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M428.206 320.419L423.312 320.002L421.225 315.555L424.034 311.524L428.928 311.941L431.015 316.388L428.206 320.419Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M429.087 310.074L424.193 309.657L422.106 305.21L424.915 301.18L429.809 301.597L431.895 306.044L429.087 310.074Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M429.969 299.729L425.074 299.313L422.988 294.865L425.796 290.835L430.691 291.252L432.777 295.699L429.969 299.729Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M430.849 289.385L425.955 288.968L423.868 284.521L426.677 280.49L431.571 280.907L433.658 285.355L430.849 289.385Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M431.73 279.04L426.836 278.623L424.749 274.176L427.558 270.146L432.452 270.563L434.539 275.01L431.73 279.04Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M432.612 268.696L427.717 268.279L425.631 263.832L428.439 259.801L433.334 260.218L435.42 264.665L432.612 268.696Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M433.492 258.351L428.598 257.934L426.512 253.487L429.32 249.456L434.215 249.873L436.301 254.321L433.492 258.351Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M434.374 248.006L429.479 247.59L427.393 243.142L430.201 239.112L435.096 239.529L437.182 243.976L434.374 248.006Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M435.255 237.662L430.36 237.245L428.274 232.798L431.082 228.767L435.977 229.184L438.063 233.631L435.255 237.662Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M426.736 231.726L421.842 231.309L419.755 226.862L422.564 222.832L427.458 223.249L429.544 227.696L426.736 231.726Z",
    fill: "#3B82F6"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M418.218 225.791L413.324 225.374L411.237 220.927L414.046 216.897L418.94 217.313L421.026 221.761L418.218 225.791Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M409.699 219.856L404.805 219.439L402.719 214.992L405.527 210.961L410.421 211.378L412.508 215.825L409.699 219.856Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M401.182 213.92L396.287 213.504L394.201 209.056L397.009 205.026L401.904 205.443L403.99 209.89L401.182 213.92Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M392.663 207.985L387.769 207.568L385.682 203.121L388.491 199.091L393.385 199.507L395.471 203.955L392.663 207.985Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M384.145 202.05L379.25 201.633L377.164 197.186L379.972 193.155L384.867 193.572L386.953 198.019L384.145 202.05Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M375.627 196.114L370.732 195.698L368.646 191.25L371.454 187.22L376.349 187.637L378.435 192.084L375.627 196.114Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M367.109 190.179L362.214 189.762L360.128 185.315L362.936 181.285L367.831 181.701L369.917 186.149L367.109 190.179Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M358.59 184.244L353.696 183.827L351.609 179.379L354.418 175.349L359.312 175.766L361.398 180.213L358.59 184.244Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M211.434 322.796L206.54 322.379L204.453 317.931L207.262 313.901L212.156 314.318L214.243 318.765L211.434 322.796Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M210.553 333.14L205.659 332.723L203.572 328.276L206.381 324.246L211.275 324.663L213.362 329.11L210.553 333.14Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M200.273 347.894L195.378 347.477L193.292 343.03L196.1 339L200.995 339.417L203.081 343.864L200.273 347.894Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M208.791 353.83L203.897 353.413L201.81 348.965L204.619 344.935L209.513 345.352L211.6 349.799L208.791 353.83Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M217.31 359.765L212.415 359.348L210.329 354.901L213.137 350.87L218.032 351.287L220.118 355.735L217.31 359.765Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M225.827 365.7L220.933 365.283L218.846 360.836L221.655 356.806L226.549 357.223L228.636 361.67L225.827 365.7Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M234.345 371.635L229.451 371.219L227.365 366.771L230.173 362.741L235.067 363.158L237.154 367.605L234.345 371.635Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M242.864 377.571L237.969 377.154L235.883 372.707L238.691 368.676L243.586 369.093L245.672 373.541L242.864 377.571Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M251.382 383.506L246.488 383.089L244.401 378.642L247.21 374.612L252.104 375.029L254.19 379.476L251.382 383.506Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M259.9 389.442L255.006 389.025L252.919 384.577L255.728 380.547L260.622 380.964L262.708 385.411L259.9 389.442Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M268.418 395.377L263.524 394.96L261.437 390.513L264.246 386.482L269.14 386.899L271.226 391.347L268.418 395.377Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M276.936 401.312L272.042 400.895L269.955 396.448L272.764 392.418L277.658 392.835L279.745 397.282L276.936 401.312Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M285.454 407.248L280.56 406.831L278.473 402.383L281.282 398.353L286.176 398.77L288.263 403.217L285.454 407.248Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M293.973 413.183L289.079 412.766L286.992 408.319L289.801 404.289L294.695 404.705L296.782 409.153L293.973 413.183Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M302.491 419.118L297.597 418.701L295.511 414.254L298.319 410.224L303.213 410.641L305.3 415.088L302.491 419.118Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M311.009 425.054L306.115 424.637L304.029 420.19L306.837 416.159L311.731 416.576L313.818 421.023L311.009 425.054Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M320.408 420.644L315.514 420.227L313.428 415.78L316.236 411.75L321.13 412.167L323.217 416.614L320.408 420.644Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M329.808 416.235L324.913 415.818L322.827 411.371L325.635 407.341L330.53 407.757L332.616 412.205L329.808 416.235Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M339.207 411.826L334.312 411.409L332.226 406.962L335.034 402.931L339.929 403.348L342.015 407.795L339.207 411.826Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M348.607 407.416L343.712 407L341.626 402.552L344.434 398.522L349.329 398.939L351.415 403.386L348.607 407.416Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M358.006 403.007L353.111 402.59L351.025 398.143L353.833 394.113L358.728 394.529L360.814 398.977L358.006 403.007Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M367.405 398.598L362.51 398.181L360.424 393.734L363.232 389.703L368.127 390.12L370.213 394.567L367.405 398.598Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M376.804 394.188L371.909 393.772L369.823 389.324L372.631 385.294L377.526 385.711L379.612 390.158L376.804 394.188Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M386.204 389.779L381.309 389.362L379.223 384.915L382.031 380.885L386.926 381.302L389.012 385.749L386.204 389.779Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M395.602 385.37L390.708 384.953L388.621 380.506L391.43 376.475L396.324 376.892L398.41 381.34L395.602 385.37Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M405.002 380.961L400.108 380.544L398.021 376.097L400.83 372.066L405.724 372.483L407.811 376.93L405.002 380.961Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M414.401 376.551L409.507 376.134L407.42 371.687L410.229 367.657L415.123 368.074L417.209 372.521L414.401 376.551Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M423.801 372.142L418.906 371.725L416.82 367.278L419.629 363.248L424.523 363.665L426.609 368.112L423.801 372.142Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M433.199 367.733L428.305 367.316L426.219 362.869L429.027 358.838L433.921 359.255L436.008 363.702L433.199 367.733Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M434.08 357.388L429.186 356.971L427.099 352.524L429.908 348.494L434.802 348.91L436.889 353.358L434.08 357.388Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M434.962 347.043L430.067 346.627L427.981 342.179L430.789 338.149L435.684 338.566L437.77 343.013L434.962 347.043Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M435.842 336.699L430.948 336.282L428.862 331.835L431.67 327.804L436.564 328.221L438.651 332.668L435.842 336.699Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M436.724 326.354L431.829 325.937L429.743 321.49L432.551 317.46L437.446 317.877L439.532 322.324L436.724 326.354Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M437.605 316.01L432.71 315.593L430.624 311.145L433.432 307.115L438.327 307.532L440.413 311.979L437.605 316.01Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M438.486 305.665L433.592 305.248L431.505 300.801L434.314 296.77L439.208 297.187L441.294 301.634L438.486 305.665Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M439.367 295.32L434.472 294.903L432.386 290.456L435.194 286.426L440.089 286.843L442.175 291.29L439.367 295.32Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M440.248 284.975L435.353 284.559L433.267 280.111L436.075 276.081L440.97 276.498L443.056 280.945L440.248 284.975Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M441.129 274.631L436.235 274.214L434.148 269.767L436.957 265.736L441.851 266.153L443.937 270.601L441.129 274.631Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M442.01 264.286L437.115 263.869L435.029 259.422L437.838 255.392L442.732 255.809L444.818 260.256L442.01 264.286Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M442.891 253.942L437.997 253.525L435.91 249.078L438.719 245.047L443.613 245.464L445.7 249.911L442.891 253.942Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M443.772 243.597L438.878 243.18L436.791 238.733L439.6 234.703L444.494 235.119L446.581 239.567L443.772 243.597Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M444.653 233.252L439.759 232.835L437.672 228.388L440.481 224.358L445.375 224.775L447.461 229.222L444.653 233.252Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M436.136 227.317L431.241 226.9L429.155 222.453L431.963 218.423L436.858 218.839L438.944 223.287L436.136 227.317Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M427.617 221.382L422.722 220.965L420.636 216.518L423.444 212.487L428.339 212.904L430.425 217.351L427.617 221.382Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M419.099 215.446L414.204 215.03L412.118 210.582L414.926 206.552L419.821 206.969L421.907 211.416L419.099 215.446Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M410.58 209.511L405.686 209.094L403.599 204.647L406.408 200.617L411.302 201.033L413.389 205.481L410.58 209.511Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M402.063 203.576L397.168 203.159L395.082 198.712L397.89 194.681L402.785 195.098L404.871 199.545L402.063 203.576Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M393.544 197.64L388.649 197.224L386.563 192.776L389.372 188.746L394.266 189.163L396.352 193.61L393.544 197.64Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M385.026 191.705L380.131 191.288L378.045 186.841L380.853 182.811L385.748 183.227L387.834 187.675L385.026 191.705Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M376.508 185.77L371.613 185.353L369.527 180.906L372.335 176.875L377.23 177.292L379.316 181.739L376.508 185.77Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M367.46 178.705L363.808 178.394L362.252 175.076L364.347 172.07L367.998 172.381L369.555 175.698L367.46 178.705Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M202.035 327.205L197.141 326.788L195.054 322.341L197.863 318.31L202.757 318.727L204.843 323.175L202.035 327.205Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M201.154 337.55L196.26 337.133L194.173 332.685L196.982 328.655L201.876 329.072L203.962 333.519L201.154 337.55Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M190.873 352.303L185.979 351.887L183.892 347.439L186.701 343.409L191.595 343.826L193.682 348.273L190.873 352.303Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M199.392 358.239L194.498 357.822L192.411 353.375L195.22 349.344L200.114 349.761L202.2 354.209L199.392 358.239Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M207.91 364.174L203.016 363.757L200.929 359.31L203.738 355.28L208.632 355.697L210.718 360.144L207.91 364.174Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M216.429 370.109L211.534 369.693L209.448 365.245L212.256 361.215L217.151 361.632L219.237 366.079L216.429 370.109Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M224.946 376.045L220.052 375.628L217.965 371.181L220.774 367.15L225.668 367.567L227.754 372.015L224.946 376.045Z",
    fill: "#3B82F6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M233.464 381.98L228.57 381.563L226.483 377.116L229.292 373.086L234.186 373.503L236.273 377.95L233.464 381.98Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M241.983 387.916L237.088 387.499L235.002 383.051L237.81 379.021L242.705 379.438L244.791 383.885L241.983 387.916Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M250.501 393.851L245.607 393.434L243.52 388.987L246.329 384.956L251.223 385.373L253.31 389.821L250.501 393.851Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M259.019 399.786L254.125 399.369L252.038 394.922L254.847 390.892L259.741 391.309L261.828 395.756L259.019 399.786Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M267.537 405.722L262.643 405.305L260.556 400.857L263.365 396.827L268.259 397.244L270.346 401.691L267.537 405.722Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M276.055 411.657L271.161 411.24L269.075 406.793L271.883 402.763L276.777 403.179L278.864 407.627L276.055 411.657Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M284.573 417.592L279.679 417.175L277.593 412.728L280.401 408.698L285.295 409.114L287.382 413.562L284.573 417.592Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M293.092 423.528L288.197 423.111L286.111 418.664L288.919 414.633L293.814 415.05L295.9 419.497L293.092 423.528Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M301.61 429.463L296.715 429.046L294.629 424.599L297.437 420.568L302.332 420.985L304.418 425.433L301.61 429.463Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M310.128 435.398L305.233 434.981L303.147 430.534L305.956 426.504L310.85 426.921L312.936 431.368L310.128 435.398Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M319.527 430.989L314.633 430.572L312.547 426.125L315.355 422.094L320.25 422.511L322.336 426.959L319.527 430.989Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M328.926 426.58L324.032 426.163L321.946 421.716L324.754 417.685L329.648 418.102L331.735 422.549L328.926 426.58Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M338.326 422.17L333.431 421.753L331.345 417.306L334.153 413.276L339.048 413.693L341.134 418.14L338.326 422.17Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M347.725 417.761L342.831 417.344L340.744 412.897L343.553 408.867L348.447 409.284L350.534 413.731L347.725 417.761Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M357.125 413.352L352.23 412.935L350.144 408.488L352.952 404.457L357.847 404.874L359.933 409.321L357.125 413.352Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M366.524 408.942L361.629 408.526L359.543 404.078L362.351 400.048L367.246 400.465L369.332 404.912L366.524 408.942Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M404.121 391.305L399.226 390.888L397.14 386.441L399.948 382.411L404.843 382.828L406.929 387.275L404.121 391.305Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M413.52 386.896L408.626 386.479L406.539 382.032L409.348 378.001L414.242 378.418L416.329 382.866L413.52 386.896Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M422.92 382.487L418.025 382.07L415.939 377.623L418.747 373.592L423.642 374.009L425.728 378.456L422.92 382.487Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M432.319 378.077L427.424 377.66L425.338 373.213L428.146 369.183L433.041 369.6L435.127 374.047L432.319 378.077Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M441.717 373.668L436.823 373.251L434.737 368.804L437.545 364.774L442.439 365.19L444.526 369.638L441.717 373.668Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M442.599 363.323L437.704 362.907L435.618 358.459L438.426 354.429L443.321 354.846L445.407 359.293L442.599 363.323Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M443.48 352.979L438.585 352.562L436.499 348.115L439.307 344.084L444.202 344.501L446.288 348.948L443.48 352.979Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M444.36 342.634L439.466 342.217L437.38 337.77L440.188 333.74L445.083 334.156L447.169 338.604L444.36 342.634Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M445.242 332.29L440.347 331.873L438.261 327.425L441.069 323.395L445.964 323.812L448.05 328.259L445.242 332.29Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M446.123 321.945L441.228 321.528L439.142 317.081L441.95 313.05L446.845 313.467L448.931 317.914L446.123 321.945Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M447.004 311.6L442.11 311.183L440.023 306.736L442.832 302.706L447.726 303.122L449.812 307.57L447.004 311.6Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M447.885 301.255L442.99 300.839L440.904 296.391L443.713 292.361L448.607 292.778L450.693 297.225L447.885 301.255Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M448.766 290.911L443.871 290.494L441.785 286.047L444.593 282.016L449.488 282.433L451.574 286.881L448.766 290.911Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M449.647 280.566L444.753 280.149L442.666 275.702L445.475 271.672L450.369 272.089L452.456 276.536L449.647 280.566Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M450.528 270.222L445.634 269.805L443.547 265.358L446.356 261.327L451.25 261.744L453.336 266.191L450.528 270.222Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M451.409 259.877L446.515 259.46L444.429 255.013L447.237 250.982L452.131 251.399L454.218 255.847L451.409 259.877Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M452.29 249.532L447.396 249.116L445.309 244.668L448.118 240.638L453.012 241.055L455.099 245.502L452.29 249.532Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M453.171 239.188L448.277 238.771L446.19 234.324L448.999 230.293L453.893 230.71L455.979 235.157L453.171 239.188Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M454.052 228.843L449.158 228.426L447.072 223.979L449.88 219.949L454.774 220.365L456.861 224.813L454.052 228.843Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M445.534 222.908L440.64 222.491L438.554 218.044L441.362 214.013L446.256 214.43L448.343 218.877L445.534 222.908Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M437.017 216.972L432.122 216.556L430.036 212.108L432.844 208.078L437.739 208.495L439.825 212.942L437.017 216.972Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M428.498 211.037L423.604 210.62L421.517 206.173L424.326 202.143L429.22 202.559L431.307 207.007L428.498 211.037Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M419.98 205.102L415.086 204.685L412.999 200.238L415.808 196.207L420.702 196.624L422.789 201.071L419.98 205.102Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M411.461 199.166L406.566 198.75L404.48 194.302L407.289 190.272L412.183 190.689L414.269 195.136L411.461 199.166Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M402.944 193.231L398.049 192.814L395.963 188.367L398.771 184.337L403.666 184.754L405.752 189.201L402.944 193.231Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M394.425 187.296L389.53 186.879L387.444 182.432L390.252 178.401L395.147 178.818L397.233 183.265L394.425 187.296Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M385.907 181.36L381.012 180.944L378.926 176.496L381.734 172.466L386.629 172.883L388.715 177.33L385.907 181.36Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M376.705 173.968L373.415 173.687L372.012 170.697L373.9 167.988L377.191 168.268L378.593 171.258L376.705 173.968Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M193.518 321.272L188.621 320.855L186.534 316.405L189.343 312.372L194.241 312.79L196.328 317.239L193.518 321.272Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M192.635 331.614L187.741 331.197L185.655 326.75L188.463 322.72L193.357 323.137L195.444 327.584L192.635 331.614Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M191.754 341.959L186.86 341.542L184.774 337.095L187.582 333.064L192.476 333.481L194.563 337.928L191.754 341.959Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M181.474 356.713L176.58 356.296L174.493 351.849L177.302 347.818L182.196 348.235L184.282 352.683L181.474 356.713Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M189.992 362.648L185.098 362.231L183.012 357.784L185.82 353.754L190.714 354.17L192.801 358.618L189.992 362.648Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M198.511 368.583L193.616 368.167L191.53 363.719L194.339 359.689L199.233 360.106L201.319 364.553L198.511 368.583Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M207.029 374.519L202.135 374.102L200.048 369.655L202.857 365.624L207.751 366.041L209.837 370.489L207.029 374.519Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M215.548 380.454L210.653 380.037L208.567 375.59L211.375 371.56L216.27 371.977L218.356 376.424L215.548 380.454Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M224.065 386.39L219.17 385.973L217.084 381.525L219.893 377.495L224.787 377.912L226.873 382.359L224.065 386.39Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M232.583 392.325L227.689 391.908L225.602 387.461L228.411 383.43L233.305 383.847L235.391 388.294L232.583 392.325Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M241.102 398.26L236.207 397.843L234.121 393.396L236.929 389.366L241.824 389.783L243.91 394.23L241.102 398.26Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M249.62 404.196L244.726 403.779L242.639 399.331L245.448 395.301L250.342 395.718L252.428 400.165L249.62 404.196Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M258.138 410.131L253.243 409.714L251.157 405.267L253.965 401.236L258.86 401.653L260.946 406.1L258.138 410.131Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M266.656 416.066L261.762 415.649L259.676 411.202L262.484 407.172L267.378 407.588L269.465 412.036L266.656 416.066Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M275.174 422.002L270.28 421.585L268.194 417.137L271.002 413.107L275.897 413.524L277.983 417.971L275.174 422.002Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M283.693 427.937L278.798 427.52L276.712 423.073L279.52 419.042L284.415 419.459L286.501 423.907L283.693 427.937Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M292.211 433.872L287.316 433.455L285.23 429.008L288.039 424.978L292.933 425.395L295.019 429.842L292.211 433.872Z",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M300.729 439.807L295.835 439.391L293.748 434.943L296.557 430.913L301.451 431.33L303.537 435.777L300.729 439.807Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M309.247 445.743L304.353 445.326L302.266 440.879L305.075 436.848L309.969 437.265L312.055 441.712L309.247 445.743Z",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M318.646 441.334L313.752 440.917L311.665 436.469L314.474 432.439L319.368 432.856L321.454 437.303L318.646 441.334Z",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M328.046 436.924L323.151 436.507L321.065 432.06L323.873 428.03L328.768 428.447L330.854 432.894L328.046 436.924Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M337.444 432.515L332.55 432.098L330.464 427.651L333.272 423.62L338.167 424.037L340.253 428.485L337.444 432.515Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M346.844 428.106L341.95 427.689L339.864 423.242L342.672 419.211L347.566 419.628L349.653 424.075L346.844 428.106Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M412.639 397.241L407.744 396.824L405.658 392.377L408.466 388.346L413.361 388.763L415.447 393.21L412.639 397.241Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M422.039 392.831L417.144 392.414L415.058 387.967L417.866 383.937L422.761 384.354L424.847 388.801L422.039 392.831Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M431.437 388.422L426.543 388.005L424.456 383.558L427.265 379.527L432.159 379.944L434.246 384.392L431.437 388.422Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M440.837 384.013L435.942 383.596L433.856 379.149L436.664 375.118L441.559 375.535L443.645 379.982L440.837 384.013Z",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M450.236 379.603L445.342 379.187L443.255 374.739L446.064 370.709L450.958 371.126L453.044 375.573L450.236 379.603Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M451.117 369.259L446.223 368.842L444.137 364.395L446.945 360.364L451.839 360.781L453.926 365.229L451.117 369.259Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M451.998 358.914L447.104 358.497L445.017 354.05L447.826 350.02L452.72 350.437L454.807 354.884L451.998 358.914Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M452.879 348.569L447.985 348.153L445.898 343.705L448.707 339.675L453.601 340.092L455.687 344.539L452.879 348.569Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M453.76 338.225L448.866 337.808L446.78 333.361L449.588 329.33L454.482 329.747L456.569 334.194L453.76 338.225Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M454.641 327.88L449.747 327.463L447.66 323.016L450.469 318.986L455.363 319.403L457.45 323.85L454.641 327.88Z",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M455.523 317.536L450.628 317.119L448.542 312.671L451.35 308.641L456.245 309.058L458.331 313.505L455.523 317.536Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M456.403 307.191L451.509 306.774L449.423 302.327L452.231 298.297L457.126 298.713L459.212 303.161L456.403 307.191Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M457.285 296.846L452.39 296.429L450.304 291.982L453.112 287.952L458.007 288.369L460.093 292.816L457.285 296.846Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M458.166 286.502L453.271 286.085L451.185 281.638L453.993 277.607L458.888 278.024L460.974 282.471L458.166 286.502Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M459.047 276.157L454.152 275.74L452.066 271.293L454.874 267.263L459.769 267.679L461.855 272.127L459.047 276.157Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M459.928 265.812L455.033 265.395L452.947 260.948L455.755 256.918L460.65 257.335L462.736 261.782L459.928 265.812Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M460.809 255.468L455.914 255.051L453.828 250.604L456.636 246.573L461.531 246.99L463.617 251.437L460.809 255.468Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M461.69 245.123L456.796 244.706L454.709 240.259L457.518 236.229L462.412 236.645L464.498 241.093L461.69 245.123Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M462.571 234.778L457.676 234.362L455.59 229.914L458.399 225.884L463.293 226.301L465.379 230.748L462.571 234.778Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 224.434L458.557 224.017L456.471 219.57L459.279 215.539L464.174 215.956L466.26 220.403L463.452 224.434Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M454.933 218.498L450.039 218.082L447.952 213.634L450.761 209.604L455.655 210.021L457.742 214.468L454.933 218.498Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M446.415 212.563L441.521 212.146L439.434 207.699L442.243 203.669L447.137 204.086L449.224 208.533L446.415 212.563Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M437.898 206.628L433.003 206.211L430.917 201.764L433.725 197.733L438.62 198.15L440.706 202.597L437.898 206.628Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M429.379 200.693L424.485 200.276L422.398 195.828L425.207 191.798L430.101 192.215L432.187 196.662L429.379 200.693Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M420.861 194.757L415.967 194.34L413.88 189.893L416.689 185.863L421.583 186.28L423.669 190.727L420.861 194.757Z",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M412.342 188.822L407.448 188.405L405.362 183.958L408.17 179.927L413.065 180.344L415.151 184.791L412.342 188.822Z",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M403.825 182.886L398.93 182.47L396.844 178.022L399.652 173.992L404.547 174.409L406.633 178.856L403.825 182.886Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M395.306 176.951L390.412 176.534L388.325 172.087L391.134 168.056L396.028 168.473L398.115 172.921L395.306 176.951Z",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M386.788 171.016L381.894 170.599L379.807 166.152L382.616 162.121L387.51 162.538L389.597 166.985L386.788 171.016Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M184.117 325.679L179.223 325.262L177.137 320.815L179.945 316.784L184.84 317.201L186.926 321.648L184.117 325.679Z",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M183.236 336.024L178.342 335.607L176.255 331.159L179.064 327.129L183.958 327.546L186.045 331.993L183.236 336.024Z",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M182.355 346.368L177.461 345.951L175.374 341.504L178.183 337.474L183.077 337.891L185.164 342.338L182.355 346.368Z",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M172.075 361.122L167.18 360.705L165.094 356.258L167.902 352.228L172.797 352.644L174.883 357.092L172.075 361.122Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M180.593 367.057L175.699 366.641L173.612 362.193L176.421 358.163L181.315 358.58L183.402 363.027L180.593 367.057Z",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M189.111 372.993L184.217 372.576L182.13 368.129L184.939 364.098L189.833 364.515L191.92 368.962L189.111 372.993Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M197.63 378.928L192.735 378.511L190.649 374.064L193.457 370.034L198.352 370.451L200.438 374.898L197.63 378.928Z",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M206.148 384.864L201.253 384.447L199.167 379.999L201.975 375.969L206.87 376.386L208.956 380.833L206.148 384.864Z",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M214.666 390.799L209.772 390.382L207.686 385.935L210.494 381.904L215.388 382.321L217.475 386.769L214.666 390.799Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M223.184 396.734L218.289 396.317L216.203 391.87L219.011 387.84L223.906 388.256L225.992 392.704L223.184 396.734Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M231.702 402.669L226.807 402.253L224.721 397.805L227.529 393.775L232.424 394.192L234.51 398.639L231.702 402.669Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M240.221 408.605L235.326 408.188L233.24 403.741L236.048 399.71L240.943 400.127L243.029 404.574L240.221 408.605Z",
    fill: "#F59E0B"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M248.739 414.54L243.844 414.123L241.758 409.676L244.567 405.646L249.461 406.062L251.547 410.51L248.739 414.54Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M257.257 420.476L252.363 420.059L250.276 415.611L253.085 411.581L257.979 411.998L260.065 416.445L257.257 420.476Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M265.775 426.411L260.881 425.994L258.794 421.547L261.603 417.516L266.497 417.933L268.583 422.381L265.775 426.411Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M274.293 432.346L269.399 431.929L267.312 427.482L270.121 423.452L275.015 423.869L277.102 428.316L274.293 432.346Z",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M282.811 438.281L277.917 437.865L275.83 433.417L278.639 429.387L283.533 429.804L285.62 434.251L282.811 438.281Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M291.33 444.217L286.435 443.8L284.349 439.353L287.157 435.322L292.052 435.739L294.138 440.186L291.33 444.217Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M299.848 450.152L294.953 449.735L292.867 445.288L295.675 441.258L300.57 441.675L302.656 446.122L299.848 450.152Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M308.366 456.088L303.471 455.671L301.385 451.223L304.193 447.193L309.088 447.61L311.174 452.057L308.366 456.088Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M317.765 451.678L312.871 451.261L310.784 446.814L313.593 442.784L318.487 443.201L320.574 447.648L317.765 451.678Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M327.164 447.269L322.27 446.852L320.183 442.405L322.992 438.375L327.886 438.791L329.972 443.239L327.164 447.269Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M335.486 440.563L333.119 440.361L332.111 438.211L333.468 436.262L335.835 436.464L336.844 438.614L335.486 440.563Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M460.516 364.849L455.622 364.433L453.535 359.985L456.344 355.955L461.238 356.372L463.325 360.819L460.516 364.849Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M461.398 354.505L456.503 354.088L454.417 349.641L457.225 345.61L462.12 346.027L464.206 350.474L461.398 354.505Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M462.278 344.16L457.384 343.743L455.298 339.296L458.106 335.266L463.001 335.683L465.087 340.13L462.278 344.16Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M463.159 333.816L458.265 333.399L456.179 328.951L458.987 324.921L463.881 325.338L465.968 329.785L463.159 333.816Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M464.041 323.471L459.146 323.054L457.06 318.607L459.868 314.576L464.763 314.993L466.849 319.44L464.041 323.471Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M464.922 313.126L460.027 312.709L457.941 308.262L460.749 304.232L465.644 304.648L467.73 309.096L464.922 313.126Z",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M465.803 302.781L460.908 302.365L458.822 297.917L461.63 293.887L466.525 294.304L468.611 298.751L465.803 302.781Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M466.684 292.437L461.789 292.02L459.703 287.573L462.511 283.542L467.406 283.959L469.492 288.407L466.684 292.437Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M467.565 282.092L462.67 281.675L460.584 277.228L463.392 273.198L468.287 273.615L470.373 278.062L467.565 282.092Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M468.446 271.748L463.551 271.331L461.465 266.884L464.273 262.853L469.168 263.27L471.254 267.717L468.446 271.748Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M469.327 261.403L464.432 260.986L462.346 256.539L465.154 252.508L470.049 252.925L472.135 257.373L469.327 261.403Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M470.208 251.058L465.314 250.642L463.227 246.194L466.036 242.164L470.93 242.581L473.016 247.028L470.208 251.058Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M471.089 240.714L466.194 240.297L464.108 235.85L466.916 231.819L471.811 232.236L473.897 236.683L471.089 240.714Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M471.97 230.369L467.076 229.952L464.99 225.505L467.798 221.475L472.692 221.892L474.779 226.339L471.97 230.369Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M472.851 220.025L467.957 219.608L465.87 215.16L468.679 211.13L473.573 211.547L475.659 215.994L472.851 220.025Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M464.333 214.089L459.439 213.672L457.352 209.225L460.161 205.195L465.055 205.612L467.142 210.059L464.333 214.089Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M455.815 208.154L450.92 207.737L448.834 203.29L451.642 199.259L456.537 199.676L458.623 204.123L455.815 208.154Z",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M447.297 202.219L442.402 201.802L440.316 197.354L443.124 193.324L448.019 193.741L450.105 198.188L447.297 202.219Z",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M438.779 196.283L433.885 195.866L431.798 191.419L434.607 187.389L439.501 187.806L441.587 192.253L438.779 196.283Z",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M430.26 190.348L425.365 189.931L423.279 185.484L426.088 181.453L430.982 181.87L433.068 186.317L430.26 190.348Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M421.742 184.413L416.847 183.996L414.761 179.548L417.569 175.518L422.464 175.935L424.55 180.382L421.742 184.413Z",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M413.223 178.477L408.329 178.06L406.242 173.613L409.051 169.582L413.945 169.999L416.032 174.447L413.223 178.477Z",
    fill: "#EF4444"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M404.706 172.542L399.811 172.125L397.725 167.678L400.533 163.647L405.428 164.064L407.514 168.511L404.706 172.542Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M396.187 166.606L391.293 166.189L389.206 161.742L392.015 157.712L396.909 158.129L398.995 162.576L396.187 166.606Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M387.669 160.671L382.774 160.254L380.688 155.807L383.497 151.777L388.391 152.193L390.477 156.641L387.669 160.671Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M378.073 152.439L375.706 152.237L374.697 150.087L376.055 148.138L378.422 148.34L379.431 150.49L378.073 152.439Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M174.718 330.088L169.824 329.671L167.737 325.224L170.546 321.194L175.44 321.611L177.526 326.058L174.718 330.088Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M173.837 340.433L168.942 340.016L166.856 335.569L169.665 331.538L174.559 331.955L176.645 336.402L173.837 340.433Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M172.956 350.777L168.061 350.361L165.975 345.913L168.783 341.883L173.678 342.3L175.764 346.747L172.956 350.777Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M162.676 365.531L157.781 365.114L155.695 360.667L158.503 356.637L163.398 357.054L165.484 361.501L162.676 365.531Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M171.194 371.467L166.299 371.05L164.213 366.603L167.021 362.572L171.916 362.989L174.002 367.436L171.194 371.467Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M179.712 377.402L174.818 376.985L172.731 372.538L175.54 368.508L180.434 368.925L182.52 373.372L179.712 377.402Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M188.23 383.337L183.336 382.921L181.249 378.473L184.058 374.443L188.952 374.86L191.039 379.307L188.23 383.337Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M196.749 389.273L191.854 388.856L189.768 384.409L192.576 380.378L197.471 380.795L199.557 385.242L196.749 389.273Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M205.267 395.208L200.372 394.791L198.286 390.344L201.094 386.314L205.989 386.73L208.075 391.178L205.267 395.208Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M213.786 401.143L208.891 400.727L206.805 396.279L209.613 392.249L214.508 392.666L216.594 397.113L213.786 401.143Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M222.303 407.079L217.409 406.662L215.322 402.215L218.131 398.184L223.025 398.601L225.111 403.048L222.303 407.079Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M230.821 413.014L225.927 412.597L223.84 408.15L226.649 404.12L231.543 404.536L233.629 408.984L230.821 413.014Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M239.34 418.95L234.445 418.533L232.359 414.085L235.167 410.055L240.062 410.472L242.148 414.919L239.34 418.95Z",
    fill: "#EF4444"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M247.858 424.885L242.963 424.468L240.877 420.021L243.685 415.99L248.58 416.407L250.666 420.855L247.858 424.885Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M256.376 430.82L251.481 430.403L249.395 425.956L252.203 421.926L257.098 422.343L259.184 426.79L256.376 430.82Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M264.894 436.755L260 436.339L257.913 431.891L260.722 427.861L265.616 428.278L267.703 432.725L264.894 436.755Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M273.412 442.691L268.518 442.274L266.431 437.827L269.24 433.796L274.134 434.213L276.221 438.66L273.412 442.691Z",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M281.93 448.626L277.036 448.209L274.95 443.762L277.758 439.732L282.652 440.149L284.739 444.596L281.93 448.626Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M290.449 454.562L285.554 454.145L283.468 449.697L286.276 445.667L291.171 446.084L293.257 450.531L290.449 454.562Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M298.967 460.497L294.072 460.08L291.986 455.633L294.794 451.602L299.689 452.019L301.775 456.466L298.967 460.497Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M307.485 466.432L302.59 466.015L300.504 461.568L303.312 457.538L308.207 457.955L310.293 462.402L307.485 466.432Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 462.023L311.99 461.606L309.904 457.159L312.712 453.128L317.606 453.545L319.693 457.992L316.884 462.023Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M326.283 457.614L321.389 457.197L319.303 452.749L322.111 448.719L327.005 449.136L329.092 453.583L326.283 457.614Z",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M469.916 360.44L465.021 360.023L462.935 355.576L465.743 351.546L470.638 351.963L472.724 356.41L469.916 360.44Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M470.797 350.095L465.902 349.679L463.816 345.231L466.624 341.201L471.519 341.618L473.605 346.065L470.797 350.095Z",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M471.677 339.751L466.783 339.334L464.697 334.887L467.505 330.856L472.399 331.273L474.486 335.72L471.677 339.751Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M472.559 329.406L467.664 328.989L465.578 324.542L468.386 320.512L473.281 320.929L475.367 325.376L472.559 329.406Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M473.44 319.062L468.545 318.645L466.459 314.197L469.267 310.167L474.162 310.584L476.248 315.031L473.44 319.062Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M474.321 308.717L469.426 308.3L467.34 303.853L470.148 299.823L475.043 300.239L477.129 304.687L474.321 308.717Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M475.202 298.372L470.307 297.955L468.221 293.508L471.029 289.478L475.924 289.895L478.01 294.342L475.202 298.372Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M476.083 288.028L471.189 287.611L469.102 283.164L471.911 279.133L476.805 279.55L478.891 283.997L476.083 288.028Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M476.964 277.683L472.069 277.266L469.983 272.819L472.791 268.789L477.686 269.205L479.772 273.653L476.964 277.683Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M477.845 267.338L472.95 266.922L470.864 262.474L473.672 258.444L478.567 258.861L480.653 263.308L477.845 267.338Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M478.726 256.994L473.832 256.577L471.745 252.13L474.554 248.099L479.448 248.516L481.534 252.963L478.726 256.994Z",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M479.607 246.649L474.712 246.232L472.626 241.785L475.435 237.755L480.329 238.171L482.415 242.619L479.607 246.649Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M480.488 236.304L475.594 235.888L473.508 231.44L476.316 227.41L481.21 227.827L483.297 232.274L480.488 236.304Z",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M481.369 225.96L476.475 225.543L474.388 221.096L477.197 217.065L482.091 217.482L484.178 221.929L481.369 225.96Z",
    fill: "white"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M482.25 215.615L477.356 215.198L475.269 210.751L478.078 206.721L482.972 207.138L485.058 211.585L482.25 215.615Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M473.732 209.68L468.837 209.263L466.751 204.816L469.56 200.785L474.454 201.202L476.54 205.649L473.732 209.68Z",
    fill: "white"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M465.214 203.745L460.32 203.328L458.233 198.88L461.042 194.85L465.936 195.267L468.022 199.714L465.214 203.745Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M456.695 197.809L451.801 197.392L449.715 192.945L452.523 188.915L457.417 189.332L459.504 193.779L456.695 197.809Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M448.177 191.874L443.283 191.457L441.197 187.01L444.005 182.979L448.899 183.396L450.986 187.843L448.177 191.874Z",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M439.66 185.939L434.765 185.522L432.679 181.074L435.487 177.044L440.382 177.461L442.468 181.908L439.66 185.939Z",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M431.141 180.003L426.247 179.586L424.16 175.139L426.969 171.109L431.863 171.525L433.95 175.973L431.141 180.003Z",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M422.623 174.068L417.729 173.651L415.642 169.204L418.451 165.173L423.345 165.59L425.432 170.037L422.623 174.068Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M414.105 168.132L409.21 167.715L407.124 163.268L409.932 159.238L414.827 159.655L416.913 164.102L414.105 168.132Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M405.587 162.197L400.692 161.78L398.606 157.333L401.415 153.303L406.309 153.719L408.395 158.167L405.587 162.197Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M397.069 156.262L392.174 155.845L390.088 151.398L392.896 147.367L397.791 147.784L399.877 152.231L397.069 156.262Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M388.55 150.326L383.656 149.91L381.57 145.462L384.378 141.432L389.272 141.849L391.359 146.296L388.55 150.326Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M380.032 144.391L375.137 143.974L373.051 139.527L375.859 135.497L380.754 135.913L382.84 140.361L380.032 144.391Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M371.428 138.273L366.734 137.873L364.734 133.609L367.427 129.744L372.12 130.144L374.12 134.408L371.428 138.273Z",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M165.319 334.498L160.424 334.081L158.338 329.633L161.146 325.603L166.041 326.02L168.127 330.467L165.319 334.498Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M164.438 344.842L159.543 344.425L157.457 339.978L160.265 335.948L165.16 336.365L167.246 340.812L164.438 344.842Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M163.557 355.187L158.662 354.77L156.576 350.323L159.384 346.292L164.279 346.709L166.365 351.156L163.557 355.187Z",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M153.276 369.941L148.381 369.524L146.295 365.077L149.103 361.046L153.998 361.463L156.084 365.91L153.276 369.941Z",
    fill: "white"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 375.876L156.9 375.459L154.814 371.012L157.622 366.982L162.517 367.398L164.603 371.846L161.795 375.876Z",
    fill: "white"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M170.313 381.811L165.418 381.395L163.332 376.947L166.14 372.917L171.035 373.334L173.121 377.781L170.313 381.811Z",
    fill: "white"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M178.831 387.747L173.937 387.33L171.85 382.883L174.659 378.852L179.553 379.269L181.639 383.716L178.831 387.747Z",
    fill: "white"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M187.349 393.682L182.455 393.265L180.368 388.818L183.177 384.788L188.071 385.204L190.157 389.652L187.349 393.682Z",
    fill: "white"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M195.868 399.617L190.973 399.201L188.887 394.753L191.695 390.723L196.59 391.14L198.676 395.587L195.868 399.617Z",
    fill: "white"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M204.386 405.553L199.491 405.136L197.405 400.689L200.213 396.658L205.108 397.075L207.194 401.522L204.386 405.553Z",
    fill: "white"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M212.904 411.488L208.01 411.071L205.924 406.624L208.732 402.594L213.626 403.01L215.713 407.458L212.904 411.488Z",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M221.422 417.423L216.527 417.007L214.441 412.559L217.249 408.529L222.144 408.946L224.23 413.393L221.422 417.423Z",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M229.94 423.359L225.045 422.942L222.959 418.495L225.768 414.464L230.662 414.881L232.748 419.328L229.94 423.359Z",
    fill: "white"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M238.459 429.294L233.564 428.877L231.478 424.43L234.286 420.4L239.181 420.817L241.267 425.264L238.459 429.294Z",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M246.977 435.229L242.082 434.813L239.996 430.365L242.804 426.335L247.699 426.752L249.785 431.199L246.977 435.229Z",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M255.495 441.165L250.6 440.748L248.514 436.301L251.322 432.27L256.217 432.687L258.303 437.134L255.495 441.165Z",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M264.013 447.1L259.118 446.683L257.032 442.236L259.84 438.206L264.735 438.622L266.821 443.07L264.013 447.1Z",
    fill: "white"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M272.531 453.036L267.636 452.619L265.55 448.171L268.359 444.141L273.253 444.558L275.339 449.005L272.531 453.036Z",
    fill: "white"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M281.049 458.971L276.154 458.554L274.068 454.107L276.876 450.076L281.771 450.493L283.857 454.94L281.049 458.971Z",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M289.568 464.906L284.673 464.489L282.587 460.042L285.395 456.012L290.29 456.429L292.376 460.876L289.568 464.906Z",
    fill: "white"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M298.086 470.842L293.191 470.425L291.105 465.977L293.914 461.947L298.808 462.364L300.894 466.811L298.086 470.842Z",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M306.604 476.777L301.71 476.36L299.623 471.913L302.432 467.882L307.326 468.299L309.412 472.747L306.604 476.777Z",
    fill: "white"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M316.003 472.368L311.108 471.951L309.022 467.503L311.831 463.473L316.725 463.89L318.811 468.337L316.003 472.368Z",
    fill: "white"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M325.402 467.958L320.508 467.541L318.422 463.094L321.23 459.064L326.125 459.481L328.211 463.928L325.402 467.958Z",
    fill: "white"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M479.314 356.031L474.42 355.614L472.333 351.167L475.142 347.136L480.036 347.553L482.122 352L479.314 356.031Z",
    fill: "white"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M480.195 345.686L475.3 345.269L473.214 340.822L476.022 336.792L480.917 337.209L483.003 341.656L480.195 345.686Z",
    fill: "white"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M481.076 335.342L476.182 334.925L474.096 330.477L476.904 326.447L481.798 326.864L483.885 331.311L481.076 335.342Z",
    fill: "white"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M481.957 324.997L477.063 324.58L474.976 320.133L477.785 316.102L482.679 316.519L484.765 320.966L481.957 324.997Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M482.838 314.652L477.944 314.235L475.858 309.788L478.666 305.758L483.56 306.174L485.647 310.622L482.838 314.652Z",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M483.719 304.307L478.825 303.891L476.739 299.443L479.547 295.413L484.441 295.83L486.528 300.277L483.719 304.307Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M484.6 293.963L479.706 293.546L477.619 289.099L480.428 285.068L485.322 285.485L487.408 289.933L484.6 293.963Z",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M485.481 283.618L480.587 283.201L478.501 278.754L481.309 274.724L486.203 275.141L488.29 279.588L485.481 283.618Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M486.362 273.274L481.468 272.857L479.382 268.41L482.19 264.379L487.084 264.796L489.171 269.243L486.362 273.274Z",
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M487.244 262.929L482.349 262.512L480.263 258.065L483.071 254.034L487.966 254.451L490.052 258.899L487.244 262.929Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M488.125 252.584L483.23 252.168L481.144 247.72L483.952 243.69L488.847 244.107L490.933 248.554L488.125 252.584Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M489.005 242.24L484.111 241.823L482.025 237.376L484.833 233.345L489.727 233.762L491.814 238.209L489.005 242.24Z",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M489.887 231.895L484.992 231.478L482.906 227.031L485.714 223.001L490.609 223.417L492.695 227.865L489.887 231.895Z",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M490.768 221.551L485.873 221.134L483.787 216.686L486.595 212.656L491.49 213.073L493.576 217.52L490.768 221.551Z",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M491.649 211.206L486.754 210.789L484.668 206.342L487.477 202.311L492.371 202.728L494.457 207.175L491.649 211.206Z",
    fill: "white"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M483.131 205.271L478.237 204.854L476.151 200.406L478.959 196.376L483.854 196.793L485.94 201.24L483.131 205.271Z",
    fill: "white"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M474.613 199.335L469.719 198.918L467.633 194.471L470.441 190.441L475.335 190.858L477.422 195.305L474.613 199.335Z",
    fill: "white"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M466.095 193.4L461.201 192.983L459.115 188.536L461.923 184.505L466.817 184.922L468.904 189.369L466.095 193.4Z",
    fill: "white"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M457.576 187.465L452.682 187.048L450.596 182.6L453.404 178.57L458.298 178.987L460.385 183.434L457.576 187.465Z",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M449.058 181.529L444.164 181.112L442.077 176.665L444.886 172.635L449.78 173.051L451.867 177.499L449.058 181.529Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M440.541 175.594L435.646 175.177L433.56 170.73L436.368 166.699L441.263 167.116L443.349 171.563L440.541 175.594Z",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M432.022 169.658L427.128 169.242L425.041 164.794L427.85 160.764L432.744 161.181L434.831 165.628L432.022 169.658Z",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M423.504 163.723L418.61 163.306L416.523 158.859L419.332 154.829L424.226 155.245L426.312 159.693L423.504 163.723Z",
    fill: "white"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M414.986 157.788L410.091 157.371L408.005 152.924L410.813 148.893L415.708 149.31L417.794 153.757L414.986 157.788Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M406.468 151.852L401.573 151.436L399.487 146.988L402.295 142.958L407.19 143.375L409.276 147.822L406.468 151.852Z",
    fill: "white"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M397.949 145.917L393.055 145.5L390.969 141.053L393.777 137.023L398.671 137.44L400.758 141.887L397.949 145.917Z",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M156.8 328.562L151.906 328.145L149.82 323.698L152.628 319.668L157.522 320.085L159.609 324.532L156.8 328.562Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M155.919 338.907L151.025 338.49L148.939 334.043L151.747 330.012L156.641 330.429L158.728 334.876L155.919 338.907Z",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M155.038 349.251L150.144 348.835L148.057 344.387L150.866 340.357L155.76 340.774L157.846 345.221L155.038 349.251Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M154.157 359.596L149.263 359.179L147.176 354.732L149.985 350.702L154.879 351.118L156.965 355.566L154.157 359.596Z",
    fill: "white"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M143.878 374.35L138.983 373.933L136.897 369.486L139.705 365.456L144.6 365.872L146.686 370.32L143.878 374.35Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M152.395 380.285L147.501 379.868L145.414 375.421L148.223 371.391L153.117 371.808L155.203 376.255L152.395 380.285Z",
    fill: "white"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M160.914 386.221L156.019 385.804L153.933 381.357L156.741 377.326L161.636 377.743L163.722 382.19L160.914 386.221Z",
    fill: "white"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M169.432 392.156L164.537 391.739L162.451 387.292L165.259 383.262L170.154 383.678L172.24 388.126L169.432 392.156Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M177.95 398.091L173.055 397.674L170.969 393.227L173.777 389.197L178.672 389.614L180.758 394.061L177.95 398.091Z",
    fill: "white"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M186.468 404.027L181.573 403.61L179.487 399.163L182.296 395.132L187.19 395.549L189.276 399.996L186.468 404.027Z",
    fill: "white"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M194.987 409.962L190.092 409.545L188.006 405.098L190.814 401.067L195.709 401.484L197.795 405.932L194.987 409.962Z",
    fill: "white"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M203.505 415.897L198.61 415.481L196.524 411.033L199.332 407.003L204.227 407.42L206.313 411.867L203.505 415.897Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M212.023 421.833L207.129 421.416L205.043 416.969L207.851 412.938L212.745 413.355L214.832 417.802L212.023 421.833Z",
    fill: "white"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M220.541 427.768L215.646 427.351L213.56 422.904L216.368 418.874L221.263 419.291L223.349 423.738L220.541 427.768Z",
    fill: "white"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M229.059 433.703L224.164 433.286L222.078 428.839L224.886 424.809L229.781 425.226L231.867 429.673L229.059 433.703Z",
    fill: "white"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M237.578 439.639L232.683 439.222L230.597 434.775L233.405 430.744L238.3 431.161L240.386 435.608L237.578 439.639Z",
    fill: "white"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M246.096 445.574L241.201 445.157L239.115 440.71L241.923 436.68L246.818 437.097L248.904 441.544L246.096 445.574Z",
    fill: "white"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M254.614 451.51L249.719 451.093L247.633 446.645L250.442 442.615L255.336 443.032L257.422 447.479L254.614 451.51Z",
    fill: "white"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M263.132 457.445L258.238 457.028L256.151 452.581L258.96 448.55L263.854 448.967L265.94 453.414L263.132 457.445Z",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 463.38L266.756 462.963L264.669 458.516L267.478 454.486L272.372 454.902L274.458 459.35L271.65 463.38Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M280.168 469.315L275.274 468.899L273.187 464.451L275.996 460.421L280.89 460.838L282.977 465.285L280.168 469.315Z",
    fill: "white"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M288.687 475.251L283.792 474.834L281.706 470.387L284.514 466.356L289.409 466.773L291.495 471.22L288.687 475.251Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M297.205 481.186L292.31 480.769L290.224 476.322L293.032 472.292L297.927 472.709L300.013 477.156L297.205 481.186Z",
    fill: "white"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M305.723 487.121L300.828 486.704L298.742 482.257L301.55 478.227L306.445 478.644L308.531 483.091L305.723 487.121Z",
    fill: "white"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M315.122 482.712L310.228 482.295L308.141 477.848L310.95 473.818L315.844 474.235L317.93 478.682L315.122 482.712Z",
    fill: "white"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M324.521 478.303L319.627 477.886L317.54 473.439L320.349 469.408L325.243 469.825L327.329 474.273L324.521 478.303Z",
    fill: "white"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M333.921 473.894L329.026 473.477L326.94 469.029L329.748 464.999L334.643 465.416L336.729 469.863L333.921 473.894Z",
    fill: "white"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M489.112 340.248L485.35 339.928L483.746 336.509L485.905 333.411L489.668 333.731L491.271 337.15L489.112 340.248Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M490.476 330.932L485.581 330.515L483.495 326.068L486.303 322.038L491.198 322.455L493.284 326.902L490.476 330.932Z",
    fill: "white"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M491.357 320.588L486.463 320.171L484.376 315.724L487.185 311.693L492.079 312.11L494.165 316.557L491.357 320.588Z",
    fill: "white"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M492.238 310.243L487.343 309.826L485.257 305.379L488.066 301.349L492.96 301.765L495.046 306.213L492.238 310.243Z",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M493.119 299.898L488.225 299.481L486.138 295.034L488.947 291.004L493.841 291.421L495.928 295.868L493.119 299.898Z",
    fill: "white"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M494 289.554L489.106 289.137L487.019 284.69L489.828 280.659L494.722 281.076L496.809 285.523L494 289.554Z",
    fill: "white"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M494.881 279.209L489.987 278.792L487.9 274.345L490.709 270.315L495.603 270.731L497.689 275.179L494.881 279.209Z",
    fill: "white"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M495.762 268.864L490.868 268.448L488.782 264L491.59 259.97L496.484 260.387L498.571 264.834L495.762 268.864Z",
    fill: "white"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M496.643 258.52L491.749 258.103L489.662 253.656L492.471 249.625L497.365 250.042L499.452 254.489L496.643 258.52Z",
    fill: "white"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M497.525 248.175L492.63 247.758L490.544 243.311L493.352 239.281L498.247 239.697L500.333 244.145L497.525 248.175Z",
    fill: "white"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M498.405 237.83L493.511 237.414L491.425 232.966L494.233 228.936L499.127 229.353L501.214 233.8L498.405 237.83Z",
    fill: "white"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M499.286 227.486L494.392 227.069L492.305 222.622L495.114 218.591L500.008 219.008L502.095 223.455L499.286 227.486Z",
    fill: "white"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M500.168 217.141L495.273 216.724L493.187 212.277L495.995 208.247L500.89 208.664L502.976 213.111L500.168 217.141Z",
    fill: "white"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M501.048 206.797L496.154 206.38L494.068 201.932L496.876 197.902L501.771 198.319L503.857 202.766L501.048 206.797Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M492.53 200.861L487.635 200.444L485.549 195.997L488.357 191.967L493.252 192.384L495.338 196.831L492.53 200.861Z",
    fill: "white"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M484.012 194.926L479.118 194.509L477.032 190.062L479.84 186.031L484.734 186.448L486.821 190.895L484.012 194.926Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M475.494 188.991L470.6 188.574L468.513 184.126L471.322 180.096L476.216 180.513L478.303 184.96L475.494 188.991Z",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M466.976 183.055L462.082 182.638L459.995 178.191L462.804 174.161L467.698 174.578L469.785 179.025L466.976 183.055Z",
    fill: "white"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M458.458 177.12L453.563 176.703L451.477 172.256L454.285 168.225L459.18 168.642L461.266 173.089L458.458 177.12Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M449.94 171.184L445.045 170.768L442.959 166.32L445.767 162.29L450.662 162.707L452.748 167.154L449.94 171.184Z",
    fill: "white"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M441.422 165.249L436.528 164.832L434.441 160.385L437.25 156.355L442.144 156.772L444.23 161.219L441.422 165.249Z",
    fill: "white"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M432.904 159.314L428.009 158.897L425.923 154.45L428.731 150.419L433.626 150.836L435.712 155.284L432.904 159.314Z",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M424.386 153.378L419.491 152.962L417.405 148.514L420.213 144.484L425.108 144.901L427.194 149.348L424.386 153.378Z",
    fill: "white"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M415.866 147.443L410.972 147.026L408.886 142.579L411.694 138.549L416.588 138.966L418.675 143.413L415.866 147.443Z",
    fill: "white"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M148.143 322.329L143.576 321.94L141.629 317.791L144.25 314.03L148.816 314.419L150.763 318.568L148.143 322.329Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M147.402 332.972L142.507 332.555L140.421 328.107L143.229 324.077L148.124 324.494L150.21 328.941L147.402 332.972Z",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M146.521 343.316L141.626 342.899L139.54 338.452L142.348 334.422L147.243 334.838L149.329 339.286L146.521 343.316Z",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M145.64 353.661L140.745 353.244L138.659 348.797L141.467 344.766L146.362 345.183L148.448 349.63L145.64 353.661Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M144.758 364.005L139.864 363.588L137.778 359.141L140.586 355.111L145.48 355.528L147.567 359.975L144.758 364.005Z",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M134.478 378.759L129.583 378.342L127.497 373.895L130.305 369.865L135.2 370.282L137.286 374.729L134.478 378.759Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M142.996 384.695L138.102 384.278L136.016 379.831L138.824 375.8L143.719 376.217L145.805 380.664L142.996 384.695Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M151.514 390.63L146.619 390.213L144.533 385.766L147.342 381.735L152.236 382.152L154.322 386.6L151.514 390.63Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M160.033 396.565L155.138 396.148L153.052 391.701L155.86 387.671L160.755 388.088L162.841 392.535L160.033 396.565Z",
    fill: "#EF4444"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M168.551 402.501L163.656 402.084L161.57 397.637L164.378 393.606L169.273 394.023L171.359 398.47L168.551 402.501Z",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M177.069 408.436L172.174 408.019L170.088 403.572L172.896 399.541L177.791 399.958L179.877 404.406L177.069 408.436Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M185.587 414.371L180.692 413.955L178.606 409.507L181.414 405.477L186.309 405.894L188.395 410.341L185.587 414.371Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M194.106 420.307L189.211 419.89L187.125 415.443L189.933 411.412L194.828 411.829L196.914 416.276L194.106 420.307Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M202.624 426.242L197.729 425.825L195.643 421.378L198.451 417.348L203.346 417.764L205.432 422.212L202.624 426.242Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M211.142 432.177L206.248 431.76L204.161 427.313L206.97 423.283L211.864 423.7L213.951 428.147L211.142 432.177Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M219.66 438.113L214.765 437.696L212.679 433.249L215.487 429.218L220.382 429.635L222.468 434.082L219.66 438.113Z",
    fill: "white"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M228.178 444.048L223.283 443.631L221.197 439.184L224.005 435.154L228.9 435.57L230.986 440.018L228.178 444.048Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M236.697 449.983L231.802 449.567L229.716 445.119L232.524 441.089L237.419 441.506L239.505 445.953L236.697 449.983Z",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M245.215 455.919L240.32 455.502L238.234 451.055L241.042 447.024L245.937 447.441L248.023 451.888L245.215 455.919Z",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M253.733 461.854L248.838 461.437L246.752 456.99L249.56 452.96L254.455 453.376L256.541 457.824L253.733 461.854Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M262.251 467.789L257.356 467.373L255.27 462.925L258.078 458.895L262.973 459.312L265.059 463.759L262.251 467.789Z",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M270.769 473.725L265.875 473.308L263.788 468.861L266.597 464.83L271.491 465.247L273.578 469.694L270.769 473.725Z",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M279.287 479.66L274.393 479.243L272.306 474.796L275.115 470.766L280.009 471.182L282.096 475.63L279.287 479.66Z",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M287.806 485.595L282.911 485.178L280.825 480.731L283.633 476.701L288.528 477.118L290.614 481.565L287.806 485.595Z",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M296.324 491.531L291.429 491.114L289.343 486.666L292.151 482.636L297.046 483.053L299.132 487.5L296.324 491.531Z",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M304.842 497.466L299.947 497.049L297.861 492.602L300.669 488.572L305.564 488.988L307.65 493.436L304.842 497.466Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M314.241 493.057L309.346 492.64L307.26 488.193L310.068 484.162L314.963 484.579L317.049 489.026L314.241 493.057Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M323.64 488.647L318.746 488.231L316.659 483.783L319.468 479.753L324.362 480.17L326.449 484.617L323.64 488.647Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M333.039 484.238L328.145 483.821L326.058 479.374L328.867 475.344L333.761 475.761L335.848 480.208L333.039 484.238Z",
    fill: "white"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M342.439 479.829L337.545 479.412L335.458 474.965L338.267 470.934L343.161 471.351L345.247 475.799L342.439 479.829Z",
    fill: "white"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M351.838 475.42L346.943 475.003L344.857 470.556L347.665 466.525L352.56 466.942L354.646 471.389L351.838 475.42Z",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M499.876 326.523L494.981 326.106L492.895 321.659L495.703 317.629L500.598 318.045L502.684 322.493L499.876 326.523Z",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M500.756 316.178L495.862 315.762L493.776 311.314L496.584 307.284L501.479 307.701L503.565 312.148L500.756 316.178Z",
    fill: "white"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M501.638 305.834L496.743 305.417L494.657 300.97L497.465 296.939L502.36 297.356L504.446 301.803L501.638 305.834Z",
    fill: "white"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M502.519 295.489L497.624 295.072L495.538 290.625L498.346 286.595L503.241 287.011L505.327 291.459L502.519 295.489Z",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M503.4 285.144L498.506 284.728L496.419 280.28L499.228 276.25L504.122 276.667L506.208 281.114L503.4 285.144Z",
    fill: "white"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M504.281 274.8L499.386 274.383L497.3 269.936L500.109 265.905L505.003 266.322L507.089 270.769L504.281 274.8Z",
    fill: "white"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M505.162 264.455L500.267 264.038L498.181 259.591L500.989 255.561L505.884 255.977L507.97 260.425L505.162 264.455Z",
    fill: "white"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M506.043 254.111L501.149 253.694L499.062 249.246L501.871 245.216L506.765 245.633L508.851 250.08L506.043 254.111Z",
    fill: "white"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M506.924 243.766L502.03 243.349L499.943 238.902L502.752 234.871L507.646 235.288L509.732 239.736L506.924 243.766Z",
    fill: "white"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M507.805 233.421L502.911 233.004L500.825 228.557L503.633 224.527L508.527 224.944L510.614 229.391L507.805 233.421Z",
    fill: "white"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M508.686 223.077L503.792 222.66L501.705 218.212L504.514 214.182L509.408 214.599L511.495 219.046L508.686 223.077Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M509.567 212.732L504.673 212.315L502.586 207.868L505.395 203.837L510.289 204.254L512.375 208.702L509.567 212.732Z",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M510.448 202.387L505.554 201.971L503.468 197.523L506.276 193.493L511.17 193.91L513.257 198.357L510.448 202.387Z",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M501.93 196.452L497.035 196.035L494.949 191.588L497.757 187.557L502.652 187.974L504.738 192.421L501.93 196.452Z",
    fill: "white"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M493.411 190.517L488.517 190.1L486.43 185.652L489.239 181.622L494.133 182.039L496.22 186.486L493.411 190.517Z",
    fill: "white"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M540.377 168.826L535.483 168.409L533.397 163.962L536.205 159.932L541.099 160.349L543.186 164.796L540.377 168.826Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M484.894 184.581L479.999 184.164L477.913 179.717L480.721 175.687L485.616 176.104L487.702 180.551L484.894 184.581Z",
    fill: "white"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M531.86 162.891L526.965 162.474L524.879 158.027L527.687 153.996L532.582 154.413L534.668 158.86L531.86 162.891Z",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M476.376 178.646L471.481 178.229L469.395 173.782L472.203 169.751L477.098 170.168L479.184 174.615L476.376 178.646Z",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M523.342 156.955L518.447 156.538L516.361 152.091L519.169 148.061L524.064 148.478L526.15 152.925L523.342 156.955Z",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M467.857 172.71L462.963 172.294L460.876 167.846L463.685 163.816L468.579 164.233L470.665 168.68L467.857 172.71Z",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M459.339 166.775L454.444 166.358L452.358 161.911L455.166 157.881L460.061 158.298L462.147 162.745L459.339 166.775Z",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M450.82 160.84L445.926 160.423L443.84 155.976L446.648 151.945L451.542 152.362L453.629 156.81L450.82 160.84Z",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M442.303 154.905L437.408 154.488L435.322 150.041L438.13 146.01L443.025 146.427L445.111 150.874L442.303 154.905Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M433.784 148.969L428.89 148.552L426.804 144.105L429.612 140.075L434.507 140.492L436.593 144.939L433.784 148.969Z",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M425.266 143.034L420.372 142.617L418.285 138.17L421.094 134.139L425.988 134.556L428.075 139.004L425.266 143.034Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M415.67 134.802L413.303 134.6L412.295 132.45L413.653 130.501L416.019 130.702L417.028 132.853L415.67 134.802Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M138.883 327.036L133.989 326.619L131.902 322.172L134.711 318.142L139.605 318.559L141.692 323.006L138.883 327.036Z",
    fill: "white"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M138.002 337.381L133.108 336.964L131.021 332.517L133.83 328.486L138.724 328.903L140.811 333.35L138.002 337.381Z",
    fill: "white"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 347.725L132.226 347.308L130.14 342.861L132.948 338.831L137.843 339.248L139.929 343.695L137.121 347.725Z",
    fill: "white"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M136.24 358.07L131.345 357.653L129.259 353.206L132.067 349.176L136.962 349.592L139.048 354.04L136.24 358.07Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M135.359 368.415L130.464 367.998L128.378 363.551L131.186 359.52L136.081 359.937L138.167 364.384L135.359 368.415Z",
    fill: "white"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M125.079 383.169L120.184 382.752L118.098 378.305L120.906 374.274L125.801 374.691L127.887 379.138L125.079 383.169Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M133.597 389.104L128.702 388.687L126.616 384.24L129.424 380.209L134.319 380.626L136.405 385.074L133.597 389.104Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M142.115 395.039L137.221 394.622L135.135 390.175L137.943 386.145L142.837 386.562L144.924 391.009L142.115 395.039Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M150.633 400.974L145.738 400.558L143.652 396.11L146.46 392.08L151.355 392.497L153.441 396.944L150.633 400.974Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M159.152 406.91L154.257 406.493L152.171 402.046L154.979 398.015L159.874 398.432L161.96 402.88L159.152 406.91Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M167.67 412.845L162.775 412.428L160.689 407.981L163.497 403.951L168.392 404.368L170.478 408.815L167.67 412.845Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M176.188 418.781L171.293 418.364L169.207 413.917L172.015 409.886L176.91 410.303L178.996 414.75L176.188 418.781Z",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M184.706 424.716L179.812 424.299L177.725 419.852L180.534 415.822L185.428 416.238L187.514 420.686L184.706 424.716Z",
    fill: "white"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M193.225 430.651L188.33 430.235L186.244 425.787L189.052 421.757L193.947 422.174L196.033 426.621L193.225 430.651Z",
    fill: "white"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M201.743 436.587L196.848 436.17L194.762 431.723L197.57 427.692L202.465 428.109L204.551 432.556L201.743 436.587Z",
    fill: "white"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M210.261 442.522L205.367 442.105L203.28 437.658L206.089 433.628L210.983 434.044L213.07 438.492L210.261 442.522Z",
    fill: "white"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M218.779 448.457L213.884 448.041L211.798 443.593L214.606 439.563L219.501 439.98L221.587 444.427L218.779 448.457Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M227.297 454.393L222.402 453.976L220.316 449.529L223.124 445.498L228.019 445.915L230.105 450.362L227.297 454.393Z",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M235.816 460.328L230.921 459.911L228.835 455.464L231.643 451.434L236.538 451.85L238.624 456.298L235.816 460.328Z",
    fill: "white"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M244.334 466.263L239.439 465.847L237.353 461.399L240.161 457.369L245.056 457.786L247.142 462.233L244.334 466.263Z",
    fill: "white"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M252.852 472.199L247.957 471.782L245.871 467.335L248.679 463.304L253.574 463.721L255.66 468.168L252.852 472.199Z",
    fill: "white"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M261.37 478.134L256.475 477.717L254.389 473.27L257.197 469.24L262.092 469.656L264.178 474.104L261.37 478.134Z",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M269.888 484.069L264.993 483.652L262.907 479.205L265.715 475.175L270.61 475.592L272.696 480.039L269.888 484.069Z",
    fill: "white"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M278.406 490.005L273.511 489.588L271.425 485.14L274.233 481.11L279.128 481.527L281.214 485.974L278.406 490.005Z",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M286.924 495.94L282.03 495.523L279.944 491.076L282.752 487.046L287.647 487.462L289.733 491.91L286.924 495.94Z",
    fill: "white"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M295.443 501.875L290.548 501.458L288.462 497.011L291.27 492.981L296.165 493.398L298.251 497.845L295.443 501.875Z",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M303.961 507.811L299.066 507.394L296.98 502.947L299.788 498.916L304.683 499.333L306.769 503.78L303.961 507.811Z",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M313.36 503.401L308.465 502.984L306.379 498.537L309.187 494.507L314.082 494.924L316.168 499.371L313.36 503.401Z",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M322.759 498.992L317.864 498.575L315.778 494.128L318.586 490.098L323.481 490.514L325.567 494.962L322.759 498.992Z",
    fill: "white"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M332.158 494.583L327.264 494.166L325.178 489.719L327.986 485.688L332.88 486.105L334.967 490.552L332.158 494.583Z",
    fill: "white"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M341.558 490.173L336.663 489.757L334.577 485.309L337.385 481.279L342.28 481.696L344.366 486.143L341.558 490.173Z",
    fill: "white"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M350.957 485.764L346.063 485.347L343.976 480.9L346.785 476.87L351.679 477.287L353.766 481.734L350.957 485.764Z",
    fill: "white"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M509.275 322.114L504.38 321.697L502.294 317.25L505.102 313.219L509.997 313.636L512.083 318.083L509.275 322.114Z",
    fill: "white"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 311.769L505.261 311.352L503.175 306.905L505.984 302.875L510.878 303.292L512.964 307.739L510.156 311.769Z",
    fill: "white"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M511.037 301.424L506.142 301.007L504.056 296.56L506.864 292.53L511.759 292.947L513.845 297.394L511.037 301.424Z",
    fill: "white"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M511.918 291.08L507.024 290.663L504.937 286.216L507.746 282.185L512.64 282.602L514.726 287.049L511.918 291.08Z",
    fill: "white"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M512.799 280.735L507.905 280.318L505.818 275.871L508.627 271.841L513.521 272.258L515.607 276.705L512.799 280.735Z",
    fill: "white"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M513.68 270.39L508.786 269.974L506.7 265.526L509.508 261.496L514.402 261.913L516.489 266.36L513.68 270.39Z",
    fill: "white"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M514.561 260.046L509.667 259.629L507.58 255.182L510.389 251.151L515.283 251.568L517.37 256.016L514.561 260.046Z",
    fill: "white"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M515.442 249.701L510.548 249.284L508.461 244.837L511.27 240.807L516.164 241.224L518.25 245.671L515.442 249.701Z",
    fill: "white"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M516.323 239.357L511.429 238.94L509.343 234.492L512.151 230.462L517.045 230.879L519.132 235.326L516.323 239.357Z",
    fill: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M517.204 229.012L512.31 228.595L510.223 224.148L513.032 220.118L517.926 220.534L520.013 224.982L517.204 229.012Z",
    fill: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M518.086 218.667L513.191 218.25L511.105 213.803L513.913 209.773L518.808 210.19L520.894 214.637L518.086 218.667Z",
    fill: "white"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M518.966 208.323L514.072 207.906L511.986 203.458L514.794 199.428L519.688 199.845L521.775 204.292L518.966 208.323Z",
    fill: "white"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M519.847 197.978L514.953 197.561L512.867 193.114L515.675 189.084L520.569 189.5L522.656 193.948L519.847 197.978Z",
    fill: "white"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M511.329 192.043L506.435 191.626L504.348 187.179L507.157 183.148L512.051 183.565L514.138 188.012L511.329 192.043Z",
    fill: "white"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M502.811 186.107L497.916 185.69L495.83 181.243L498.638 177.213L503.533 177.63L505.619 182.077L502.811 186.107Z",
    fill: "white"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M549.777 164.417L544.883 164L542.796 159.553L545.605 155.522L550.499 155.939L552.585 160.386L549.777 164.417Z",
    fill: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M558.342 170.266L553.447 169.849L551.361 165.402L554.17 161.372L559.064 161.789L561.15 166.236L558.342 170.266Z",
    fill: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M549.342 174.103L544.447 173.686L542.361 169.239L545.17 165.208L550.064 165.625L552.15 170.073L549.342 174.103Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M494.292 180.172L489.398 179.755L487.311 175.308L490.12 171.277L495.014 171.694L497.1 176.141L494.292 180.172Z",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M541.258 158.481L536.364 158.064L534.278 153.617L537.086 149.587L541.98 150.004L544.067 154.451L541.258 158.481Z",
    fill: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M485.775 174.237L480.88 173.82L478.794 169.373L481.602 165.342L486.497 165.759L488.583 170.206L485.775 174.237Z",
    fill: "white"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M532.741 152.546L527.846 152.129L525.76 147.682L528.568 143.652L533.463 144.069L535.549 148.516L532.741 152.546Z",
    fill: "white"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M477.256 168.301L472.362 167.884L470.276 163.437L473.084 159.407L477.979 159.824L480.065 164.271L477.256 168.301Z",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M524.223 146.611L519.328 146.194L517.242 141.747L520.05 137.716L524.945 138.133L527.031 142.58L524.223 146.611Z",
    fill: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M468.738 162.366L463.844 161.949L461.758 157.502L464.566 153.471L469.46 153.888L471.547 158.336L468.738 162.366Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M460.22 156.431L455.325 156.014L453.239 151.567L456.047 147.536L460.942 147.953L463.028 152.4L460.22 156.431Z",
    fill: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M451.702 150.495L446.807 150.078L444.721 145.631L447.529 141.601L452.424 142.018L454.51 146.465L451.702 150.495Z",
    fill: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M443.184 144.56L438.29 144.143L436.203 139.696L439.012 135.665L443.906 136.082L445.993 140.53L443.184 144.56Z",
    fill: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M434.666 138.625L429.771 138.208L427.685 133.761L430.493 129.73L435.388 130.147L437.474 134.594L434.666 138.625Z",
    fill: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M426.147 132.689L421.253 132.272L419.166 127.825L421.975 123.795L426.869 124.212L428.956 128.659L426.147 132.689Z",
    fill: "white"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M129.484 331.445L124.589 331.029L122.503 326.581L125.311 322.551L130.206 322.968L132.292 327.415L129.484 331.445Z",
    fill: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M128.603 341.79L123.708 341.373L121.622 336.926L124.43 332.896L129.325 333.312L131.411 337.76L128.603 341.79Z",
    fill: "white"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M127.722 352.135L122.827 351.718L120.741 347.271L123.549 343.24L128.444 343.657L130.53 348.104L127.722 352.135Z",
    fill: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M126.841 362.479L121.946 362.062L119.86 357.615L122.668 353.585L127.563 354.002L129.649 358.449L126.841 362.479Z",
    fill: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M125.96 372.824L121.065 372.407L118.979 367.96L121.787 363.93L126.682 364.346L128.768 368.794L125.96 372.824Z",
    fill: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M115.68 387.578L110.785 387.161L108.699 382.714L111.507 378.683L116.402 379.1L118.488 383.548L115.68 387.578Z",
    fill: "white"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M124.198 393.513L119.303 393.096L117.217 388.649L120.025 384.619L124.92 385.036L127.006 389.483L124.198 393.513Z",
    fill: "white"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M132.716 399.448L127.821 399.032L125.735 394.584L128.543 390.554L133.438 390.971L135.524 395.418L132.716 399.448Z",
    fill: "white"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M141.234 405.384L136.34 404.967L134.253 400.52L137.062 396.489L141.956 396.906L144.043 401.354L141.234 405.384Z",
    fill: "white"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M149.752 411.319L144.857 410.902L142.771 406.455L145.579 402.425L150.474 402.842L152.56 407.289L149.752 411.319Z",
    fill: "white"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M158.27 417.255L153.376 416.838L151.29 412.391L154.098 408.36L158.992 408.777L161.079 413.224L158.27 417.255Z",
    fill: "white"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M166.788 423.19L161.894 422.773L159.808 418.326L162.616 414.296L167.511 414.712L169.597 419.16L166.788 423.19Z",
    fill: "white"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M175.307 429.125L170.412 428.708L168.326 424.261L171.134 420.231L176.029 420.648L178.115 425.095L175.307 429.125Z",
    fill: "white"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M183.825 435.061L178.93 434.644L176.844 430.196L179.652 426.166L184.547 426.583L186.633 431.03L183.825 435.061Z",
    fill: "white"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M192.343 440.996L187.449 440.579L185.363 436.132L188.171 432.102L193.065 432.518L195.152 436.966L192.343 440.996Z",
    fill: "white"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M200.861 446.931L195.967 446.515L193.881 442.067L196.689 438.037L201.584 438.454L203.67 442.901L200.861 446.931Z",
    fill: "white"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M209.38 452.867L204.486 452.45L202.399 448.003L205.208 443.972L210.102 444.389L212.189 448.836L209.38 452.867Z",
    fill: "white"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M217.898 458.802L213.003 458.385L210.917 453.938L213.725 449.907L218.62 450.324L220.706 454.771L217.898 458.802Z",
    fill: "white"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M226.416 464.737L221.521 464.32L219.435 459.873L222.243 455.843L227.138 456.26L229.224 460.707L226.416 464.737Z",
    fill: "white"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M234.934 470.673L230.04 470.256L227.954 465.809L230.762 461.778L235.657 462.195L237.743 466.642L234.934 470.673Z",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M243.453 476.608L238.558 476.191L236.472 471.744L239.28 467.714L244.175 468.13L246.261 472.578L243.453 476.608Z",
    fill: "white"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M251.971 482.543L247.076 482.126L244.99 477.679L247.798 473.649L252.693 474.066L254.779 478.513L251.971 482.543Z",
    fill: "white"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M260.489 488.479L255.594 488.062L253.508 483.614L256.317 479.584L261.211 480.001L263.297 484.448L260.489 488.479Z",
    fill: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M269.007 494.414L264.113 493.997L262.026 489.55L264.835 485.519L269.729 485.936L271.815 490.384L269.007 494.414Z",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M277.525 500.349L272.63 499.932L270.544 495.485L273.352 491.455L278.247 491.872L280.333 496.319L277.525 500.349Z",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 506.285L281.149 505.868L279.063 501.421L281.871 497.39L286.766 497.807L288.852 502.254L286.044 506.285Z",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M294.562 512.22L289.667 511.803L287.581 507.356L290.389 503.325L295.284 503.742L297.37 508.19L294.562 512.22Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M303.08 518.155L298.185 517.738L296.099 513.291L298.907 509.261L303.802 509.678L305.888 514.125L303.08 518.155Z",
    fill: "white"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M312.479 513.746L307.585 513.329L305.498 508.882L308.307 504.851L313.201 505.268L315.287 509.716L312.479 513.746Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M321.878 509.337L316.983 508.92L314.897 504.473L317.706 500.442L322.6 500.859L324.686 505.306L321.878 509.337Z",
    fill: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M331.277 504.927L326.383 504.511L324.297 500.063L327.105 496.033L332 496.45L334.086 500.897L331.277 504.927Z",
    fill: "white"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M340.677 500.518L335.782 500.101L333.696 495.654L336.504 491.624L341.399 492.04L343.485 496.488L340.677 500.518Z",
    fill: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M519.556 307.362L514.659 306.945L512.571 302.495L515.381 298.463L520.279 298.88L522.366 303.33L519.556 307.362Z",
    fill: "white"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M520.436 297.015L515.542 296.598L513.455 292.151L516.264 288.121L521.158 288.537L523.245 292.985L520.436 297.015Z",
    fill: "white"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M521.317 286.67L516.423 286.254L514.336 281.806L517.145 277.776L522.039 278.193L524.125 282.64L521.317 286.67Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M522.198 276.326L517.304 275.909L515.218 271.462L518.026 267.431L522.92 267.848L525.007 272.296L522.198 276.326Z",
    fill: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M523.079 265.981L518.185 265.564L516.098 261.117L518.907 257.087L523.801 257.503L525.888 261.951L523.079 265.981Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M523.96 255.637L519.066 255.22L516.979 250.772L519.788 246.742L524.682 247.159L526.769 251.606L523.96 255.637Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M524.841 245.292L519.947 244.875L517.861 240.428L520.669 236.397L525.563 236.814L527.65 241.262L524.841 245.292Z",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M525.722 234.947L520.828 234.53L518.742 230.083L521.55 226.053L526.444 226.47L528.531 230.917L525.722 234.947Z",
    fill: "#EF4444"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M526.604 224.603L521.709 224.186L519.623 219.738L522.431 215.708L527.326 216.125L529.412 220.572L526.604 224.603Z",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M527.485 214.258L522.59 213.841L520.504 209.394L523.312 205.363L528.207 205.78L530.293 210.228L527.485 214.258Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M528.365 203.913L523.471 203.497L521.385 199.049L524.193 195.019L529.087 195.436L531.174 199.883L528.365 203.913Z",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M529.247 193.569L524.352 193.152L522.266 188.705L525.074 184.674L529.969 185.091L532.055 189.538L529.247 193.569Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M520.729 187.633L515.834 187.216L513.748 182.769L516.556 178.739L521.451 179.156L523.537 183.603L520.729 187.633Z",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M512.211 181.698L507.316 181.281L505.23 176.834L508.038 172.803L512.933 173.22L515.019 177.668L512.211 181.698Z",
    fill: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M503.692 175.763L498.798 175.346L496.711 170.899L499.52 166.868L504.414 167.285L506.5 171.732L503.692 175.763Z",
    fill: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M550.658 154.072L545.764 153.655L543.678 149.208L546.486 145.178L551.38 145.595L553.467 150.042L550.658 154.072Z",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M559.223 159.922L554.329 159.505L552.242 155.057L555.051 151.027L559.945 151.444L562.032 155.891L559.223 159.922Z",
    fill: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M495.173 169.827L490.278 169.41L488.192 164.963L491 160.933L495.895 161.35L497.981 165.797L495.173 169.827Z",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M542.139 148.137L537.245 147.72L535.159 143.273L537.967 139.242L542.861 139.659L544.948 144.106L542.139 148.137Z",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M486.655 163.892L481.761 163.475L479.675 159.028L482.483 154.997L487.377 155.414L489.464 159.862L486.655 163.892Z",
    fill: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M533.622 142.202L528.727 141.785L526.641 137.338L529.449 133.307L534.344 133.724L536.43 138.171L533.622 142.202Z",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M478.137 157.957L473.243 157.54L471.157 153.093L473.965 149.062L478.859 149.479L480.946 153.926L478.137 157.957Z",
    fill: "white"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M525.104 136.266L520.209 135.849L518.123 131.402L520.931 127.372L525.826 127.789L527.912 132.236L525.104 136.266Z",
    fill: "white"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M469.619 152.021L464.725 151.604L462.638 147.157L465.447 143.127L470.341 143.544L472.428 147.991L469.619 152.021Z",
    fill: "white"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M461.101 146.086L456.206 145.669L454.12 141.222L456.928 137.191L461.823 137.608L463.909 142.056L461.101 146.086Z",
    fill: "white"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M452.583 140.151L447.688 139.734L445.602 135.287L448.41 131.256L453.305 131.673L455.391 136.12L452.583 140.151Z",
    fill: "white"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M444.065 134.215L439.171 133.798L437.084 129.351L439.893 125.321L444.787 125.738L446.873 130.185L444.065 134.215Z",
    fill: "white"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M435.547 128.28L430.652 127.863L428.566 123.416L431.374 119.385L436.269 119.802L438.355 124.249L435.547 128.28Z",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M427.029 122.345L422.134 121.928L420.048 117.481L422.856 113.45L427.751 113.867L429.837 118.314L427.029 122.345Z",
    fill: "white"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M418.512 116.412L413.615 115.995L411.527 111.545L414.337 107.512L419.234 107.929L421.322 112.379L418.512 116.412Z",
    fill: "white"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M120.591 324.712L116.575 324.37L114.863 320.721L117.167 317.413L121.184 317.755L122.896 321.405L120.591 324.712Z",
    fill: "white"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M120.085 335.855L115.19 335.438L113.104 330.99L115.912 326.96L120.807 327.377L122.893 331.824L120.085 335.855Z",
    fill: "white"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M119.204 346.199L114.309 345.782L112.223 341.335L115.031 337.305L119.926 337.722L122.012 342.169L119.204 346.199Z",
    fill: "white"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M118.323 356.544L113.428 356.127L111.342 351.68L114.15 347.649L119.045 348.066L121.131 352.514L118.323 356.544Z",
    fill: "white"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M117.442 366.889L112.547 366.472L110.461 362.025L113.269 357.994L118.164 358.411L120.25 362.858L117.442 366.889Z",
    fill: "white"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M116.56 377.233L111.666 376.816L109.58 372.369L112.388 368.339L117.282 368.756L119.369 373.203L116.56 377.233Z",
    fill: "white"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M106.28 391.987L101.386 391.57L99.2996 387.123L102.108 383.093L107.002 383.51L109.089 387.957L106.28 391.987Z",
    fill: "white"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M114.798 397.922L109.904 397.506L107.818 393.058L110.626 389.028L115.521 389.445L117.607 393.892L114.798 397.922Z",
    fill: "white"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M123.317 403.858L118.422 403.441L116.336 398.994L119.144 394.963L124.039 395.38L126.125 399.828L123.317 403.858Z",
    fill: "white"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M131.835 409.793L126.94 409.376L124.854 404.929L127.662 400.899L132.557 401.316L134.643 405.763L131.835 409.793Z",
    fill: "white"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M140.353 415.729L135.459 415.312L133.372 410.864L136.181 406.834L141.075 407.251L143.161 411.698L140.353 415.729Z",
    fill: "white"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M148.871 421.664L143.976 421.247L141.89 416.8L144.698 412.769L149.593 413.186L151.679 417.634L148.871 421.664Z",
    fill: "white"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M157.39 427.599L152.495 427.182L150.409 422.735L153.217 418.705L158.112 419.122L160.198 423.569L157.39 427.599Z",
    fill: "white"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M165.908 433.535L161.013 433.118L158.927 428.67L161.735 424.64L166.63 425.057L168.716 429.504L165.908 433.535Z",
    fill: "white"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M174.426 439.47L169.531 439.053L167.445 434.606L170.253 430.576L175.148 430.992L177.234 435.44L174.426 439.47Z",
    fill: "white"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M182.944 445.405L178.049 444.988L175.963 440.541L178.771 436.511L183.666 436.928L185.752 441.375L182.944 445.405Z",
    fill: "white"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M191.462 451.341L186.568 450.924L184.482 446.476L187.29 442.446L192.184 442.863L194.271 447.31L191.462 451.341Z",
    fill: "white"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M199.98 457.276L195.086 456.859L193 452.412L195.808 448.381L200.702 448.798L202.789 453.245L199.98 457.276Z",
    fill: "white"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M208.499 463.211L203.605 462.794L201.518 458.347L204.327 454.317L209.221 454.734L211.308 459.181L208.499 463.211Z",
    fill: "white"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M217.017 469.147L212.122 468.73L210.036 464.283L212.844 460.252L217.739 460.669L219.825 465.116L217.017 469.147Z",
    fill: "white"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M225.535 475.082L220.64 474.665L218.554 470.218L221.362 466.187L226.257 466.604L228.343 471.052L225.535 475.082Z",
    fill: "white"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M234.053 481.017L229.159 480.6L227.073 476.153L229.881 472.123L234.775 472.54L236.862 476.987L234.053 481.017Z",
    fill: "white"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M242.572 486.953L237.677 486.536L235.591 482.088L238.399 478.058L243.294 478.475L245.38 482.922L242.572 486.953Z",
    fill: "white"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M251.09 492.888L246.195 492.471L244.109 488.024L246.917 483.993L251.812 484.41L253.898 488.858L251.09 492.888Z",
    fill: "white"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M259.608 498.823L254.713 498.406L252.627 493.959L255.435 489.929L260.33 490.346L262.416 494.793L259.608 498.823Z",
    fill: "white"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M268.126 504.759L263.231 504.342L261.145 499.895L263.953 495.864L268.848 496.281L270.934 500.728L268.126 504.759Z",
    fill: "white"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M276.644 510.694L271.749 510.277L269.663 505.83L272.471 501.799L277.366 502.216L279.452 506.664L276.644 510.694Z",
    fill: "white"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M285.163 516.629L280.268 516.212L278.182 511.765L280.99 507.735L285.885 508.152L287.971 512.599L285.163 516.629Z",
    fill: "white"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M293.681 522.565L288.786 522.148L286.7 517.701L289.508 513.67L294.403 514.087L296.489 518.534L293.681 522.565Z",
    fill: "white"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M302.199 528.5L297.304 528.083L295.218 523.636L298.026 519.606L302.921 520.022L305.007 524.47L302.199 528.5Z",
    fill: "white"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M311.598 524.091L306.703 523.674L304.617 519.227L307.425 515.196L312.32 515.613L314.406 520.06L311.598 524.091Z",
    fill: "white"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M320.997 519.681L316.103 519.264L314.016 514.817L316.825 510.787L321.719 511.204L323.805 515.651L320.997 519.681Z",
    fill: "white"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M330.396 515.272L325.502 514.855L323.415 510.408L326.224 506.378L331.118 506.794L333.205 511.242L330.396 515.272Z",
    fill: "white"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M339.796 510.863L334.901 510.446L332.815 505.999L335.623 501.968L340.518 502.385L342.604 506.832L339.796 510.863Z",
    fill: "white"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M349.195 506.453L344.3 506.037L342.214 501.589L345.022 497.559L349.917 497.976L352.003 502.423L349.195 506.453Z",
    fill: "white"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M529.835 292.606L524.941 292.189L522.854 287.742L525.663 283.711L530.557 284.128L532.644 288.575L529.835 292.606Z",
    fill: "white"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M530.716 282.261L525.822 281.844L523.736 277.397L526.544 273.367L531.439 273.784L533.525 278.231L530.716 282.261Z",
    fill: "white"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M531.597 271.917L526.703 271.5L524.617 267.052L527.425 263.022L532.319 263.439L534.406 267.886L531.597 271.917Z",
    fill: "white"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M532.478 261.572L527.584 261.155L525.497 256.708L528.306 252.677L533.2 253.094L535.287 257.542L532.478 261.572Z",
    fill: "white"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M533.36 251.227L528.465 250.81L526.379 246.363L529.187 242.333L534.082 242.75L536.168 247.197L533.36 251.227Z",
    fill: "white"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M534.24 240.883L529.346 240.466L527.26 236.018L530.068 231.988L534.962 232.405L537.049 236.852L534.24 240.883Z",
    fill: "white"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M535.122 230.538L530.227 230.121L528.141 225.674L530.949 221.644L535.844 222.06L537.93 226.508L535.122 230.538Z",
    fill: "white"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M536.003 220.193L531.108 219.776L529.022 215.329L531.83 211.299L536.725 211.716L538.811 216.163L536.003 220.193Z",
    fill: "white"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M536.883 209.849L531.989 209.432L529.903 204.985L532.711 200.954L537.606 201.371L539.692 205.818L536.883 209.849Z",
    fill: "white"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M537.765 199.504L532.87 199.087L530.784 194.64L533.592 190.61L538.487 191.026L540.573 195.474L537.765 199.504Z",
    fill: "white"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M530.128 183.224L525.233 182.807L523.147 178.36L525.955 174.329L530.85 174.746L532.936 179.194L530.128 183.224Z",
    fill: "white"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M521.61 177.289L516.715 176.872L514.629 172.425L517.437 168.394L522.332 168.811L524.418 173.258L521.61 177.289Z",
    fill: "white"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M513.091 171.353L508.197 170.936L506.111 166.489L508.919 162.459L513.813 162.876L515.9 167.323L513.091 171.353Z",
    fill: "white"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M560.058 149.663L555.163 149.246L553.077 144.799L555.885 140.768L560.78 141.185L562.866 145.633L560.058 149.663Z",
    fill: "white"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M568.623 155.512L563.728 155.095L561.642 150.648L564.45 146.618L569.345 147.035L571.431 151.482L568.623 155.512Z",
    fill: "white"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M504.573 165.418L499.678 165.001L497.592 160.554L500.4 156.524L505.295 156.94L507.381 161.388L504.573 165.418Z",
    fill: "white"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M551.539 143.728L546.645 143.311L544.558 138.864L547.367 134.833L552.261 135.25L554.348 139.697L551.539 143.728Z",
    fill: "white"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M496.054 159.483L491.16 159.066L489.074 154.619L491.882 150.588L496.776 151.005L498.863 155.452L496.054 159.483Z",
    fill: "white"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M543.021 137.792L538.126 137.375L536.04 132.928L538.848 128.898L543.743 129.315L545.829 133.762L543.021 137.792Z",
    fill: "white"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M487.537 153.547L482.642 153.13L480.556 148.683L483.364 144.653L488.259 145.07L490.345 149.517L487.537 153.547Z",
    fill: "white"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M534.503 131.857L529.608 131.44L527.522 126.993L530.331 122.962L535.225 123.379L537.311 127.827L534.503 131.857Z",
    fill: "white"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M700.342 192.792L695.447 192.375L693.361 187.928L696.169 183.898L701.064 184.315L703.15 188.762L700.342 192.792Z",
    fill: "white"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M479.019 147.612L474.124 147.195L472.038 142.748L474.846 138.717L479.741 139.134L481.827 143.582L479.019 147.612Z",
    fill: "white"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M470.501 141.677L465.606 141.26L463.52 136.813L466.328 132.782L471.223 133.199L473.309 137.646L470.501 141.677Z",
    fill: "white"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M461.982 135.741L457.088 135.324L455.001 130.877L457.81 126.847L462.704 127.264L464.79 131.711L461.982 135.741Z",
    fill: "white"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M453.464 129.806L448.569 129.389L446.483 124.942L449.291 120.911L454.186 121.328L456.272 125.775L453.464 129.806Z",
    fill: "white"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M444.946 123.871L440.051 123.454L437.965 119.007L440.774 114.976L445.668 115.393L447.754 119.84L444.946 123.871Z",
    fill: "white"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M436.428 117.935L431.533 117.518L429.447 113.071L432.255 109.041L437.15 109.458L439.236 113.905L436.428 117.935Z",
    fill: "white"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M427.91 112L423.015 111.583L420.929 107.136L423.737 103.106L428.632 103.522L430.718 107.97L427.91 112Z",
    fill: "white"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M111.567 329.919L106.672 329.503L104.586 325.055L107.394 321.025L112.289 321.442L114.375 325.889L111.567 329.919Z",
    fill: "white"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M110.686 340.264L105.791 339.847L103.705 335.4L106.513 331.37L111.408 331.786L113.494 336.234L110.686 340.264Z",
    fill: "white"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M109.804 350.609L104.91 350.192L102.824 345.745L105.632 341.714L110.526 342.131L112.613 346.578L109.804 350.609Z",
    fill: "white"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M108.923 360.953L104.029 360.536L101.943 356.089L104.751 352.059L109.645 352.476L111.732 356.923L108.923 360.953Z",
    fill: "white"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M108.042 371.298L103.148 370.881L101.062 366.434L103.87 362.404L108.764 362.82L110.851 367.268L108.042 371.298Z",
    fill: "white"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M107.161 381.642L102.267 381.226L100.18 376.778L102.989 372.748L107.883 373.165L109.97 377.612L107.161 381.642Z",
    fill: "white"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8813 396.396L91.9867 395.98L89.9005 391.532L92.7087 387.502L97.6033 387.919L99.6895 392.366L96.8813 396.396Z",
    fill: "white"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M105.399 402.332L100.505 401.915L98.4185 397.468L101.227 393.437L106.121 393.854L108.208 398.302L105.399 402.332Z",
    fill: "white"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M113.917 408.267L109.023 407.85L106.937 403.403L109.745 399.373L114.639 399.79L116.726 404.237L113.917 408.267Z",
    fill: "white"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M122.435 414.203L117.541 413.786L115.455 409.338L118.263 405.308L123.157 405.725L125.244 410.172L122.435 414.203Z",
    fill: "white"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M130.954 420.138L126.059 419.721L123.973 415.274L126.781 411.243L131.676 411.66L133.762 416.108L130.954 420.138Z",
    fill: "white"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M139.472 426.073L134.578 425.656L132.492 421.209L135.3 417.179L140.194 417.596L142.281 422.043L139.472 426.073Z",
    fill: "white"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M147.99 432.009L143.095 431.592L141.009 427.144L143.817 423.114L148.712 423.531L150.798 427.978L147.99 432.009Z",
    fill: "white"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M156.508 437.944L151.614 437.527L149.528 433.08L152.336 429.049L157.23 429.466L159.317 433.914L156.508 437.944Z",
    fill: "white"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M539.223 178.46L534.329 178.043L532.242 173.596L535.051 169.566L539.945 169.982L542.032 174.43L539.223 178.46Z",
    fill: "white"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M165.027 443.879L160.132 443.462L158.046 439.015L160.854 434.985L165.749 435.402L167.835 439.849L165.027 443.879Z",
    fill: "white"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M173.545 449.815L168.65 449.398L166.564 444.95L169.372 440.92L174.267 441.337L176.353 445.784L173.545 449.815Z",
    fill: "white"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M182.063 455.75L177.168 455.333L175.082 450.886L177.89 446.855L182.785 447.272L184.871 451.719L182.063 455.75Z",
    fill: "white"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M190.581 461.685L185.687 461.268L183.6 456.821L186.409 452.791L191.303 453.208L193.39 457.655L190.581 461.685Z",
    fill: "white"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M199.1 467.621L194.205 467.204L192.119 462.757L194.927 458.726L199.822 459.143L201.908 463.59L199.1 467.621Z",
    fill: "white"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M207.618 473.556L202.723 473.139L200.637 468.692L203.446 464.662L208.34 465.078L210.426 469.526L207.618 473.556Z",
    fill: "white"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M216.136 479.491L211.241 479.074L209.155 474.627L211.963 470.597L216.858 471.014L218.944 475.461L216.136 479.491Z",
    fill: "white"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M224.654 485.427L219.759 485.01L217.673 480.562L220.481 476.532L225.376 476.949L227.462 481.396L224.654 485.427Z",
    fill: "white"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M233.172 491.362L228.278 490.945L226.191 486.498L229 482.467L233.894 482.884L235.981 487.332L233.172 491.362Z",
    fill: "white"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M241.69 497.297L236.796 496.88L234.71 492.433L237.518 488.403L242.413 488.82L244.499 493.267L241.69 497.297Z",
    fill: "white"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M250.209 503.233L245.314 502.816L243.228 498.369L246.036 494.338L250.931 494.755L253.017 499.202L250.209 503.233Z",
    fill: "white"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M258.727 509.168L253.832 508.751L251.746 504.304L254.554 500.274L259.449 500.69L261.535 505.138L258.727 509.168Z",
    fill: "white"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M267.245 515.103L262.35 514.686L260.264 510.239L263.072 506.209L267.967 506.626L270.053 511.073L267.245 515.103Z",
    fill: "white"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M275.763 521.039L270.868 520.622L268.782 516.175L271.59 512.144L276.485 512.561L278.571 517.008L275.763 521.039Z",
    fill: "white"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M284.281 526.974L279.387 526.557L277.301 522.11L280.109 518.079L285.003 518.496L287.09 522.944L284.281 526.974Z",
    fill: "white"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M292.799 532.909L287.905 532.492L285.819 528.045L288.627 524.015L293.522 524.432L295.608 528.879L292.799 532.909Z",
    fill: "white"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M301.318 538.845L296.423 538.428L294.337 533.981L297.145 529.95L302.04 530.367L304.126 534.814L301.318 538.845Z",
    fill: "white"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M310.717 534.435L305.822 534.018L303.736 529.571L306.544 525.541L311.439 525.958L313.525 530.405L310.717 534.435Z",
    fill: "white"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M320.116 530.026L315.221 529.609L313.135 525.162L315.943 521.132L320.838 521.548L322.924 525.996L320.116 530.026Z",
    fill: "white"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M329.515 525.617L324.621 525.2L322.534 520.753L325.343 516.722L330.237 517.139L332.324 521.586L329.515 525.617Z",
    fill: "white"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M338.915 521.207L334.02 520.791L331.934 516.343L334.742 512.313L339.637 512.73L341.723 517.177L338.915 521.207Z",
    fill: "white"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M348.314 516.798L343.42 516.381L341.333 511.934L344.142 507.904L349.036 508.32L351.122 512.768L348.314 516.798Z",
    fill: "white"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M357.535 512.009L353.059 511.628L351.151 507.56L353.719 503.875L358.195 504.256L360.103 508.323L357.535 512.009Z",
    fill: "white"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M539.235 288.196L534.34 287.78L532.254 283.332L535.062 279.302L539.957 279.719L542.043 284.166L539.235 288.196Z",
    fill: "white"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M540.115 277.852L535.221 277.435L533.135 272.988L535.943 268.957L540.837 269.374L542.924 273.822L540.115 277.852Z",
    fill: "white"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M540.996 267.507L536.102 267.09L534.015 262.643L536.824 258.613L541.718 259.029L543.805 263.477L540.996 267.507Z",
    fill: "white"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M541.878 257.163L536.983 256.746L534.897 252.298L537.705 248.268L542.6 248.685L544.686 253.132L541.878 257.163Z",
    fill: "white"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M542.758 246.818L537.864 246.401L535.778 241.954L538.586 237.923L543.48 238.34L545.567 242.788L542.758 246.818Z",
    fill: "white"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M543.64 236.473L538.745 236.056L536.659 231.609L539.467 227.579L544.362 227.996L546.448 232.443L543.64 236.473Z",
    fill: "white"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M544.521 226.129L539.626 225.712L537.54 221.264L540.348 217.234L545.243 217.651L547.329 222.098L544.521 226.129Z",
    fill: "white"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M545.402 215.784L540.507 215.367L538.421 210.92L541.229 206.889L546.124 207.306L548.21 211.754L545.402 215.784Z",
    fill: "white"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M531.009 172.879L526.114 172.462L524.028 168.015L526.837 163.985L531.731 164.402L533.817 168.849L531.009 172.879Z",
    fill: "white"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M522.491 166.944L517.596 166.527L515.51 162.08L518.318 158.05L523.213 158.466L525.299 162.914L522.491 166.944Z",
    fill: "white"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M569.457 145.254L564.563 144.837L562.476 140.39L565.285 136.359L570.179 136.776L572.266 141.223L569.457 145.254Z",
    fill: "white"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M579.342 141.448L574.447 141.031L572.361 136.583L575.17 132.553L580.064 132.97L582.15 137.417L579.342 141.448Z",
    fill: "white"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M588.342 137.103L583.447 136.686L581.361 132.239L584.17 128.208L589.064 128.625L591.15 133.073L588.342 137.103Z",
    fill: "white"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M578.022 151.103L573.128 150.686L571.041 146.239L573.85 142.208L578.744 142.625L580.831 147.073L578.022 151.103Z",
    fill: "white"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M585.342 157.103L580.447 156.686L578.361 152.239L581.17 148.208L586.064 148.625L588.15 153.073L585.342 157.103Z",
    fill: "white"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M576.342 162.103L571.447 161.686L569.361 157.239L572.17 153.208L577.064 153.625L579.15 158.073L576.342 162.103Z",
    fill: "white"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M567.342 166.103L562.447 165.686L560.361 161.239L563.17 157.208L568.064 157.625L570.15 162.073L567.342 166.103Z",
    fill: "white"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M566.342 176.103L561.447 175.686L559.361 171.239L562.17 167.208L567.064 167.625L569.15 172.073L566.342 176.103Z",
    fill: "white"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M576.342 172.103L571.447 171.686L569.361 167.239L572.17 163.208L577.064 163.625L579.15 168.073L576.342 172.103Z",
    fill: "white"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M587.907 147.297L583.012 146.88L580.926 142.433L583.734 138.402L588.629 138.819L590.715 143.267L587.907 147.297Z",
    fill: "white"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M513.972 161.009L509.078 160.592L506.992 156.145L509.8 152.114L514.694 152.531L516.781 156.978L513.972 161.009Z",
    fill: "white"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M560.939 139.318L556.044 138.901L553.958 134.454L556.766 130.424L561.661 130.841L563.747 135.288L560.939 139.318Z",
    fill: "white"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M505.454 155.073L500.559 154.656L498.473 150.209L501.281 146.179L506.176 146.596L508.262 151.043L505.454 155.073Z",
    fill: "white"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M552.42 133.383L547.526 132.966L545.439 128.519L548.248 124.488L553.142 124.905L555.228 129.353L552.42 133.383Z",
    fill: "white"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M561.342 128.103L556.447 127.686L554.361 123.239L557.17 119.208L562.064 119.625L564.15 124.073L561.342 128.103Z",
    fill: "white"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M718.259 194.318L713.364 193.901L711.278 189.454L714.087 185.424L718.981 185.841L721.067 190.288L718.259 194.318Z",
    fill: "white"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M745.342 201.103L740.447 200.686L738.361 196.239L741.17 192.208L746.064 192.625L748.15 197.073L745.342 201.103Z",
    fill: "white"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M746.342 181.103L741.447 180.686L739.361 176.239L742.17 172.208L747.064 172.625L749.15 177.073L746.342 181.103Z",
    fill: "white"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M496.935 149.138L492.041 148.721L489.954 144.274L492.763 140.243L497.657 140.66L499.743 145.108L496.935 149.138Z",
    fill: "white"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M543.901 127.448L539.007 127.031L536.921 122.583L539.729 118.553L544.623 118.97L546.71 123.417L543.901 127.448Z",
    fill: "white"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M709.74 188.383L704.846 187.966L702.76 183.519L705.568 179.488L710.462 179.905L712.549 184.353L709.74 188.383Z",
    fill: "white"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M488.418 143.203L483.523 142.786L481.437 138.339L484.245 134.308L489.14 134.725L491.226 139.172L488.418 143.203Z",
    fill: "white"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M535.384 121.512L530.489 121.095L528.403 116.648L531.211 112.618L536.106 113.035L538.192 117.482L535.384 121.512Z",
    fill: "white"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M701.223 182.448L696.328 182.031L694.242 177.584L697.05 173.553L701.945 173.97L704.031 178.417L701.223 182.448Z",
    fill: "white"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M479.9 137.267L475.005 136.85L472.919 132.403L475.727 128.373L480.622 128.79L482.708 133.237L479.9 137.267Z",
    fill: "white"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M471.381 131.332L466.487 130.915L464.401 126.468L467.209 122.438L472.104 122.854L474.19 127.302L471.381 131.332Z",
    fill: "white"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M462.863 125.397L457.968 124.98L455.882 120.533L458.691 116.502L463.585 116.919L465.671 121.366L462.863 125.397Z",
    fill: "white"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M454.345 119.461L449.45 119.044L447.364 114.597L450.172 110.567L455.067 110.984L457.153 115.431L454.345 119.461Z",
    fill: "white"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M445.827 113.526L440.933 113.109L438.847 108.662L441.655 104.632L446.549 105.048L448.636 109.496L445.827 113.526Z",
    fill: "white"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M437.309 107.591L432.414 107.174L430.328 102.727L433.136 98.6962L438.031 99.1131L440.117 103.56L437.309 107.591Z",
    fill: "white"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M427.713 99.3585L425.346 99.157L424.338 97.0065L425.696 95.0577L428.062 95.2593L429.071 97.4096L427.713 99.3585Z",
    fill: "white"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M103.048 323.984L98.1539 323.567L96.0677 319.12L98.8759 315.09L103.771 315.506L105.857 319.954L103.048 323.984Z",
    fill: "white"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M102.168 334.329L97.273 333.912L95.1868 329.464L97.9951 325.434L102.89 325.851L104.976 330.298L102.168 334.329Z",
    fill: "white"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M101.287 344.673L96.3919 344.256L94.3057 339.809L97.114 335.779L102.009 336.196L104.095 340.643L101.287 344.673Z",
    fill: "white"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M538.342 188.805L533.447 188.388L531.361 183.941L534.169 179.91L539.064 180.327L541.15 184.774L538.342 188.805Z",
    fill: "white"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M100.405 355.018L95.5108 354.601L93.4246 350.154L96.2329 346.123L101.127 346.54L103.214 350.988L100.405 355.018Z",
    fill: "white"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M547.741 184.395L542.847 183.979L540.761 179.531L543.569 175.501L548.463 175.918L550.55 180.365L547.741 184.395Z",
    fill: "white"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5243 365.363L94.6297 364.946L92.5435 360.499L95.3518 356.468L100.246 356.885L102.333 361.332L99.5243 365.363Z",
    fill: "white"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M557.14 179.986L552.246 179.569L550.159 175.122L552.968 171.092L557.862 171.508L559.949 175.956L557.14 179.986Z",
    fill: "white"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6432 375.707L93.7486 375.29L91.6624 370.843L94.4707 366.813L99.3653 367.23L101.451 371.677L98.6432 375.707Z",
    fill: "white"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7624 386.052L92.8678 385.635L90.7815 381.188L93.5898 377.157L98.4844 377.574L100.571 382.022L97.7624 386.052Z",
    fill: "white"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4821 400.806L82.5875 400.389L80.5013 395.942L83.3095 391.911L88.2041 392.328L90.2903 396.775L87.4821 400.806Z",
    fill: "white"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0001 406.741L91.1056 406.324L89.0194 401.877L91.8276 397.847L96.7222 398.264L98.8084 402.711L96.0001 406.741Z",
    fill: "white"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M104.518 412.677L99.6236 412.26L97.5374 407.812L100.346 403.782L105.24 404.199L107.326 408.646L104.518 412.677Z",
    fill: "white"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M113.036 418.612L108.142 418.195L106.055 413.748L108.864 409.717L113.758 410.134L115.845 414.582L113.036 418.612Z",
    fill: "white"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M121.554 424.547L116.66 424.13L114.574 419.683L117.382 415.653L122.276 416.07L124.363 420.517L121.554 424.547Z",
    fill: "white"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M130.072 430.483L125.178 430.066L123.092 425.618L125.9 421.588L130.794 422.005L132.881 426.452L130.072 430.483Z",
    fill: "white"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M138.591 436.418L133.697 436.001L131.61 431.554L134.419 427.523L139.313 427.94L141.399 432.387L138.591 436.418Z",
    fill: "white"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M147.109 442.353L142.214 441.936L140.128 437.489L142.936 433.459L147.831 433.876L149.917 438.323L147.109 442.353Z",
    fill: "white"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M155.627 448.289L150.733 447.872L148.647 443.424L151.455 439.394L156.349 439.811L158.436 444.258L155.627 448.289Z",
    fill: "white"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M164.145 454.224L159.251 453.807L157.165 449.36L159.973 445.329L164.867 445.746L166.954 450.193L164.145 454.224Z",
    fill: "white"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M172.664 460.159L167.769 459.742L165.683 455.295L168.491 451.265L173.386 451.682L175.472 456.129L172.664 460.159Z",
    fill: "white"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M181.182 466.094L176.287 465.678L174.201 461.23L177.009 457.2L181.904 457.617L183.99 462.064L181.182 466.094Z",
    fill: "white"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M189.7 472.03L184.806 471.613L182.72 467.166L185.528 463.135L190.422 463.552L192.509 468L189.7 472.03Z",
    fill: "white"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M198.218 477.965L193.324 477.548L191.238 473.101L194.046 469.071L198.94 469.488L201.027 473.935L198.218 477.965Z",
    fill: "white"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M206.737 483.901L201.842 483.484L199.756 479.036L202.564 475.006L207.459 475.423L209.545 479.87L206.737 483.901Z",
    fill: "white"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M215.255 489.836L210.36 489.419L208.274 484.972L211.082 480.941L215.977 481.358L218.063 485.805L215.255 489.836Z",
    fill: "white"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M223.773 495.771L218.878 495.354L216.792 490.907L219.6 486.877L224.495 487.294L226.581 491.741L223.773 495.771Z",
    fill: "white"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M232.291 501.707L227.397 501.29L225.31 496.843L228.119 492.812L233.013 493.229L235.099 497.676L232.291 501.707Z",
    fill: "white"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M240.81 507.642L235.915 507.225L233.829 502.778L236.637 498.747L241.532 499.164L243.618 503.612L240.81 507.642Z",
    fill: "white"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M249.328 513.577L244.433 513.16L242.347 508.713L245.155 504.683L250.05 505.1L252.136 509.547L249.328 513.577Z",
    fill: "white"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M257.845 519.513L252.951 519.096L250.865 514.649L253.673 510.618L258.567 511.035L260.654 515.482L257.845 519.513Z",
    fill: "white"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M266.363 525.448L261.469 525.031L259.383 520.584L262.191 516.553L267.085 516.97L269.172 521.418L266.363 525.448Z",
    fill: "white"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M274.882 531.383L269.987 530.966L267.901 526.519L270.709 522.489L275.604 522.906L277.69 527.353L274.882 531.383Z",
    fill: "white"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M283.401 537.319L278.506 536.902L276.42 532.455L279.228 528.424L284.123 528.841L286.209 533.288L283.401 537.319Z",
    fill: "white"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M291.919 543.254L287.024 542.837L284.938 538.39L287.746 534.36L292.641 534.776L294.727 539.224L291.919 543.254Z",
    fill: "white"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M300.437 549.189L295.542 548.772L293.456 544.325L296.264 540.295L301.159 540.712L303.245 545.159L300.437 549.189Z",
    fill: "white"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M309.836 544.78L304.941 544.363L302.855 539.916L305.663 535.886L310.558 536.302L312.644 540.75L309.836 544.78Z",
    fill: "white"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M319.235 540.371L314.34 539.954L312.254 535.507L315.062 531.476L319.957 531.893L322.043 536.34L319.235 540.371Z",
    fill: "white"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M328.634 535.961L323.739 535.544L321.653 531.097L324.462 527.067L329.356 527.484L331.442 531.931L328.634 535.961Z",
    fill: "white"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M338.034 531.552L333.139 531.135L331.053 526.688L333.861 522.658L338.756 523.074L340.842 527.522L338.034 531.552Z",
    fill: "white"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M347.433 527.143L342.538 526.726L340.452 522.279L343.26 518.248L348.155 518.665L350.241 523.112L347.433 527.143Z",
    fill: "white"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M356.832 522.733L351.938 522.317L349.851 517.869L352.66 513.839L357.554 514.256L359.641 518.703L356.832 522.733Z",
    fill: "white"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M366.231 518.324L361.337 517.907L359.25 513.46L362.059 509.43L366.953 509.846L369.039 514.294L366.231 518.324Z",
    fill: "white"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M552.158 242.409L547.264 241.992L545.178 237.545L547.986 233.514L552.88 233.931L554.967 238.378L552.158 242.409Z",
    fill: "white"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M553.039 232.064L548.145 231.647L546.058 227.2L548.867 223.169L553.761 223.586L555.847 228.034L553.039 232.064Z",
    fill: "white"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M570.338 134.909L565.444 134.492L563.357 130.045L566.166 126.014L571.06 126.431L573.146 130.879L570.338 134.909Z",
    fill: "white"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M580.223 131.103L575.328 130.686L573.242 126.239L576.05 122.208L580.945 122.625L583.031 127.073L580.223 131.103Z",
    fill: "white"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M736.177 195.844L731.282 195.427L729.196 190.98L732.004 186.95L736.899 187.367L738.985 191.814L736.177 195.844Z",
    fill: "white"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M514.854 150.664L509.959 150.247L507.873 145.8L510.681 141.77L515.576 142.186L517.662 146.634L514.854 150.664Z",
    fill: "white"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M727.659 189.909L722.764 189.492L720.678 185.045L723.486 181.014L728.381 181.431L730.467 185.879L727.659 189.909Z",
    fill: "white"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M506.335 144.729L501.441 144.312L499.354 139.865L502.163 135.834L507.057 136.251L509.143 140.698L506.335 144.729Z",
    fill: "white"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M719.14 183.974L714.246 183.557L712.159 179.11L714.968 175.079L719.862 175.496L721.949 179.943L719.14 183.974Z",
    fill: "white"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M546.86 194.74L541.965 194.323L539.879 189.876L542.687 185.846L547.582 186.263L549.668 190.71L546.86 194.74Z",
    fill: "white"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M497.816 138.793L492.922 138.376L490.836 133.929L493.644 129.899L498.538 130.316L500.625 134.763L497.816 138.793Z",
    fill: "white"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M544.783 117.103L539.888 116.686L537.802 112.239L540.61 108.208L545.505 108.625L547.591 113.073L544.783 117.103Z",
    fill: "white"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M556.259 190.331L551.365 189.914L549.279 185.467L552.087 181.436L556.981 181.853L559.068 186.3L556.259 190.331Z",
    fill: "white"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M710.622 178.038L705.727 177.621L703.641 173.174L706.449 169.144L711.344 169.561L713.43 174.008L710.622 178.038Z",
    fill: "white"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M565.659 185.922L560.764 185.505L558.678 181.058L561.486 177.027L566.381 177.444L568.467 181.891L565.659 185.922Z",
    fill: "white"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M489.299 132.858L484.404 132.441L482.318 127.994L485.126 123.964L490.021 124.38L492.107 128.828L489.299 132.858Z",
    fill: "white"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M575.058 181.512L570.164 181.095L568.077 176.648L570.886 172.618L575.78 173.034L577.867 177.482L575.058 181.512Z",
    fill: "white"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M702.104 172.103L697.21 171.686L695.123 167.239L697.932 163.208L702.826 163.625L704.912 168.072L702.104 172.103Z",
    fill: "white"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M584.457 177.103L579.563 176.686L577.476 172.239L580.285 168.208L585.179 168.625L587.266 173.073L584.457 177.103Z",
    fill: "white"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M480.781 126.923L475.886 126.506L473.8 122.059L476.608 118.028L481.503 118.445L483.589 122.892L480.781 126.923Z",
    fill: "white"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M472.262 120.987L467.368 120.57L465.282 116.123L468.09 112.093L472.984 112.51L475.071 116.957L472.262 120.987Z",
    fill: "white"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M463.744 115.052L458.849 114.635L456.763 110.188L459.571 106.158L464.466 106.574L466.552 111.022L463.744 115.052Z",
    fill: "white"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M455.226 109.117L450.331 108.7L448.245 104.253L451.053 100.222L455.948 100.639L458.034 105.086L455.226 109.117Z",
    fill: "#3B82F6"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M446.708 103.181L441.814 102.765L439.727 98.3172L442.536 94.2869L447.43 94.7038L449.517 99.151L446.708 103.181Z",
    fill: "white"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M438.19 97.2461L433.295 96.8292L431.209 92.3819L434.017 88.3516L438.912 88.7685L440.998 93.2157L438.19 97.2461Z",
    fill: "white"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6493 328.393L88.7547 327.977L86.6685 323.529L89.4768 319.499L94.3714 319.916L96.4576 324.363L93.6493 328.393Z",
    fill: "white"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7685 338.738L87.8739 338.321L85.7877 333.874L88.5959 329.844L93.4905 330.26L95.5767 334.708L92.7685 338.738Z",
    fill: "white"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8874 349.083L86.9928 348.666L84.9065 344.219L87.7148 340.188L92.6094 340.605L94.6956 345.052L91.8874 349.083Z",
    fill: "white"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0063 359.427L86.1117 359.01L84.0254 354.563L86.8337 350.533L91.7283 350.95L93.8145 355.397L91.0063 359.427Z",
    fill: "white"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1252 369.772L85.2306 369.355L83.1444 364.908L85.9526 360.877L90.8472 361.294L92.9334 365.742L90.1252 369.772Z",
    fill: "white"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M89.244 380.116L84.3494 379.7L82.2632 375.252L85.0715 371.222L89.9661 371.639L92.0523 376.086L89.244 380.116Z",
    fill: "white"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3632 390.461L83.4686 390.044L81.3824 385.597L84.1906 381.567L89.0852 381.984L91.1714 386.431L88.3632 390.461Z",
    fill: "white"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0824 405.215L73.1878 404.798L71.1016 400.351L73.9099 396.321L78.8045 396.738L80.8907 401.185L78.0824 405.215Z",
    fill: "white"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M86.601 411.151L81.7064 410.734L79.6202 406.286L82.4284 402.256L87.323 402.673L89.4092 407.12L86.601 411.151Z",
    fill: "white"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M95.119 417.086L90.2244 416.669L88.1383 412.222L90.9465 408.191L95.8411 408.608L97.9273 413.056L95.119 417.086Z",
    fill: "white"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M103.637 423.021L98.7425 422.604L96.6563 418.157L99.4646 414.127L104.359 414.544L106.445 418.991L103.637 423.021Z",
    fill: "white"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M112.155 428.957L107.261 428.54L105.174 424.092L107.983 420.062L112.877 420.479L114.964 424.926L112.155 428.957Z",
    fill: "white"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M120.673 434.892L115.779 434.475L113.692 430.028L116.501 425.997L121.395 426.414L123.482 430.861L120.673 434.892Z",
    fill: "white"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M129.192 440.827L124.297 440.41L122.211 435.963L125.019 431.933L129.914 432.35L132 436.797L129.192 440.827Z",
    fill: "white"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M137.71 446.763L132.816 446.346L130.729 441.898L133.538 437.868L138.432 438.285L140.518 442.732L137.71 446.763Z",
    fill: "white"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M146.228 452.698L141.333 452.281L139.247 447.834L142.055 443.803L146.95 444.22L149.036 448.667L146.228 452.698Z",
    fill: "white"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M154.746 458.633L149.852 458.216L147.765 453.769L150.574 449.739L155.468 450.156L157.554 454.603L154.746 458.633Z",
    fill: "white"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M163.264 464.568L158.37 464.152L156.284 459.704L159.092 455.674L163.986 456.091L166.073 460.538L163.264 464.568Z",
    fill: "white"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M171.783 470.504L166.888 470.087L164.802 465.64L167.61 461.609L172.505 462.026L174.591 466.474L171.783 470.504Z",
    fill: "white"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M180.301 476.439L175.406 476.022L173.32 471.575L176.128 467.545L181.023 467.961L183.109 472.409L180.301 476.439Z",
    fill: "white"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M188.819 482.375L183.925 481.958L181.838 477.51L184.647 473.48L189.541 473.897L191.628 478.344L188.819 482.375Z",
    fill: "white"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M197.337 488.31L192.443 487.893L190.357 483.446L193.165 479.415L198.059 479.832L200.146 484.279L197.337 488.31Z",
    fill: "white"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M205.856 494.245L200.961 493.828L198.875 489.381L201.683 485.351L206.578 485.768L208.664 490.215L205.856 494.245Z",
    fill: "white"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M214.373 500.181L209.479 499.764L207.393 495.316L210.201 491.286L215.095 491.703L217.182 496.15L214.373 500.181Z",
    fill: "white"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M222.891 506.116L217.997 505.699L215.911 501.252L218.719 497.221L223.614 497.638L225.7 502.086L222.891 506.116Z",
    fill: "white"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M231.41 512.051L226.516 511.634L224.429 507.187L227.238 503.157L232.132 503.574L234.219 508.021L231.41 512.051Z",
    fill: "white"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M239.929 517.987L235.034 517.57L232.948 513.123L235.756 509.092L240.651 509.509L242.737 513.956L239.929 517.987Z",
    fill: "white"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M248.447 523.922L243.552 523.505L241.466 519.058L244.274 515.027L249.169 515.444L251.255 519.892L248.447 523.922Z",
    fill: "white"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M256.965 529.857L252.07 529.44L249.984 524.993L252.792 520.963L257.687 521.38L259.773 525.827L256.965 529.857Z",
    fill: "white"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M265.483 535.793L260.588 535.376L258.502 530.929L261.31 526.898L266.205 527.315L268.291 531.762L265.483 535.793Z",
    fill: "white"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M274.001 541.728L269.106 541.311L267.02 536.864L269.828 532.833L274.723 533.25L276.809 537.697L274.001 541.728Z",
    fill: "#EF4444"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M282.519 547.663L277.625 547.246L275.538 542.799L278.347 538.769L283.241 539.186L285.328 543.633L282.519 547.663Z",
    fill: "white"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M291.037 553.599L286.143 553.182L284.056 548.735L286.865 544.704L291.759 545.121L293.845 549.568L291.037 553.599Z",
    fill: "white"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M299.555 559.534L294.661 559.117L292.575 554.67L295.383 550.639L300.277 551.056L302.364 555.504L299.555 559.534Z",
    fill: "white"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M308.955 555.125L304.06 554.708L301.974 550.261L304.782 546.23L309.677 546.647L311.763 551.094L308.955 555.125Z",
    fill: "white"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M318.354 550.715L313.459 550.298L311.373 545.851L314.181 541.821L319.076 542.238L321.162 546.685L318.354 550.715Z",
    fill: "white"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M327.753 546.306L322.859 545.889L320.772 541.442L323.581 537.412L328.475 537.828L330.561 542.276L327.753 546.306Z",
    fill: "white"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M545.979 205.085L541.085 204.668L538.998 200.221L541.807 196.19L546.701 196.607L548.787 201.054L545.979 205.085Z",
    fill: "white"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M337.153 541.897L332.258 541.48L330.172 537.033L332.98 533.002L337.875 533.419L339.961 537.867L337.153 541.897Z",
    fill: "white"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M555.378 200.675L550.484 200.259L548.397 195.811L551.206 191.781L556.1 192.198L558.186 196.645L555.378 200.675Z",
    fill: "white"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M564.778 196.266L559.883 195.849L557.797 191.402L560.605 187.372L565.5 187.789L567.586 192.236L564.778 196.266Z",
    fill: "white"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M346.552 537.487L341.657 537.07L339.571 532.623L342.379 528.593L347.274 529.01L349.36 533.457L346.552 537.487Z",
    fill: "white"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M574.177 191.857L569.282 191.44L567.196 186.993L570.004 182.962L574.899 183.379L576.985 187.826L574.177 191.857Z",
    fill: "white"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M583.576 187.448L578.682 187.031L576.596 182.584L579.404 178.553L584.298 178.97L586.385 183.417L583.576 187.448Z",
    fill: "white"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M355.951 533.078L351.056 532.661L348.97 528.214L351.778 524.184L356.673 524.601L358.759 529.048L355.951 533.078Z",
    fill: "white"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M592.975 183.038L588.081 182.621L585.994 178.174L588.803 174.144L593.697 174.561L595.783 179.008L592.975 183.038Z",
    fill: "white"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M602.313 178.498L597.563 178.093L595.539 173.777L598.264 169.866L603.014 170.27L605.039 174.586L602.313 178.498Z",
    fill: "white"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M594.125 172.834L589.375 172.43L587.35 168.114L590.076 164.202L594.826 164.607L596.85 168.923L594.125 172.834Z",
    fill: "white"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M603.125 167.834L598.375 167.43L596.35 163.114L599.076 159.202L603.826 159.607L605.85 163.923L603.125 167.834Z",
    fill: "white"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M594.125 161.834L589.375 161.43L587.35 157.114L590.076 153.202L594.826 153.607L596.85 157.923L594.125 161.834Z",
    fill: "white"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M586.125 166.834L581.375 166.43L579.35 162.114L582.076 158.202L586.826 158.607L588.85 162.923L586.125 166.834Z",
    fill: "white"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M365.35 528.669L360.456 528.252L358.369 523.805L361.178 519.774L366.072 520.191L368.158 524.638L365.35 528.669Z",
    fill: "#EF4444"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M551.342 262.45L546.447 262.033L544.361 257.586L547.169 253.556L552.064 253.973L554.15 258.42L551.342 262.45Z",
    fill: "white"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M552.225 252.108L547.327 251.691L545.24 247.241L548.05 243.209L552.947 243.626L555.035 248.075L552.225 252.108Z",
    fill: "white"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M745.576 191.435L740.681 191.018L738.595 186.571L741.403 182.54L746.298 182.957L748.384 187.405L745.576 191.435Z",
    fill: "white"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M737.058 185.5L732.163 185.083L730.077 180.636L732.885 176.605L737.78 177.022L739.866 181.469L737.058 185.5Z",
    fill: "white"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M515.735 140.319L510.84 139.903L508.754 135.455L511.562 131.425L516.457 131.842L518.543 136.289L515.735 140.319Z",
    fill: "white"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M728.54 179.564L723.645 179.147L721.559 174.7L724.367 170.67L729.262 171.087L731.348 175.534L728.54 179.564Z",
    fill: "white"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M507.216 134.384L502.322 133.967L500.235 129.52L503.044 125.49L507.938 125.906L510.024 130.354L507.216 134.384Z",
    fill: "white"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M674.015 185.485L669.121 185.068L667.034 180.621L669.843 176.59L674.737 177.007L676.824 181.454L674.015 185.485Z",
    fill: "white"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M498.697 128.449L493.803 128.032L491.717 123.585L494.525 119.554L499.419 119.971L501.506 124.418L498.697 128.449Z",
    fill: "white"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M665.497 179.549L660.602 179.133L658.516 174.685L661.324 170.655L666.219 171.072L668.305 175.519L665.497 179.549Z",
    fill: "white"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M490.18 122.513L485.285 122.097L483.199 117.649L486.007 113.619L490.902 114.036L492.988 118.483L490.18 122.513Z",
    fill: "#EF4444"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M657.342 174.103L652.448 173.686L650.361 169.239L653.17 165.208L658.064 165.625L660.15 170.072L657.342 174.103Z",
    fill: "white"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M481.662 116.578L476.767 116.161L474.681 111.714L477.489 107.684L482.384 108.1L484.47 112.548L481.662 116.578Z",
    fill: "white"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M473.144 110.643L468.249 110.226L466.163 105.779L468.971 101.748L473.866 102.165L475.952 106.612L473.144 110.643Z",
    fill: "white"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M464.625 104.707L459.731 104.29L457.644 99.8431L460.453 95.8128L465.347 96.2297L467.434 100.677L464.625 104.707Z",
    fill: "white"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M456.107 98.7721L451.213 98.3552L449.126 93.9079L451.935 89.8776L456.829 90.2945L458.915 94.7417L456.107 98.7721Z",
    fill: "white"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M447.59 92.8368L442.695 92.4199L440.609 87.9726L443.417 83.9423L448.312 84.3592L450.398 88.8064L447.59 92.8368Z",
    fill: "white"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9686 322.112L80.455 321.727L78.5311 317.626L81.1209 313.91L85.6345 314.294L87.5584 318.395L84.9686 322.112Z",
    fill: "white"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2497 332.803L79.3551 332.386L77.2689 327.938L80.0771 323.908L84.9717 324.325L87.0579 328.772L84.2497 332.803Z",
    fill: "white"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3688 343.147L78.4742 342.73L76.388 338.283L79.1962 334.253L84.0908 334.67L86.177 339.117L83.3688 343.147Z",
    fill: "white"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4877 353.492L77.5931 353.075L75.5069 348.628L78.3151 344.597L83.2097 345.014L85.2959 349.462L82.4877 353.492Z",
    fill: "white"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6066 363.837L76.712 363.42L74.6258 358.973L77.434 354.942L82.3286 355.359L84.4148 359.806L81.6066 363.837Z",
    fill: "white"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7255 374.181L75.8309 373.764L73.7447 369.317L76.5529 365.287L81.4475 365.704L83.5337 370.151L80.7255 374.181Z",
    fill: "white"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8444 384.526L74.9498 384.109L72.8636 379.662L75.6718 375.631L80.5664 376.048L82.6526 380.495L79.8444 384.526Z",
    fill: "white"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9633 394.87L74.0687 394.453L71.9825 390.006L74.7907 385.976L79.6853 386.393L81.7715 390.84L78.9633 394.87Z",
    fill: "white"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2013 415.56L72.3067 415.143L70.2205 410.696L73.0288 406.665L77.9234 407.082L80.0096 411.529L77.2013 415.56Z",
    fill: "white"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2379 427.431L89.3433 427.014L87.2572 422.566L90.0654 418.536L94.96 418.953L97.0462 423.4L94.2379 427.431Z",
    fill: "white"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M102.756 433.366L97.8614 432.949L95.7752 428.502L98.5835 424.471L103.478 424.888L105.564 429.335L102.756 433.366Z",
    fill: "white"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M111.274 439.301L106.38 438.884L104.294 434.437L107.102 430.407L111.996 430.824L114.083 435.271L111.274 439.301Z",
    fill: "white"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 445.236L114.898 444.82L112.812 440.372L115.62 436.342L120.514 436.759L122.601 441.206L119.792 445.236Z",
    fill: "white"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M128.31 451.172L123.416 450.755L121.33 446.308L124.138 442.277L129.033 442.694L131.119 447.141L128.31 451.172Z",
    fill: "white"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M136.829 457.107L131.934 456.69L129.848 452.243L132.656 448.213L137.551 448.63L139.637 453.077L136.829 457.107Z",
    fill: "white"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M145.347 463.042L140.452 462.626L138.366 458.178L141.174 454.148L146.069 454.565L148.155 459.012L145.347 463.042Z",
    fill: "white"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M153.865 468.978L148.971 468.561L146.884 464.114L149.693 460.083L154.587 460.5L156.673 464.948L153.865 468.978Z",
    fill: "white"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M162.383 474.913L157.489 474.496L155.402 470.049L158.211 466.019L163.105 466.435L165.191 470.883L162.383 474.913Z",
    fill: "white"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M170.902 480.848L166.007 480.432L163.921 475.984L166.729 471.954L171.624 472.371L173.71 476.818L170.902 480.848Z",
    fill: "white"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M179.42 486.784L174.525 486.367L172.439 481.92L175.247 477.889L180.142 478.306L182.228 482.753L179.42 486.784Z",
    fill: "white"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M187.938 492.719L183.044 492.302L180.957 487.855L183.766 483.825L188.66 484.242L190.747 488.689L187.938 492.719Z",
    fill: "white"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M196.456 498.655L191.562 498.238L189.475 493.79L192.284 489.76L197.178 490.177L199.265 494.624L196.456 498.655Z",
    fill: "white"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M213.492 510.525L208.598 510.108L206.512 505.661L209.32 501.631L214.214 502.047L216.301 506.495L213.492 510.525Z",
    fill: "white"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M222.011 516.46L217.116 516.044L215.03 511.596L217.838 507.566L222.733 507.983L224.819 512.43L222.011 516.46Z",
    fill: "white"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M230.529 522.396L225.635 521.979L223.548 517.532L226.357 513.501L231.251 513.918L233.337 518.366L230.529 522.396Z",
    fill: "white"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M239.047 528.331L234.153 527.914L232.066 523.467L234.875 519.437L239.769 519.854L241.856 524.301L239.047 528.331Z",
    fill: "white"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M554.497 211.02L549.603 210.603L547.516 206.156L550.325 202.126L555.219 202.543L557.306 206.99L554.497 211.02Z",
    fill: "white"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M563.897 206.611L559.003 206.194L556.916 201.747L559.725 197.716L564.619 198.133L566.705 202.58L563.897 206.611Z",
    fill: "white"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M247.565 534.267L242.671 533.85L240.585 529.403L243.393 525.372L248.288 525.789L250.374 530.236L247.565 534.267Z",
    fill: "white"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M573.296 202.202L568.401 201.785L566.315 197.337L569.123 193.307L574.018 193.724L576.104 198.171L573.296 202.202Z",
    fill: "white"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M582.695 197.792L577.801 197.375L575.715 192.928L578.523 188.898L583.417 189.315L585.504 193.762L582.695 197.792Z",
    fill: "white"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M256.083 540.202L251.189 539.785L249.103 535.338L251.911 531.307L256.805 531.724L258.892 536.171L256.083 540.202Z",
    fill: "white"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M592.094 193.383L587.2 192.966L585.114 188.519L587.922 184.488L592.816 184.905L594.903 189.352L592.094 193.383Z",
    fill: "white"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M601.494 188.974L596.6 188.557L594.513 184.11L597.322 180.079L602.216 180.496L604.303 184.943L601.494 188.974Z",
    fill: "white"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M264.602 546.137L259.707 545.72L257.621 541.273L260.429 537.243L265.324 537.66L267.41 542.107L264.602 546.137Z",
    fill: "white"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M273.12 552.073L268.225 551.656L266.139 547.208L268.947 543.178L273.842 543.595L275.928 548.042L273.12 552.073Z",
    fill: "white"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M281.638 558.008L276.744 557.591L274.658 553.144L277.466 549.113L282.36 549.53L284.447 553.978L281.638 558.008Z",
    fill: "white"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M290.156 563.943L285.262 563.526L283.176 559.079L285.984 555.049L290.878 555.466L292.965 559.913L290.156 563.943Z",
    fill: "white"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M297.597 567.582L295.23 567.38L294.221 565.23L295.579 563.281L297.946 563.483L298.955 565.633L297.597 567.582Z",
    fill: "white"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M308.073 565.469L303.179 565.052L301.093 560.605L303.901 556.575L308.795 556.992L310.882 561.439L308.073 565.469Z",
    fill: "white"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M317.473 561.06L312.578 560.643L310.492 556.196L313.3 552.165L318.195 552.582L320.281 557.03L317.473 561.06Z",
    fill: "white"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M326.872 556.651L321.977 556.234L319.891 551.787L322.699 547.756L327.594 548.173L329.68 552.62L326.872 556.651Z",
    fill: "white"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M336.272 552.241L331.377 551.824L329.291 547.377L332.099 543.347L336.994 543.764L339.08 548.211L336.272 552.241Z",
    fill: "white"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M345.671 547.832L340.776 547.415L338.69 542.968L341.498 538.938L346.393 539.355L348.479 543.802L345.671 547.832Z",
    fill: "white"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M355.07 543.423L350.175 543.006L348.089 538.559L350.897 534.528L355.792 534.945L357.878 539.393L355.07 543.423Z",
    fill: "white"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M364.469 539.013L359.574 538.597L357.488 534.149L360.296 530.119L365.191 530.536L367.277 534.983L364.469 539.013Z",
    fill: "white"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M373.807 534.473L369.057 534.068L367.032 529.752L369.758 525.841L374.508 526.245L376.532 530.561L373.807 534.473Z",
    fill: "white"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M560.174 246.654L556.058 246.304L554.303 242.564L556.665 239.175L560.781 239.526L562.535 243.265L560.174 246.654Z",
    fill: "white"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M560.741 258.041L555.847 257.624L553.761 253.177L556.569 249.147L561.463 249.564L563.55 254.011L560.741 258.041Z",
    fill: "white"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M737.939 175.155L733.045 174.738L730.958 170.291L733.767 166.261L738.661 166.677L740.748 171.125L737.939 175.155Z",
    fill: "white"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M516.616 129.975L511.721 129.558L509.635 125.111L512.443 121.08L517.338 121.497L519.424 125.944L516.616 129.975Z",
    fill: "white"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M683.415 181.075L678.521 180.659L676.434 176.211L679.243 172.181L684.137 172.598L686.224 177.045L683.415 181.075Z",
    fill: "white"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M508.097 124.039L503.203 123.623L501.117 119.175L503.925 115.145L508.819 115.562L510.906 120.009L508.097 124.039Z",
    fill: "white"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M674.897 175.14L670.002 174.723L667.916 170.276L670.724 166.246L675.619 166.663L677.705 171.11L674.897 175.14Z",
    fill: "white"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M499.578 118.104L494.684 117.687L492.597 113.24L495.406 109.21L500.3 109.626L502.387 114.074L499.578 118.104Z",
    fill: "white"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M666.377 169.205L661.483 168.788L659.397 164.341L662.205 160.31L667.099 160.727L669.186 165.174L666.377 169.205Z",
    fill: "white"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M491.061 112.169L486.166 111.752L484.08 107.305L486.888 103.274L491.783 103.691L493.869 108.138L491.061 112.169Z",
    fill: "white"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M657.86 163.269L652.965 162.853L650.879 158.405L653.687 154.375L658.582 154.792L660.668 159.239L657.86 163.269Z",
    fill: "white"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M482.543 106.233L477.648 105.817L475.562 101.369L478.37 97.3389L483.265 97.7558L485.351 102.203L482.543 106.233Z",
    fill: "white"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M649.342 157.334L644.447 156.917L642.361 152.47L645.169 148.44L650.064 148.857L652.15 153.304L649.342 157.334Z",
    fill: "white"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M640.342 161.137L635.447 160.72L633.361 156.273L636.169 152.242L641.064 152.659L643.15 157.106L640.342 161.137Z",
    fill: "white"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M639.342 171.103L634.447 170.686L632.361 166.239L635.169 162.208L640.064 162.625L642.15 167.072L639.342 171.103Z",
    fill: "white"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M648.342 167.103L643.447 166.686L641.361 162.239L644.169 158.208L649.064 158.625L651.15 163.072L648.342 167.103Z",
    fill: "white"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M563.016 216.955L558.121 216.539L556.035 212.091L558.843 208.061L563.738 208.478L565.824 212.925L563.016 216.955Z",
    fill: "white"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M474.025 100.298L469.13 99.8812L467.044 95.4339L469.852 91.4036L474.747 91.8205L476.833 96.2677L474.025 100.298Z",
    fill: "white"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M572.415 212.546L567.521 212.129L565.434 207.682L568.243 203.652L573.137 204.069L575.224 208.516L572.415 212.546Z",
    fill: "white"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M465.506 94.3628L460.612 93.9459L458.525 89.4986L461.334 85.4683L466.228 85.8852L468.314 90.3324L465.506 94.3628Z",
    fill: "white"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M581.814 208.137L576.92 207.72L574.833 203.273L577.642 199.242L582.536 199.659L584.622 204.106L581.814 208.137Z",
    fill: "white"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M456.988 88.4274L452.093 88.0105L450.007 83.5632L452.816 79.5329L457.71 79.9498L459.796 84.3969L456.988 88.4274Z",
    fill: "white"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M591.214 203.728L586.319 203.311L584.233 198.863L587.041 194.833L591.936 195.25L594.022 199.697L591.214 203.728Z",
    fill: "white"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M448.471 82.4922L443.576 82.0753L441.49 77.628L444.298 73.5977L449.193 74.0146L451.279 78.4618L448.471 82.4922Z",
    fill: "white"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M600.613 199.318L595.718 198.901L593.632 194.454L596.44 190.424L601.335 190.841L603.421 195.288L600.613 199.318Z",
    fill: "white"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7316 326.867L70.837 326.45L68.7508 322.003L71.559 317.973L76.4536 318.39L78.5398 322.837L75.7316 326.867Z",
    fill: "white"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8505 337.212L69.9559 336.795L67.8697 332.348L70.6779 328.317L75.5725 328.734L77.6587 333.182L74.8505 337.212Z",
    fill: "white"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9696 347.557L69.075 347.14L66.9888 342.693L69.7971 338.662L74.6917 339.079L76.7779 343.526L73.9696 347.557Z",
    fill: "#3B82F6"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0885 357.901L68.1939 357.484L66.1077 353.037L68.916 349.007L73.8106 349.424L75.8968 353.871L73.0885 357.901Z",
    fill: "white"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2074 368.246L67.3128 367.829L65.2266 363.382L68.0349 359.351L72.9295 359.768L75.0157 364.216L72.2074 368.246Z",
    fill: "white"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3679 386.638L67.0012 386.437L65.9924 384.286L67.3504 382.338L69.717 382.539L70.7258 384.689L69.3679 386.638Z",
    fill: "white"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7248 417.672L64.3582 417.471L63.3494 415.32L64.7073 413.372L67.0739 413.573L68.0827 415.723L66.7248 417.672Z",
    fill: "white"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3568 437.775L88.4622 437.358L86.376 432.911L89.1843 428.881L94.0789 429.298L96.1651 433.745L93.3568 437.775Z",
    fill: "white"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M101.875 443.71L96.9806 443.294L94.8944 438.846L97.7026 434.816L102.597 435.233L104.683 439.68L101.875 443.71Z",
    fill: "white"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M110.393 449.646L105.499 449.229L103.412 444.782L106.221 440.751L111.115 441.168L113.202 445.615L110.393 449.646Z",
    fill: "white"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M118.911 455.581L114.017 455.164L111.93 450.717L114.739 446.687L119.633 447.103L121.72 451.551L118.911 455.581Z",
    fill: "white"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M127.429 461.516L122.535 461.099L120.449 456.652L123.257 452.622L128.151 453.039L130.238 457.486L127.429 461.516Z",
    fill: "white"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M135.948 467.452L131.053 467.035L128.967 462.588L131.775 458.557L136.67 458.974L138.756 463.422L135.948 467.452Z",
    fill: "white"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M144.465 473.387L139.571 472.97L137.485 468.523L140.293 464.492L145.188 464.909L147.274 469.357L144.465 473.387Z",
    fill: "white"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M152.984 479.322L148.09 478.906L146.003 474.458L148.812 470.428L153.706 470.845L155.793 475.292L152.984 479.322Z",
    fill: "white"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M161.502 485.258L156.608 484.841L154.522 480.394L157.33 476.363L162.224 476.78L164.311 481.227L161.502 485.258Z",
    fill: "white"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M170.021 491.193L165.126 490.776L163.04 486.329L165.848 482.299L170.743 482.716L172.829 487.163L170.021 491.193Z",
    fill: "white"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M178.538 497.128L173.644 496.712L171.558 492.264L174.366 488.234L179.261 488.651L181.347 493.098L178.538 497.128Z",
    fill: "white"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M187.057 503.064L182.163 502.647L180.076 498.2L182.885 494.169L187.779 494.586L189.865 499.033L187.057 503.064Z",
    fill: "white"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M194.497 506.702L192.131 506.501L191.122 504.35L192.48 502.402L194.847 502.603L195.855 504.754L194.497 506.702Z",
    fill: "white"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M221.13 526.805L216.235 526.388L214.149 521.941L216.957 517.911L221.852 518.327L223.938 522.775L221.13 526.805Z",
    fill: "white"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M229.648 532.741L224.754 532.324L222.667 527.877L225.476 523.846L230.37 524.263L232.456 528.71L229.648 532.741Z",
    fill: "white"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M238.166 538.676L233.272 538.259L231.185 533.812L233.994 529.781L238.888 530.198L240.975 534.645L238.166 538.676Z",
    fill: "white"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M246.684 544.611L241.79 544.194L239.703 539.747L242.512 535.717L247.406 536.134L249.493 540.581L246.684 544.611Z",
    fill: "white"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M255.202 550.547L250.308 550.13L248.222 545.682L251.03 541.652L255.924 542.069L258.011 546.516L255.202 550.547Z",
    fill: "white"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M263.72 556.482L258.826 556.065L256.74 551.618L259.548 547.587L264.442 548.004L266.529 552.451L263.72 556.482Z",
    fill: "white"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M272.238 562.417L267.344 562L265.258 557.553L268.066 553.523L272.961 553.94L275.047 558.387L272.238 562.417Z",
    fill: "white"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M280.757 568.353L275.862 567.936L273.776 563.488L276.584 559.458L281.479 559.875L283.565 564.322L280.757 568.353Z",
    fill: "white"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M289.135 573.99L284.569 573.601L282.622 569.452L285.242 565.691L289.809 566.08L291.755 570.23L289.135 573.99Z",
    fill: "white"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M325.991 566.995L321.096 566.579L319.01 562.131L321.818 558.101L326.713 558.518L328.799 562.965L325.991 566.995Z",
    fill: "white"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M554.346 221.515L549.449 221.098L547.361 216.648L550.171 212.615L555.069 213.032L557.156 217.482L554.346 221.515Z",
    fill: "white"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M610.342 185.103L605.447 184.686L603.361 180.239L606.169 176.208L611.064 176.625L613.15 181.073L610.342 185.103Z",
    fill: "white"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M620.342 180.103L615.447 179.686L613.361 175.239L616.169 171.208L621.064 171.625L623.15 176.073L620.342 180.103Z",
    fill: "white"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M611.342 174.103L606.447 173.686L604.361 169.239L607.169 165.208L612.064 165.625L614.15 170.073L611.342 174.103Z",
    fill: "white"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M610.342 195.103L605.447 194.686L603.361 190.239L606.169 186.208L611.064 186.625L613.15 191.073L610.342 195.103Z",
    fill: "white"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M335.391 562.586L330.496 562.169L328.41 557.722L331.218 553.691L336.113 554.108L338.199 558.556L335.391 562.586Z",
    fill: "white"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M344.79 558.177L339.895 557.76L337.809 553.313L340.617 549.282L345.512 549.699L347.598 554.146L344.79 558.177Z",
    fill: "white"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M354.189 553.767L349.295 553.35L347.208 548.903L350.017 544.873L354.911 545.29L356.998 549.737L354.189 553.767Z",
    fill: "white"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M363.588 549.358L358.693 548.941L356.607 544.494L359.415 540.464L364.31 540.881L366.396 545.328L363.588 549.358Z",
    fill: "white"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M372.988 544.949L368.093 544.532L366.007 540.085L368.815 536.055L373.71 536.471L375.796 540.919L372.988 544.949Z",
    fill: "white"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M526.015 125.565L521.12 125.149L519.034 120.701L521.842 116.671L526.737 117.088L528.823 121.535L526.015 125.565Z",
    fill: "white"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M692.814 176.666L687.92 176.249L685.833 171.802L688.642 167.772L693.536 168.189L695.623 172.636L692.814 176.666Z",
    fill: "white"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M517.497 119.63L512.602 119.213L510.516 114.766L513.324 110.736L518.219 111.153L520.305 115.6L517.497 119.63Z",
    fill: "white"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M684.296 170.731L679.402 170.314L677.315 165.867L680.124 161.836L685.018 162.253L687.104 166.7L684.296 170.731Z",
    fill: "white"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M508.978 113.695L504.084 113.278L501.997 108.831L504.806 104.8L509.7 105.217L511.787 109.664L508.978 113.695Z",
    fill: "white"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M675.777 164.796L670.883 164.379L668.797 159.931L671.605 155.901L676.5 156.318L678.586 160.765L675.777 164.796Z",
    fill: "white"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M500.459 107.759L495.565 107.343L493.479 102.895L496.287 98.8649L501.182 99.2818L503.268 103.729L500.459 107.759Z",
    fill: "white"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M667.259 158.86L662.364 158.443L660.278 153.996L663.086 149.966L667.981 150.382L670.067 154.83L667.259 158.86Z",
    fill: "white"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M491.942 101.824L487.047 101.407L484.961 96.96L487.769 92.9297L492.664 93.3466L494.75 97.7938L491.942 101.824Z",
    fill: "white"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M658.741 152.925L653.847 152.508L651.761 148.061L654.569 144.03L659.463 144.447L661.55 148.894L658.741 152.925Z",
    fill: "white"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M483.424 95.8888L478.529 95.4719L476.443 91.0246L479.251 86.9943L484.146 87.4112L486.232 91.8584L483.424 95.8888Z",
    fill: "white"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M650.223 146.99L645.329 146.573L643.243 142.125L646.051 138.095L650.945 138.512L653.032 142.959L650.223 146.99Z",
    fill: "white"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M641.223 150.792L636.329 150.375L634.243 145.928L637.051 141.898L641.945 142.315L644.032 146.762L641.223 150.792Z",
    fill: "white"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M474.906 89.9535L470.011 89.5366L467.925 85.0893L470.734 81.059L475.628 81.4759L477.714 85.9231L474.906 89.9535Z",
    fill: "white"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M466.387 84.0181L461.493 83.6012L459.407 79.1539L462.215 75.1236L467.109 75.5405L469.196 79.9876L466.387 84.0181Z",
    fill: "white"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M457.869 78.0828L452.975 77.6659L450.888 73.2186L453.697 69.1883L458.591 69.6052L460.678 74.0523L457.869 78.0828Z",
    fill: "white"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M449.351 72.1476L444.457 71.7307L442.37 67.2834L445.179 63.2531L450.073 63.67L452.16 68.1172L449.351 72.1476Z",
    fill: "white"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M440.638 65.7962L436.201 65.4183L434.31 61.387L436.856 57.7335L441.293 58.1114L443.184 62.1428L440.638 65.7962Z",
    fill: "white"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3324 331.277L61.4378 330.86L59.3516 326.412L62.1599 322.382L67.0545 322.799L69.1407 327.246L66.3324 331.277Z",
    fill: "white"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4513 341.621L60.5567 341.204L58.4705 336.757L61.2788 332.727L66.1734 333.144L68.2596 337.591L65.4513 341.621Z",
    fill: "white"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5705 351.966L59.6759 351.549L57.5897 347.102L60.3979 343.071L65.2925 343.488L67.3787 347.936L64.5705 351.966Z",
    fill: "white"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6894 362.31L58.7948 361.894L56.7086 357.446L59.5168 353.416L64.4114 353.833L66.4976 358.28L63.6894 362.31Z",
    fill: "white"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7582 372.548L57.9812 372.141L55.945 367.801L58.6859 363.867L63.4629 364.274L65.499 368.615L62.7582 372.548Z",
    fill: "white"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9577 442.184L79.0631 441.768L76.9769 437.32L79.7851 433.29L84.6797 433.707L86.7659 438.154L83.9577 442.184Z",
    fill: "white"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M92.476 448.12L87.5814 447.703L85.4952 443.255L88.3034 439.225L93.198 439.642L95.2842 444.089L92.476 448.12Z",
    fill: "white"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M100.994 454.055L96.0994 453.638L94.0133 449.191L96.8215 445.161L101.716 445.577L103.802 450.025L100.994 454.055Z",
    fill: "white"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M109.512 459.99L104.618 459.573L102.531 455.126L105.34 451.096L110.234 451.513L112.32 455.96L109.512 459.99Z",
    fill: "white"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M118.03 465.926L113.136 465.509L111.049 461.062L113.858 457.031L118.752 457.448L120.839 461.896L118.03 465.926Z",
    fill: "white"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M126.548 471.861L121.654 471.444L119.567 466.997L122.376 462.966L127.27 463.383L129.357 467.831L126.548 471.861Z",
    fill: "#3B82F6"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M135.067 477.796L130.172 477.38L128.086 472.932L130.894 468.902L135.789 469.319L137.875 473.766L135.067 477.796Z",
    fill: "#EF4444"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 483.732L138.69 483.315L136.604 478.868L139.412 474.837L144.306 475.254L146.393 479.701L143.584 483.732Z",
    fill: "white"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M152.103 489.667L147.209 489.25L145.122 484.803L147.931 480.773L152.825 481.19L154.911 485.637L152.103 489.667Z",
    fill: "white"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M560.55 223.402L558.183 223.2L557.175 221.05L558.533 219.101L560.899 219.302L561.908 221.453L560.55 223.402Z",
    fill: "white"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M579.55 214.402L577.183 214.2L576.175 212.05L577.533 210.101L579.899 210.302L580.908 212.453L579.55 214.402Z",
    fill: "white"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M671.55 192.402L669.183 192.2L668.175 190.05L669.533 188.101L671.899 188.302L672.908 190.453L671.55 192.402Z",
    fill: "white"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M160.621 495.602L155.727 495.186L153.64 490.738L156.449 486.708L161.343 487.125L163.429 491.572L160.621 495.602Z",
    fill: "white"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M169.139 501.538L164.245 501.121L162.159 496.674L164.967 492.643L169.861 493.06L171.948 497.507L169.139 501.538Z",
    fill: "white"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M177.657 507.473L172.763 507.056L170.677 502.609L173.485 498.579L178.379 498.995L180.466 503.443L177.657 507.473Z",
    fill: "white"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M219.859 536.319L215.879 535.98L214.182 532.364L216.466 529.086L220.447 529.425L222.143 533.042L219.859 536.319Z",
    fill: "white"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M237.285 549.021L232.391 548.604L230.304 544.156L233.113 540.126L238.007 540.543L240.093 544.99L237.285 549.021Z",
    fill: "white"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M245.803 554.956L240.909 554.539L238.822 550.092L241.631 546.061L246.525 546.478L248.612 550.925L245.803 554.956Z",
    fill: "white"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M254.321 560.891L249.427 560.474L247.341 556.027L250.149 551.997L255.043 552.414L257.13 556.861L254.321 560.891Z",
    fill: "white"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M262.839 566.827L257.945 566.41L255.859 561.962L258.667 557.932L263.562 558.349L265.648 562.796L262.839 566.827Z",
    fill: "white"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M271.358 572.762L266.463 572.345L264.377 567.898L267.185 563.867L272.08 564.284L274.166 568.731L271.358 572.762Z",
    fill: "white"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M279.876 578.697L274.982 578.28L272.895 573.833L275.704 569.803L280.598 570.22L282.685 574.667L279.876 578.697Z",
    fill: "white"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M334.509 572.931L329.615 572.514L327.529 568.066L330.337 564.036L335.231 564.453L337.318 568.9L334.509 572.931Z",
    fill: "white"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M343.909 568.521L339.014 568.105L336.928 563.657L339.736 559.627L344.631 560.044L346.717 564.491L343.909 568.521Z",
    fill: "white"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M353.308 564.112L348.413 563.695L346.327 559.248L349.135 555.217L354.03 555.634L356.116 560.082L353.308 564.112Z",
    fill: "white"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M362.707 559.703L357.813 559.286L355.726 554.839L358.535 550.808L363.429 551.225L365.515 555.672L362.707 559.703Z",
    fill: "white"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M372.107 555.293L367.212 554.876L365.126 550.429L367.934 546.399L372.829 546.816L374.915 551.263L372.107 555.293Z",
    fill: "white"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M526.896 115.221L522.002 114.804L519.915 110.357L522.724 106.326L527.618 106.743L529.705 111.19L526.896 115.221Z",
    fill: "white"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M693.695 166.322L688.801 165.905L686.715 161.457L689.523 157.427L694.417 157.844L696.504 162.291L693.695 166.322Z",
    fill: "white"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M518.378 109.286L513.484 108.869L511.397 104.421L514.206 100.391L519.1 100.808L521.186 105.255L518.378 109.286Z",
    fill: "white"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M685.177 160.386L680.283 159.969L678.197 155.522L681.005 151.492L685.899 151.909L687.986 156.356L685.177 160.386Z",
    fill: "white"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M509.859 103.35L504.965 102.933L502.878 98.486L505.687 94.4558L510.581 94.8726L512.667 99.3198L509.859 103.35Z",
    fill: "white"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M676.658 154.451L671.764 154.034L669.678 149.587L672.486 145.556L677.38 145.973L679.467 150.42L676.658 154.451Z",
    fill: "white"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M501.34 97.4148L496.446 96.9979L494.36 92.5506L497.168 88.5203L502.062 88.9372L504.149 93.3844L501.34 97.4148Z",
    fill: "white"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M668.14 148.515L663.245 148.099L661.159 143.651L663.967 139.621L668.862 140.038L670.948 144.485L668.14 148.515Z",
    fill: "white"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M492.823 91.4795L487.928 91.0626L485.842 86.6153L488.65 82.585L493.545 83.0019L495.631 87.449L492.823 91.4795Z",
    fill: "white"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M659.622 142.58L654.728 142.163L652.641 137.716L655.45 133.686L660.344 134.103L662.43 138.55L659.622 142.58Z",
    fill: "white"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M484.305 85.5442L479.41 85.1273L477.324 80.68L480.132 76.6497L485.027 77.0666L487.113 81.5138L484.305 85.5442Z",
    fill: "white"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M651.104 136.645L646.21 136.228L644.123 131.781L646.932 127.75L651.826 128.167L653.912 132.614L651.104 136.645Z",
    fill: "white"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M642.104 140.448L637.21 140.031L635.123 135.583L637.932 131.553L642.826 131.97L644.912 136.417L642.104 140.448Z",
    fill: "white"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M475.787 79.6089L470.892 79.192L468.806 74.7447L471.614 70.7144L476.509 71.1313L478.595 75.5785L475.787 79.6089Z",
    fill: "white"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M467.268 73.6736L462.374 73.2567L460.287 68.8094L463.096 64.7791L467.99 65.196L470.077 69.6432L467.268 73.6736Z",
    fill: "white"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M458.75 67.738L453.856 67.3212L451.769 62.874L454.578 58.8437L459.472 59.2606L461.559 63.7077L458.75 67.738Z",
    fill: "white"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M450.233 61.8029L445.338 61.386L443.252 56.9387L446.06 52.9083L450.955 53.3251L453.041 57.7725L450.233 61.8029Z",
    fill: "white"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M441.715 55.87L436.818 55.4528L434.73 51.003L437.54 46.9703L442.437 47.3874L444.525 51.8372L441.715 55.87Z",
    fill: "white"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M432.118 47.6353L429.752 47.4337L428.743 45.2834L430.101 43.3344L432.467 43.536L433.476 45.6865L432.118 47.6353Z",
    fill: "white"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8144 325.341L52.9198 324.924L50.8336 320.477L53.6418 316.447L58.5364 316.864L60.6226 321.311L57.8144 325.341Z",
    fill: "white"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9333 335.686L52.0387 335.269L49.9524 330.822L52.7607 326.791L57.6553 327.208L59.7415 331.656L56.9333 335.686Z",
    fill: "white"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0524 346.031L51.1578 345.614L49.0716 341.167L51.8798 337.136L56.7744 337.553L58.8606 342L56.0524 346.031Z",
    fill: "white"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1713 356.375L50.2767 355.958L48.1905 351.511L50.9987 347.481L55.8933 347.898L57.9795 352.345L55.1713 356.375Z",
    fill: "white"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1765 445.78L70.1778 445.439L68.4734 441.806L70.7677 438.513L74.7664 438.854L76.4709 442.487L74.1765 445.78Z",
    fill: "white"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0768 452.529L78.1822 452.112L76.096 447.665L78.9043 443.635L83.7989 444.051L85.8851 448.499L83.0768 452.529Z",
    fill: "white"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5949 458.464L86.7003 458.047L84.6141 453.6L87.4223 449.57L92.3169 449.987L94.4031 454.434L91.5949 458.464Z",
    fill: "white"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M100.113 464.4L95.2183 463.983L93.1321 459.536L95.9404 455.505L100.835 455.922L102.921 460.37L100.113 464.4Z",
    fill: "white"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M108.631 470.335L103.737 469.918L101.65 465.471L104.459 461.44L109.353 461.857L111.439 466.305L108.631 470.335Z",
    fill: "white"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M117.149 476.27L112.254 475.853L110.168 471.406L112.977 467.376L117.871 467.793L119.957 472.24L117.149 476.27Z",
    fill: "white"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M125.667 482.206L120.773 481.789L118.686 477.342L121.495 473.311L126.389 473.728L128.476 478.175L125.667 482.206Z",
    fill: "white"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M134.186 488.141L129.291 487.724L127.205 483.277L130.013 479.247L134.908 479.663L136.994 484.111L134.186 488.141Z",
    fill: "white"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M142.704 494.076L137.809 493.66L135.723 489.212L138.531 485.182L143.426 485.599L145.512 490.046L142.704 494.076Z",
    fill: "white"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M151.222 500.012L146.327 499.595L144.241 495.148L147.05 491.117L151.944 491.534L154.03 495.981L151.222 500.012Z",
    fill: "white"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M159.74 505.947L154.846 505.53L152.759 501.083L155.568 497.052L160.462 497.469L162.548 501.917L159.74 505.947Z",
    fill: "white"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M236.351 559.252L231.581 558.846L229.547 554.512L232.284 550.584L237.055 550.99L239.088 555.324L236.351 559.252Z",
    fill: "white"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M244.922 565.3L240.028 564.884L237.941 560.436L240.75 556.406L245.644 556.823L247.731 561.27L244.922 565.3Z",
    fill: "white"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M253.44 571.236L248.546 570.819L246.46 566.372L249.268 562.341L254.162 562.758L256.249 567.205L253.44 571.236Z",
    fill: "white"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M261.958 577.171L257.064 576.754L254.977 572.307L257.786 568.277L262.68 568.694L264.767 573.141L261.958 577.171Z",
    fill: "white"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M361.827 570.05L356.93 569.633L354.842 565.183L357.652 561.15L362.55 561.567L364.637 566.017L361.827 570.05Z",
    fill: "white"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M371.226 565.638L366.331 565.221L364.245 560.774L367.053 556.744L371.948 557.16L374.034 561.608L371.226 565.638Z",
    fill: "white"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M536.295 110.812L531.401 110.395L529.314 105.947L532.123 101.917L537.017 102.334L539.104 106.781L536.295 110.812Z",
    fill: "white"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M703.094 161.912L698.2 161.495L696.114 157.048L698.922 153.018L703.816 153.435L705.903 157.882L703.094 161.912Z",
    fill: "white"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M527.777 104.876L522.883 104.459L520.796 100.012L523.605 95.9818L528.499 96.3986L530.585 100.846L527.777 104.876Z",
    fill: "white"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M694.576 155.977L689.682 155.56L687.596 151.113L690.404 147.082L695.298 147.499L697.385 151.946L694.576 155.977Z",
    fill: "white"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M519.259 98.9409L514.364 98.5241L512.278 94.0767L515.087 90.0465L519.981 90.4633L522.067 94.9105L519.259 98.9409Z",
    fill: "white"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M686.058 150.042L681.164 149.625L679.077 145.177L681.886 141.147L686.78 141.564L688.867 146.011L686.058 150.042Z",
    fill: "white"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M510.74 93.0055L505.846 92.5886L503.76 88.1413L506.568 84.111L511.462 84.5279L513.549 88.9751L510.74 93.0055Z",
    fill: "white"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M677.54 144.106L672.645 143.689L670.559 139.242L673.367 135.212L678.262 135.629L680.348 140.076L677.54 144.106Z",
    fill: "white"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M502.222 87.0702L497.327 86.6533L495.241 82.206L498.049 78.1757L502.944 78.5926L505.03 83.0398L502.222 87.0702Z",
    fill: "white"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M669.021 138.171L664.127 137.754L662.04 133.307L664.849 129.276L669.743 129.693L671.829 134.14L669.021 138.171Z",
    fill: "white"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M493.704 81.1349L488.81 80.718L486.723 76.2707L489.532 72.2404L494.426 72.6573L496.512 77.1045L493.704 81.1349Z",
    fill: "white"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M660.504 132.236L655.609 131.819L653.523 127.371L656.331 123.341L661.226 123.758L663.312 128.205L660.504 132.236Z",
    fill: "white"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M485.186 75.1996L480.292 74.7827L478.205 70.3354L481.014 66.3051L485.908 66.722L487.994 71.1691L485.186 75.1996Z",
    fill: "white"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M651.985 126.3L647.091 125.883L645.005 121.436L647.813 117.406L652.708 117.823L654.794 122.27L651.985 126.3Z",
    fill: "white"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M642.985 130.103L638.091 129.686L636.005 125.239L638.813 121.208L643.708 121.625L645.794 126.072L642.985 130.103Z",
    fill: "white"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M476.668 69.2641L471.773 68.8473L469.687 64.4001L472.495 60.3698L477.39 60.7867L479.476 65.2339L476.668 69.2641Z",
    fill: "white"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M468.149 63.3289L463.255 62.912L461.168 58.4647L463.977 54.4343L468.871 54.8511L470.957 59.2985L468.149 63.3289Z",
    fill: "white"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M459.631 57.3934L454.737 56.9766L452.65 52.5294L455.459 48.499L460.353 48.9158L462.439 53.3632L459.631 57.3934Z",
    fill: "white"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M451.114 51.4581L446.219 51.0412L444.133 46.5941L446.941 42.5638L451.836 42.9807L453.922 47.4278L451.114 51.4581Z",
    fill: "white"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M442.595 45.5227L437.7 45.1058L435.614 40.6587L438.422 36.6282L443.317 37.0451L445.403 41.4924L442.595 45.5227Z",
    fill: "white"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M433.368 38.0778L430.135 37.8024L428.757 34.8649L430.612 32.2027L433.845 32.4781L435.223 35.4156L433.368 38.0778Z",
    fill: "white"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2958 319.406L44.4014 318.989L42.315 314.542L45.1234 310.511L50.0178 310.928L52.1042 315.375L49.2958 319.406Z",
    fill: "white"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4147 329.751L43.5202 329.334L41.4339 324.886L44.2423 320.856L49.1367 321.273L51.2231 325.72L48.4147 329.751Z",
    fill: "white"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5336 340.095L42.6391 339.678L40.5528 335.231L43.3612 331.201L48.2556 331.618L50.342 336.065L47.5336 340.095Z",
    fill: "white"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6525 350.44L41.758 350.023L39.6717 345.576L42.4801 341.545L47.3745 341.962L49.4609 346.41L46.6525 350.44Z",
    fill: "white"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7716 360.784L40.8772 360.368L38.7908 355.92L41.5992 351.89L46.4937 352.307L48.58 356.754L45.7716 360.784Z",
    fill: "white"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1588 451.003L60.2642 450.586L58.178 446.139L60.9863 442.109L65.8809 442.525L67.9671 446.973L65.1588 451.003Z",
    fill: "white"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6771 456.938L68.7826 456.521L66.6963 452.074L69.5046 448.044L74.3992 448.461L76.4854 452.908L73.6771 456.938Z",
    fill: "white"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1957 462.874L77.3011 462.457L75.2149 458.01L78.0232 453.979L82.9178 454.396L85.0039 458.843L82.1957 462.874Z",
    fill: "white"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7138 468.809L85.8192 468.392L83.733 463.945L86.5412 459.914L91.4358 460.331L93.522 464.779L90.7138 468.809Z",
    fill: "white"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2317 474.744L94.3372 474.327L92.251 469.88L95.0593 465.85L99.9537 466.267L102.04 470.714L99.2317 474.744Z",
    fill: "white"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M107.75 480.68L102.855 480.263L100.769 475.815L103.577 471.785L108.472 472.202L110.558 476.649L107.75 480.68Z",
    fill: "white"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M116.268 486.615L111.373 486.198L109.287 481.751L112.095 477.721L116.99 478.137L119.076 482.585L116.268 486.615Z",
    fill: "white"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M124.786 492.55L119.892 492.134L117.805 487.686L120.614 483.656L125.508 484.073L127.595 488.52L124.786 492.55Z",
    fill: "white"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M133.305 498.486L128.41 498.069L126.324 493.622L129.132 489.591L134.027 490.008L136.113 494.455L133.305 498.486Z",
    fill: "white"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M141.822 504.421L136.928 504.004L134.842 499.557L137.65 495.526L142.544 495.943L144.631 500.391L141.822 504.421Z",
    fill: "white"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M150.255 510.174L145.562 509.774L143.561 505.509L146.254 501.645L150.947 502.044L152.948 506.309L150.255 510.174Z",
    fill: "white"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M235.503 569.667L230.656 569.254L228.59 564.85L231.371 560.859L236.218 561.271L238.284 565.675L235.503 569.667Z",
    fill: "white"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M244.041 575.645L239.147 575.228L237.06 570.781L239.869 566.751L244.763 567.168L246.85 571.615L244.041 575.645Z",
    fill: "white"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M252.559 581.58L247.665 581.164L245.578 576.716L248.387 572.686L253.281 573.103L255.368 577.55L252.559 581.58Z",
    fill: "white"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M260 585.219L257.633 585.017L256.625 582.867L257.983 580.918L260.349 581.12L261.358 583.27L260 585.219Z",
    fill: "white"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M378.666 569.277L376.299 569.075L375.29 566.925L376.648 564.976L379.015 565.177L380.024 567.328L378.666 569.277Z",
    fill: "white"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M570.797 123.246L566.962 122.919L565.327 119.434L567.528 116.276L571.363 116.603L572.998 120.088L570.797 123.246Z",
    fill: "white"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M552.753 122.133L548.918 121.807L547.283 118.322L549.484 115.163L553.319 115.49L554.954 118.975L552.753 122.133Z",
    fill: "white"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M737.597 174.347L733.761 174.02L732.126 170.535L734.327 167.377L738.163 167.703L739.797 171.188L737.597 174.347Z",
    fill: "white"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M562.731 118.273L557.837 117.856L555.75 113.409L558.559 109.378L563.453 109.795L565.539 114.243L562.731 118.273Z",
    fill: "white"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M729.53 169.374L724.636 168.957L722.55 164.509L725.358 160.479L730.252 160.896L732.339 165.343L729.53 169.374Z",
    fill: "white"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M554.213 112.338L549.318 111.921L547.232 107.473L550.04 103.443L554.935 103.86L557.021 108.307L554.213 112.338Z",
    fill: "white"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M721.012 163.438L716.117 163.021L714.031 158.574L716.839 154.544L721.734 154.961L723.82 159.408L721.012 163.438Z",
    fill: "white"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M545.695 106.402L540.8 105.985L538.714 101.538L541.522 97.5078L546.417 97.9246L548.503 102.372L545.695 106.402Z",
    fill: "white"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M712.494 157.503L707.599 157.086L705.513 152.639L708.321 148.608L713.216 149.025L715.302 153.473L712.494 157.503Z",
    fill: "white"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M711.342 168.103L706.448 167.686L704.361 163.239L707.17 159.208L712.064 159.625L714.15 164.072L711.342 168.103Z",
    fill: "white"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M720.342 173.103L715.448 172.686L713.361 168.239L716.17 164.208L721.064 164.625L723.15 169.072L720.342 173.103Z",
    fill: "white"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M537.176 100.467L532.281 100.05L530.195 95.6027L533.004 91.5725L537.898 91.9893L539.984 96.4365L537.176 100.467Z",
    fill: "white"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M703.975 151.568L699.081 151.151L696.994 146.703L699.803 142.673L704.697 143.09L706.784 147.537L703.975 151.568Z",
    fill: "white"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M528.658 94.5316L523.763 94.1148L521.677 89.6674L524.485 85.6372L529.38 86.054L531.466 90.5012L528.658 94.5316Z",
    fill: "white"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M695.457 145.632L690.563 145.215L688.476 140.768L691.285 136.738L696.179 137.155L698.266 141.602L695.457 145.632Z",
    fill: "white"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M520.14 88.5963L515.245 88.1795L513.159 83.7321L515.967 79.7019L520.862 80.1187L522.948 84.5659L520.14 88.5963Z",
    fill: "white"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M686.939 139.697L682.045 139.28L679.958 134.833L682.767 130.803L687.661 131.219L689.748 135.667L686.939 139.697Z",
    fill: "white"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M511.621 82.6609L506.727 82.244L504.64 77.7967L507.449 73.7664L512.343 74.1833L514.43 78.6305L511.621 82.6609Z",
    fill: "white"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M678.421 133.762L673.526 133.345L671.44 128.897L674.248 124.867L679.143 125.284L681.229 129.731L678.421 133.762Z",
    fill: "white"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M503.103 76.7256L498.208 76.3087L496.122 71.8614L498.93 67.8311L503.825 68.248L505.911 72.6951L503.103 76.7256Z",
    fill: "white"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M669.902 127.826L665.007 127.409L662.921 122.962L665.729 118.932L670.624 119.349L672.71 123.796L669.902 127.826Z",
    fill: "white"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M494.585 70.7901L489.691 70.3733L487.604 65.9261L490.413 61.8958L495.307 62.3127L497.393 66.7598L494.585 70.7901Z",
    fill: "white"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M661.384 121.891L656.49 121.474L654.404 117.027L657.212 112.997L662.106 113.413L664.193 117.861L661.384 121.891Z",
    fill: "white"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M486.067 64.8549L481.172 64.438L479.086 59.9907L481.894 55.9603L486.789 56.3771L488.875 60.8244L486.067 64.8549Z",
    fill: "white"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M652.866 115.956L647.972 115.539L645.886 111.091L648.694 107.061L653.588 107.478L655.675 111.925L652.866 115.956Z",
    fill: "white"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M477.549 58.9194L472.655 58.5026L470.568 54.0554L473.377 50.025L478.271 50.4418L480.357 54.8892L477.549 58.9194Z",
    fill: "white"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M469.03 52.9841L464.136 52.5673L462.05 48.1201L464.858 44.0898L469.752 44.5067L471.839 48.9538L469.03 52.9841Z",
    fill: "white"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M460.512 47.0487L455.618 46.6318L453.532 42.1847L456.34 38.1542L461.234 38.5711L463.321 43.0184L460.512 47.0487Z",
    fill: "white"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M451.995 41.1134L447.1 40.6966L445.014 36.2494L447.822 32.2189L452.717 32.6358L454.803 37.0831L451.995 41.1134Z",
    fill: "white"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M443.476 35.1781L438.582 34.7613L436.495 30.3141L439.304 26.2836L444.198 26.7005L446.285 31.1478L443.476 35.1781Z",
    fill: "white"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7779 313.471L35.8833 313.054L33.7969 308.606L36.6053 304.576L41.4999 304.993L43.5861 309.44L40.7779 313.471Z",
    fill: "white"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8968 323.815L35.0022 323.398L32.9158 318.951L35.7242 314.921L40.6188 315.338L42.705 319.785L39.8968 323.815Z",
    fill: "white"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0157 334.16L34.1211 333.743L32.0347 329.296L34.8431 325.265L39.7377 325.682L41.8239 330.13L39.0157 334.16Z",
    fill: "white"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1346 344.504L33.24 344.088L31.1536 339.64L33.962 335.61L38.8566 336.027L40.9428 340.474L38.1346 344.504Z",
    fill: "white"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2535 354.849L32.3589 354.432L30.2725 349.985L33.0809 345.955L37.9755 346.372L40.0617 350.819L37.2535 354.849Z",
    fill: "white"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7597 455.412L50.8651 454.995L48.7789 450.548L51.5871 446.518L56.4817 446.935L58.5679 451.382L55.7597 455.412Z",
    fill: "white"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M64.278 461.348L59.3834 460.931L57.2972 456.484L60.1054 452.453L65 452.87L67.0862 457.317L64.278 461.348Z",
    fill: "white"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M72.796 467.283L67.9015 466.866L65.8152 462.419L68.6235 458.388L73.5181 458.805L75.6043 463.253L72.796 467.283Z",
    fill: "white"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3146 473.218L76.42 472.801L74.3338 468.354L77.142 464.324L82.0366 464.741L84.1229 469.188L81.3146 473.218Z",
    fill: "white"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8327 479.154L84.9381 478.737L82.8519 474.289L85.6601 470.259L90.5547 470.676L92.6409 475.123L89.8327 479.154Z",
    fill: "white"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3506 485.089L93.4561 484.672L91.3699 480.225L94.1782 476.195L99.0726 476.611L101.159 481.059L98.3506 485.089Z",
    fill: "white"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M106.869 491.024L101.974 490.607L99.888 486.16L102.696 482.13L107.591 482.547L109.677 486.994L106.869 491.024Z",
    fill: "white"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M115.387 496.96L110.493 496.543L108.406 492.096L111.215 488.065L116.109 488.482L118.196 492.929L115.387 496.96Z",
    fill: "white"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M123.905 502.895L119.011 502.478L116.924 498.031L119.733 494L124.627 494.417L126.714 498.865L123.905 502.895Z",
    fill: "white"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M132.424 508.83L127.529 508.413L125.443 503.966L128.251 499.936L133.146 500.353L135.232 504.8L132.424 508.83Z",
    fill: "white"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M597.685 131.67L592.791 131.253L590.704 126.805L593.513 122.775L598.407 123.192L600.493 127.639L597.685 131.67Z",
    fill: "white"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M589.166 125.734L584.272 125.317L582.185 120.87L584.994 116.84L589.888 117.257L591.975 121.704L589.166 125.734Z",
    fill: "white"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M580.648 119.799L575.754 119.382L573.667 114.935L576.476 110.904L581.37 111.321L583.456 115.769L580.648 119.799Z",
    fill: "white"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M572.13 113.864L567.235 113.447L565.149 108.999L567.957 104.969L572.852 105.386L574.938 109.833L572.13 113.864Z",
    fill: "white"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M738.929 164.964L734.035 164.547L731.949 160.1L734.757 156.07L739.651 156.487L741.738 160.934L738.929 164.964Z",
    fill: "white"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M563.612 107.928L558.717 107.511L556.631 103.064L559.439 99.0339L564.334 99.4507L566.42 103.898L563.612 107.928Z",
    fill: "white"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M730.411 159.029L725.517 158.612L723.43 154.165L726.239 150.135L731.133 150.551L733.22 154.999L730.411 159.029Z",
    fill: "white"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M555.093 101.993L550.199 101.576L548.113 97.1287L550.921 93.0985L555.815 93.5153L557.902 97.9625L555.093 101.993Z",
    fill: "white"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M721.893 153.094L716.998 152.677L714.912 148.229L717.72 144.199L722.615 144.616L724.701 149.063L721.893 153.094Z",
    fill: "white"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M546.575 96.0576L541.681 95.6408L539.595 91.1934L542.403 87.1632L547.297 87.58L549.384 92.0272L546.575 96.0576Z",
    fill: "white"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M713.375 147.158L708.48 146.741L706.394 142.294L709.202 138.264L714.097 138.681L716.183 143.128L713.375 147.158Z",
    fill: "white"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M538.057 90.1223L533.163 89.7055L531.076 85.2581L533.885 81.2279L538.779 81.6447L540.866 86.0919L538.057 90.1223Z",
    fill: "white"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M704.857 141.223L699.962 140.806L697.876 136.359L700.684 132.329L705.579 132.745L707.665 137.193L704.857 141.223Z",
    fill: "white"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M529.539 84.1869L524.645 83.77L522.558 79.3227L525.367 75.2924L530.261 75.7093L532.348 80.1565L529.539 84.1869Z",
    fill: "white"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M696.339 135.288L691.444 134.871L689.358 130.423L692.166 126.393L697.061 126.81L699.147 131.257L696.339 135.288Z",
    fill: "white"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M521.021 78.2517L516.127 77.8349L514.04 73.3875L516.849 69.3572L521.743 69.7741L523.83 74.2213L521.021 78.2517Z",
    fill: "white"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M687.82 129.352L682.926 128.936L680.84 124.488L683.648 120.458L688.542 120.875L690.629 125.322L687.82 129.352Z",
    fill: "white"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M512.503 72.3161L507.608 71.8993L505.522 67.4521L508.33 63.4218L513.225 63.8387L515.311 68.2859L512.503 72.3161Z",
    fill: "white"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M679.302 123.417L674.407 123L672.321 118.553L675.129 114.523L680.024 114.939L682.11 119.387L679.302 123.417Z",
    fill: "white"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M503.983 66.3809L499.089 65.964L497.003 61.5167L499.811 57.4863L504.705 57.9031L506.792 62.3505L503.983 66.3809Z",
    fill: "white"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M670.783 117.482L665.888 117.065L663.802 112.617L666.61 108.587L671.505 109.004L673.591 113.451L670.783 117.482Z",
    fill: "white"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M495.466 60.4454L490.572 60.0286L488.486 55.5814L491.294 51.551L496.188 51.9678L498.275 56.4151L495.466 60.4454Z",
    fill: "white"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M662.266 111.546L657.371 111.129L655.285 106.682L658.093 102.652L662.988 103.069L665.074 107.516L662.266 111.546Z",
    fill: "white"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M486.948 54.5101L482.053 54.0932L479.967 49.6461L482.775 45.6158L487.67 46.0327L489.756 50.4798L486.948 54.5101Z",
    fill: "white"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M653.747 105.611L648.853 105.194L646.766 100.747L649.575 96.7165L654.469 97.1334L656.555 101.581L653.747 105.611Z",
    fill: "white"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M478.43 48.5748L473.535 48.158L471.449 43.7108L474.257 39.6804L479.152 40.0972L481.238 44.5446L478.43 48.5748Z",
    fill: "white"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M469.911 42.6394L465.017 42.2226L462.93 37.7754L465.739 33.7449L470.633 34.1618L472.72 38.6091L469.911 42.6394Z",
    fill: "white"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M461.393 36.7041L456.499 36.2873L454.412 31.8401L457.221 27.8096L462.115 28.2265L464.202 32.6738L461.393 36.7041Z",
    fill: "white"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M452.876 30.7689L447.981 30.3521L445.895 25.9049L448.703 21.8745L453.598 22.2913L455.684 26.7386L452.876 30.7689Z",
    fill: "white"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3787 317.88L26.4841 317.463L24.3978 313.016L27.2062 308.985L32.1008 309.402L34.187 313.849L31.3787 317.88Z",
    fill: "white"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4976 328.225L25.603 327.808L23.5167 323.36L26.3251 319.33L31.2197 319.747L33.3059 324.194L30.4976 328.225Z",
    fill: "white"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6165 338.569L24.7219 338.152L22.6356 333.705L25.444 329.675L30.3386 330.092L32.4248 334.539L29.6165 338.569Z",
    fill: "white"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3607 459.822L41.4661 459.405L39.3799 454.958L42.1882 450.927L47.0828 451.344L49.169 455.791L46.3607 459.822Z",
    fill: "white"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8788 465.757L49.9842 465.34L47.898 460.893L50.7063 456.862L55.6009 457.279L57.6871 461.727L54.8788 465.757Z",
    fill: "white"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3969 471.692L58.5023 471.275L56.4161 466.828L59.2243 462.798L64.1189 463.215L66.2051 467.662L63.3969 471.692Z",
    fill: "white"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9149 477.628L67.0203 477.211L64.9342 472.763L67.7424 468.733L72.637 469.15L74.7232 473.597L71.9149 477.628Z",
    fill: "white"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4335 483.563L75.5389 483.146L73.4527 478.699L76.2609 474.668L81.1555 475.085L83.2417 479.533L80.4335 483.563Z",
    fill: "white"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9516 489.498L84.057 489.081L81.9708 484.634L84.779 480.604L89.6736 481.021L91.7598 485.468L88.9516 489.498Z",
    fill: "white"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4697 495.434L92.5753 495.017L90.4891 490.57L93.2973 486.539L98.1918 486.956L100.278 491.403L97.4697 495.434Z",
    fill: "white"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M105.988 501.369L101.093 500.952L99.0071 496.505L101.816 492.474L106.71 492.891L108.796 497.339L105.988 501.369Z",
    fill: "white"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M607.084 127.26L602.19 126.844L600.103 122.396L602.912 118.366L607.806 118.783L609.893 123.23L607.084 127.26Z",
    fill: "white"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M598.566 121.325L593.672 120.908L591.585 116.461L594.394 112.431L599.288 112.847L601.374 117.295L598.566 121.325Z",
    fill: "white"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M590.048 115.39L585.153 114.973L583.067 110.525L585.875 106.495L590.77 106.912L592.856 111.359L590.048 115.39Z",
    fill: "white"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M581.529 109.454L576.635 109.037L574.549 104.59L577.357 100.56L582.251 100.977L584.338 105.424L581.529 109.454Z",
    fill: "white"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M573.011 103.519L568.117 103.102L566.031 98.6549L568.839 94.6246L573.733 95.0414L575.82 99.4886L573.011 103.519Z",
    fill: "white"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M564.493 97.5837L559.599 97.1669L557.513 92.7196L560.321 88.6893L565.215 89.1061L567.302 93.5533L564.493 97.5837Z",
    fill: "white"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M731.293 148.684L726.398 148.268L724.312 143.82L727.12 139.79L732.015 140.207L734.101 144.654L731.293 148.684Z",
    fill: "white"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M555.974 91.6483L551.08 91.2315L548.993 86.7841L551.802 82.7539L556.696 83.1707L558.783 87.6179L555.974 91.6483Z",
    fill: "white"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M722.774 142.749L717.879 142.332L715.793 137.885L718.601 133.855L723.496 134.271L725.582 138.719L722.774 142.749Z",
    fill: "white"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M547.456 85.713L542.562 85.2962L540.475 80.8488L543.284 76.8186L548.178 77.2354L550.265 81.6826L547.456 85.713Z",
    fill: "white"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M714.256 136.814L709.361 136.397L707.275 131.95L710.083 127.919L714.978 128.336L717.064 132.783L714.256 136.814Z",
    fill: "white"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M538.938 79.7777L534.044 79.3609L531.957 74.9135L534.766 70.8832L539.66 71.3001L541.747 75.7473L538.938 79.7777Z",
    fill: "white"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M705.737 130.878L700.843 130.462L698.757 126.014L701.565 121.984L706.459 122.401L708.546 126.848L705.737 130.878Z",
    fill: "white"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M530.42 73.8423L525.526 73.4254L523.439 68.9782L526.248 64.9479L531.142 65.3648L533.228 69.812L530.42 73.8423Z",
    fill: "white"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M697.219 124.943L692.325 124.526L690.239 120.079L693.047 116.049L697.941 116.466L700.028 120.913L697.219 124.943Z",
    fill: "white"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M521.902 67.907L517.008 67.4902L514.921 63.0428L517.73 59.0124L522.624 59.4293L524.71 63.8766L521.902 67.907Z",
    fill: "white"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M688.701 119.008L683.807 118.591L681.721 114.144L684.529 110.113L689.423 110.53L691.51 114.977L688.701 119.008Z",
    fill: "white"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M513.383 61.9716L508.489 61.5547L506.403 57.1075L509.211 53.0771L514.105 53.494L516.192 57.9413L513.383 61.9716Z",
    fill: "white"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M680.183 113.072L675.288 112.655L673.202 108.208L676.01 104.178L680.905 104.595L682.991 109.042L680.183 113.072Z",
    fill: "white"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M504.865 56.0361L499.97 55.6192L497.884 51.1721L500.692 47.1418L505.587 47.5586L507.673 52.0058L504.865 56.0361Z",
    fill: "white"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M671.664 107.137L666.77 106.72L664.683 102.273L667.492 98.2425L672.386 98.6594L674.472 103.107L671.664 107.137Z",
    fill: "white"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M496.347 50.1008L491.453 49.684L489.367 45.2368L492.175 41.2064L497.069 41.6232L499.156 46.0705L496.347 50.1008Z",
    fill: "white"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M663.147 101.202L658.252 100.785L656.166 96.3375L658.974 92.3071L663.869 92.7239L665.955 97.1713L663.147 101.202Z",
    fill: "white"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M487.829 44.1655L482.935 43.7487L480.848 39.3015L483.657 35.2711L488.551 35.6879L490.637 40.1352L487.829 44.1655Z",
    fill: "white"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M654.629 95.2663L649.734 94.8494L647.648 90.4022L650.456 86.3718L655.351 86.7886L657.437 91.2359L654.629 95.2663Z",
    fill: "white"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M479.311 38.2302L474.417 37.8134L472.33 33.3662L475.139 29.3358L480.033 29.7526L482.12 34.1999L479.311 38.2302Z",
    fill: "white"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M470.793 32.2948L465.898 31.8779L463.812 27.4308L466.62 23.4003L471.515 23.8172L473.601 28.2645L470.793 32.2948Z",
    fill: "white"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M462.275 26.3595L457.38 25.9426L455.294 21.4955L458.102 17.465L462.997 17.8819L465.083 22.3292L462.275 26.3595Z",
    fill: "white"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M22.861 311.945L17.9664 311.528L15.8802 307.08L18.6884 303.05L23.583 303.467L25.6692 307.914L22.861 311.945Z",
    fill: "white"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9809 322.292L17.0834 321.875L14.9959 317.425L17.8059 313.392L22.7034 313.809L24.7908 318.259L21.9809 322.292Z",
    fill: "white"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9608 464.231L32.0664 463.814L29.98 459.367L32.7884 455.336L37.6829 455.753L39.7692 460.201L36.9608 464.231Z",
    fill: "white"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4796 470.166L40.585 469.749L38.4989 465.302L41.3071 461.272L46.2017 461.689L48.2879 466.136L45.4796 470.166Z",
    fill: "white"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9977 476.102L49.1031 475.685L47.0169 471.237L49.8252 467.207L54.7198 467.624L56.806 472.071L53.9977 476.102Z",
    fill: "white"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5158 482.037L57.6212 481.62L55.535 477.173L58.3432 473.142L63.2378 473.559L65.324 478.007L62.5158 482.037Z",
    fill: "white"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0338 487.972L66.1392 487.555L64.053 483.108L66.8613 479.078L71.7559 479.495L73.8421 483.942L71.0338 487.972Z",
    fill: "white"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5524 493.908L74.6578 493.491L72.5716 489.044L75.3798 485.013L80.2744 485.43L82.3606 489.877L79.5524 493.908Z",
    fill: "white"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0707 499.843L83.1761 499.426L81.0899 494.979L83.8982 490.948L88.7927 491.365L90.8789 495.812L88.0707 499.843Z",
    fill: "white"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M616.483 122.851L611.589 122.434L609.502 117.987L612.311 113.957L617.205 114.373L619.291 118.821L616.483 122.851Z",
    fill: "white"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M607.965 116.916L603.071 116.499L600.984 112.051L603.793 108.021L608.687 108.438L610.773 112.885L607.965 116.916Z",
    fill: "white"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M599.447 110.98L594.552 110.564L592.466 106.116L595.274 102.086L600.169 102.503L602.255 106.95L599.447 110.98Z",
    fill: "white"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M590.929 105.045L586.034 104.628L583.948 100.181L586.756 96.1506L591.651 96.5675L593.737 101.015L590.929 105.045Z",
    fill: "white"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M582.41 99.1097L577.516 98.6929L575.43 94.2456L578.238 90.2153L583.132 90.6321L585.219 95.0793L582.41 99.1097Z",
    fill: "white"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M573.892 93.1745L568.998 92.7576L566.911 88.3103L569.72 84.28L574.614 84.6968L576.7 89.144L573.892 93.1745Z",
    fill: "white"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M565.374 87.239L560.48 86.8222L558.393 82.3748L561.202 78.3445L566.096 78.7614L568.182 83.2086L565.374 87.239Z",
    fill: "white"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M732.173 138.34L727.279 137.923L725.193 133.476L728.001 129.445L732.896 129.862L734.982 134.309L732.173 138.34Z",
    fill: "white"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M556.856 81.3037L551.961 80.8869L549.875 76.4395L552.683 72.4092L557.578 72.8261L559.664 77.2733L556.856 81.3037Z",
    fill: "white"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M723.655 132.404L718.76 131.988L716.674 127.54L719.483 123.51L724.377 123.927L726.463 128.374L723.655 132.404Z",
    fill: "white"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M548.338 75.3683L543.443 74.9514L541.357 70.5042L544.165 66.4739L549.06 66.8908L551.146 71.338L548.338 75.3683Z",
    fill: "#EF4444"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M715.342 126.103L710.448 125.686L708.361 121.239L711.17 117.208L716.064 117.625L718.15 122.072L715.342 126.103Z",
    fill: "white"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M539.819 69.433L534.925 69.0162L532.839 64.5688L535.647 60.5384L540.542 60.9553L542.628 65.4026L539.819 69.433Z",
    fill: "white"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M706.619 120.534L701.724 120.117L699.638 115.67L702.446 111.639L707.341 112.056L709.427 116.503L706.619 120.534Z",
    fill: "white"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M531.301 63.4976L526.407 63.0807L524.321 58.6335L527.129 54.6031L532.023 55.02L534.11 59.4673L531.301 63.4976Z",
    fill: "white"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M698.101 114.598L693.206 114.181L691.12 109.734L693.928 105.704L698.823 106.121L700.909 110.568L698.101 114.598Z",
    fill: "white"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M522.783 57.5622L517.889 57.1454L515.803 52.6982L518.611 48.6679L523.505 49.0848L525.592 53.5319L522.783 57.5622Z",
    fill: "white"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M689.583 108.663L684.688 108.246L682.602 103.799L685.41 99.7686L690.305 100.185L692.391 104.633L689.583 108.663Z",
    fill: "white"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M514.264 51.6268L509.37 51.21L507.284 46.7628L510.092 42.7324L514.986 43.1492L517.073 47.5966L514.264 51.6268Z",
    fill: "white"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M681.064 102.728L676.169 102.311L674.083 97.8635L676.891 93.8331L681.786 94.2499L683.872 98.6973L681.064 102.728Z",
    fill: "white"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M505.746 45.6914L500.851 45.2745L498.765 40.8274L501.573 36.7969L506.468 37.2138L508.554 41.6611L505.746 45.6914Z",
    fill: "white"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M672.545 96.7921L667.65 96.3753L665.564 91.9281L668.373 87.8976L673.267 88.3145L675.353 92.7618L672.545 96.7921Z",
    fill: "white"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M497.228 39.7562L492.334 39.3394L490.247 34.8922L493.056 30.8618L497.95 31.2786L500.036 35.7259L497.228 39.7562Z",
    fill: "white"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M664.027 90.8569L659.133 90.4401L657.047 85.9929L659.855 81.9625L664.75 82.3793L666.836 86.8266L664.027 90.8569Z",
    fill: "white"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M488.71 33.8209L483.816 33.4041L481.729 28.9569L484.538 24.9264L489.432 25.3433L491.518 29.7906L488.71 33.8209Z",
    fill: "white"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M655.509 84.9216L650.615 84.5048L648.529 80.0576L651.337 76.0272L656.231 76.444L658.318 80.8913L655.509 84.9216Z",
    fill: "white"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M480.192 27.8856L475.298 27.4688L473.211 23.0216L476.02 18.9912L480.914 19.408L483 23.8553L480.192 27.8856Z",
    fill: "white"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M471.673 21.9502L466.779 21.5333L464.693 17.0862L467.501 13.0557L472.396 13.4726L474.482 17.9199L471.673 21.9502Z",
    fill: "white"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3424 306.009L9.44783 305.592L7.36164 301.145L10.1699 297.115L15.0645 297.532L17.1507 301.979L14.3424 306.009Z",
    fill: "white"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5618 468.64L22.6672 468.223L20.5809 463.776L23.3893 459.746L28.2839 460.163L30.3701 464.61L27.5618 468.64Z",
    fill: "white"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M36.08 474.575L31.1855 474.159L29.0992 469.711L31.9076 465.681L36.802 466.098L38.8884 470.545L36.08 474.575Z",
    fill: "white"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5985 480.511L39.7039 480.094L37.6177 475.647L40.426 471.616L45.3206 472.033L47.4068 476.481L44.5985 480.511Z",
    fill: "white"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1166 486.446L48.222 486.029L46.1358 481.582L48.944 477.552L53.8387 477.969L55.9248 482.416L53.1166 486.446Z",
    fill: "white"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6347 492.382L56.7401 491.965L54.6539 487.517L57.4621 483.487L62.3567 483.904L64.4429 488.351L61.6347 492.382Z",
    fill: "white"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1527 498.317L65.2581 497.9L63.1719 493.453L65.9802 489.422L70.8748 489.839L72.961 494.286L70.1527 498.317Z",
    fill: "white"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6715 504.252L73.7769 503.835L71.6907 499.388L74.499 495.358L79.3936 495.775L81.4798 500.222L78.6715 504.252Z",
    fill: "white"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M86.345 508.388L83.4312 508.14L82.1894 505.492L83.861 503.093L86.7748 503.341L88.0168 505.989L86.345 508.388Z",
    fill: "white"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M634.4 124.377L629.506 123.96L627.419 119.513L630.228 115.483L635.122 115.899L637.208 120.347L634.4 124.377Z",
    fill: "white"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M625.882 118.442L620.987 118.025L618.901 113.577L621.709 109.547L626.604 109.964L628.69 114.411L625.882 118.442Z",
    fill: "white"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M617.364 112.506L612.47 112.09L610.384 107.642L613.192 103.612L618.086 104.029L620.173 108.476L617.364 112.506Z",
    fill: "white"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M608.846 106.571L603.952 106.154L601.866 101.707L604.674 97.6766L609.568 98.0934L611.655 102.541L608.846 106.571Z",
    fill: "white"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M600.328 100.636L595.434 100.219L593.347 95.7716L596.156 91.7413L601.05 92.1581L603.137 96.6053L600.328 100.636Z",
    fill: "white"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M591.81 94.7005L586.915 94.2836L584.829 89.8363L587.637 85.806L592.532 86.2229L594.618 90.67L591.81 94.7005Z",
    fill: "white"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M583.291 88.765L578.397 88.3482L576.311 83.9008L579.119 79.8705L584.014 80.2874L586.1 84.7346L583.291 88.765Z",
    fill: "white"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M574.773 82.8298L569.879 82.413L567.792 77.9657L570.601 73.9354L575.495 74.3522L577.581 78.7994L574.773 82.8298Z",
    fill: "white"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M566.255 76.8943L561.36 76.4774L559.274 72.0302L562.082 67.9999L566.977 68.4168L569.063 72.864L566.255 76.8943Z",
    fill: "white"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M733.054 127.995L728.16 127.578L726.074 123.131L728.882 119.101L733.776 119.518L735.863 123.965L733.054 127.995Z",
    fill: "white"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M741.342 124.103L736.447 123.686L734.361 119.239L737.169 115.208L742.064 115.625L744.15 120.072L741.342 124.103Z",
    fill: "white"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M557.736 70.959L552.842 70.5422L550.756 66.0948L553.564 62.0644L558.459 62.4813L560.545 66.9286L557.736 70.959Z",
    fill: "white"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M724.536 122.06L719.641 121.643L717.555 117.196L720.363 113.165L725.258 113.582L727.344 118.029L724.536 122.06Z",
    fill: "white"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M549.218 65.0236L544.324 64.6067L542.238 60.1595L545.046 56.1291L549.94 56.546L552.027 60.9933L549.218 65.0236Z",
    fill: "#F59E0B"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M716.342 116.103L711.448 115.686L709.361 111.239L712.17 107.208L717.064 107.625L719.15 112.072L716.342 116.103Z",
    fill: "white"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M540.7 59.0882L535.806 58.6714L533.72 54.2242L536.528 50.1939L541.422 50.6108L543.509 55.058L540.7 59.0882Z",
    fill: "white"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M707.5 110.189L702.605 109.772L700.519 105.325L703.327 101.295L708.222 101.711L710.308 106.159L707.5 110.189Z",
    fill: "white"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M532.182 53.153L527.288 52.7361L525.201 48.2889L528.01 44.2585L532.904 44.6754L534.991 49.1227L532.182 53.153Z",
    fill: "white"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M698.982 104.254L694.087 103.837L692.001 99.3896L694.809 95.3592L699.704 95.7761L701.79 100.223L698.982 104.254Z",
    fill: "white"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M523.664 47.2175L518.77 46.8007L516.683 42.3535L519.492 38.3231L524.386 38.7399L526.473 43.1873L523.664 47.2175Z",
    fill: "white"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 98.3183L685.569 97.9014L683.483 93.4542L686.291 89.4238L691.186 89.8406L693.272 94.288L690.464 98.3183Z",
    fill: "white"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M515.146 41.2822L510.251 40.8654L508.165 36.4182L510.973 32.3878L515.868 32.8046L517.954 37.252L515.146 41.2822Z",
    fill: "white"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M681.945 92.3829L677.051 91.9661L674.964 87.5189L677.773 83.4885L682.667 83.9053L684.753 88.3527L681.945 92.3829Z",
    fill: "white"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M506.627 35.3469L501.733 34.9301L499.646 30.4829L502.455 26.4524L507.349 26.8693L509.435 31.3166L506.627 35.3469Z",
    fill: "white"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M673.426 86.4476L668.532 86.0308L666.446 81.5836L669.254 77.5532L674.148 77.97L676.235 82.4173L673.426 86.4476Z",
    fill: "white"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M498.11 29.4116L493.215 28.9948L491.129 24.5476L493.937 20.5171L498.832 20.934L500.918 25.3813L498.11 29.4116Z",
    fill: "white"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M664.909 80.5123L660.014 80.0955L657.928 75.6483L660.736 71.6179L665.631 72.0347L667.717 76.482L664.909 80.5123Z",
    fill: "white"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M489.591 23.4763L484.697 23.0595L482.611 18.6123L485.419 14.5818L490.313 14.9987L492.4 19.446L489.591 23.4763Z",
    fill: "white"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M481.073 17.5409L476.179 17.124L474.093 12.6769L476.901 8.64643L481.795 9.06329L483.882 13.5106L481.073 17.5409Z",
    fill: "white"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05774 298.44L1.96126 298.176L0.641486 295.363L2.41804 292.813L5.51452 293.077L6.8343 295.89L5.05774 298.44Z",
    fill: "white"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M26.681 478.985L21.7864 478.568L19.7 474.121L22.5084 470.09L27.403 470.507L29.4892 474.954L26.681 478.985Z",
    fill: "white"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1989 484.92L30.3044 484.503L28.2181 480.056L31.0265 476.026L35.9209 476.443L38.0073 480.89L35.1989 484.92Z",
    fill: "white"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7174 490.856L38.8228 490.439L36.7366 485.991L39.5449 481.961L44.4395 482.378L46.5257 486.825L43.7174 490.856Z",
    fill: "white"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2355 496.791L47.3409 496.374L45.2547 491.927L48.0629 487.896L52.9575 488.313L55.0437 492.76L52.2355 496.791Z",
    fill: "white"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7536 502.726L55.859 502.309L53.7728 497.862L56.581 493.832L61.4756 494.248L63.5618 498.696L60.7536 502.726Z",
    fill: "white"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M635.281 114.032L630.386 113.616L628.3 109.168L631.109 105.138L636.003 105.555L638.089 110.002L635.281 114.032Z",
    fill: "white"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M626.763 108.097L621.868 107.68L619.782 103.233L622.59 99.2026L627.485 99.6194L629.571 104.067L626.763 108.097Z",
    fill: "white"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M618.245 102.162L613.351 101.745L611.264 97.2976L614.073 93.2673L618.967 93.6841L621.054 98.1313L618.245 102.162Z",
    fill: "white"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M609.727 96.2265L604.833 95.8096L602.746 91.3623L605.555 87.332L610.449 87.7488L612.536 92.196L609.727 96.2265Z",
    fill: "white"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M601.209 90.2911L596.315 89.8743L594.228 85.427L597.037 81.3967L601.931 81.8135L604.017 86.2607L601.209 90.2911Z",
    fill: "white"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M592.691 84.3559L587.796 83.939L585.71 79.4917L588.518 75.4614L593.413 75.8783L595.499 80.3254L592.691 84.3559Z",
    fill: "#3B82F6"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M584.172 78.4203L579.278 78.0034L577.192 73.5562L580 69.5259L584.894 69.9428L586.981 74.39L584.172 78.4203Z",
    fill: "white"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M575.654 72.4851L570.76 72.0683L568.674 67.621L571.482 63.5905L576.376 64.0074L578.463 68.4547L575.654 72.4851Z",
    fill: "white"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M630.415 175.417L625.52 175L623.434 170.553L626.242 166.522L631.137 166.939L633.223 171.386L630.415 175.417Z",
    fill: "white"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M567.136 66.5497L562.242 66.1328L560.156 61.6857L562.964 57.6552L567.858 58.0721L569.945 62.5194L567.136 66.5497Z",
    fill: "white"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M621.897 169.481L617.002 169.065L614.916 164.617L617.724 160.587L622.619 161.004L624.705 165.451L621.897 169.481Z",
    fill: "white"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M558.618 60.6142L553.723 60.1974L551.637 55.7502L554.445 51.7199L559.34 52.1368L561.426 56.5839L558.618 60.6142Z",
    fill: "white"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M613.378 163.546L608.484 163.129L606.397 158.682L609.206 154.652L614.1 155.069L616.186 159.516L613.378 163.546Z",
    fill: "white"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M550.1 54.679L545.205 54.2621L543.119 49.8149L545.927 45.7845L550.822 46.2014L552.908 50.6487L550.1 54.679Z",
    fill: "white"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M604.86 157.611L599.966 157.194L597.879 152.747L600.688 148.716L605.582 149.133L607.668 153.58L604.86 157.611Z",
    fill: "white"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M541.582 48.7437L536.687 48.3268L534.601 43.8796L537.409 39.8492L542.304 40.2661L544.39 44.7134L541.582 48.7437Z",
    fill: "white"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M596.342 151.675L591.447 151.259L589.361 146.811L592.17 142.781L597.064 143.198L599.15 147.645L596.342 151.675Z",
    fill: "white"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M533.063 42.8084L528.169 42.3915L526.082 37.9443L528.891 33.9139L533.785 34.3308L535.872 38.7781L533.063 42.8084Z",
    fill: "white"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M699.862 93.9091L694.968 93.4922L692.882 89.045L695.69 85.0146L700.584 85.4315L702.671 89.8788L699.862 93.9091Z",
    fill: "white"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M707.342 100.103L702.447 99.6861L700.361 95.2389L703.17 91.2084L708.064 91.6253L710.15 96.0726L707.342 100.103Z",
    fill: "white"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M524.545 36.8731L519.651 36.4562L517.564 32.009L520.373 27.9786L525.267 28.3954L527.353 32.8428L524.545 36.8731Z",
    fill: "white"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M691.344 87.9738L686.45 87.5569L684.364 83.1097L687.172 79.0793L692.066 79.4962L694.153 83.9435L691.344 87.9738Z",
    fill: "white"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M516.027 30.9376L511.132 30.5208L509.046 26.0736L511.854 22.0432L516.749 22.46L518.835 26.9073L516.027 30.9376Z",
    fill: "white"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M682.826 82.0383L677.931 81.6215L675.845 77.1743L678.653 73.1439L683.548 73.5607L685.634 78.0081L682.826 82.0383Z",
    fill: "white"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M507.508 25.0022L502.613 24.5853L500.527 20.1382L503.335 16.1077L508.23 16.5246L510.316 20.9719L507.508 25.0022Z",
    fill: "white"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M674.307 76.1029L669.413 75.686L667.326 71.2389L670.135 67.2084L675.029 67.6253L677.116 72.0726L674.307 76.1029Z",
    fill: "white"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M498.99 19.0669L494.096 18.65L492.01 14.2029L494.818 10.1724L499.712 10.5893L501.799 15.0366L498.99 19.0669Z",
    fill: "white"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M490.472 13.1316L485.578 12.7147L483.492 8.26757L486.3 4.23712L491.194 4.65399L493.281 9.1013L490.472 13.1316Z",
    fill: "white"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7999 489.329L20.9053 488.913L18.8189 484.465L21.6273 480.435L26.5219 480.852L28.6081 485.299L25.7999 489.329Z",
    fill: "white"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3178 495.265L29.4233 494.848L27.337 490.401L30.1454 486.37L35.0398 486.787L37.1262 491.234L34.3178 495.265Z",
    fill: "white"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8363 501.2L37.9417 500.783L35.8555 496.336L38.6638 492.306L43.5584 492.722L45.6446 497.17L42.8363 501.2Z",
    fill: "white"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2767 504.839L47.9099 504.637L46.9011 502.487L48.2591 500.538L50.6258 500.74L51.6345 502.89L50.2767 504.839Z",
    fill: "white"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M652.121 113.262L649.755 113.06L648.746 110.91L650.104 108.961L652.47 109.162L653.479 111.313L652.121 113.262Z",
    fill: "white"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M644.681 109.623L639.787 109.206L637.701 104.759L640.509 100.729L645.403 101.146L647.49 105.593L644.681 109.623Z",
    fill: "white"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M636.162 103.688L631.268 103.271L629.181 98.8236L631.99 94.7933L636.884 95.2101L638.971 99.6573L636.162 103.688Z",
    fill: "white"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M627.644 97.7525L622.75 97.3356L620.663 92.8883L623.472 88.858L628.366 89.2748L630.453 93.722L627.644 97.7525Z",
    fill: "#EF4444"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M619.127 91.8172L614.232 91.4003L612.146 86.953L614.954 82.9227L619.849 83.3395L621.935 87.7867L619.127 91.8172Z",
    fill: "white"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M610.609 85.8818L605.714 85.465L603.628 81.0177L606.436 76.9874L611.331 77.4042L613.417 81.8514L610.609 85.8818Z",
    fill: "white"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M602.09 79.9464L597.196 79.5295L595.11 75.0824L597.918 71.0521L602.812 71.4689L604.899 75.9161L602.09 79.9464Z",
    fill: "white"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M593.572 74.0112L588.677 73.5943L586.591 69.147L589.399 65.1165L594.294 65.5334L596.38 69.9807L593.572 74.0112Z",
    fill: "white"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M585.053 68.0757L580.159 67.6588L578.073 63.2117L580.881 59.1812L585.775 59.5981L587.862 64.0454L585.053 68.0757Z",
    fill: "white"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M576.535 62.1404L571.641 61.7235L569.555 57.2763L572.363 53.246L577.257 53.6629L579.344 58.1101L576.535 62.1404Z",
    fill: "white"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M631.296 165.072L626.401 164.655L624.315 160.208L627.123 156.178L632.018 156.595L634.104 161.042L631.296 165.072Z",
    fill: "white"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M568.017 56.205L563.123 55.7881L561.036 51.3409L563.845 47.3105L568.739 47.7274L570.825 52.1747L568.017 56.205Z",
    fill: "white"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M622.777 159.137L617.883 158.72L615.797 154.273L618.605 150.242L623.5 150.659L625.586 155.106L622.777 159.137Z",
    fill: "white"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M559.499 50.2697L554.604 49.8528L552.518 45.4056L555.326 41.3752L560.221 41.7921L562.307 46.2394L559.499 50.2697Z",
    fill: "white"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M614.259 153.201L609.364 152.785L607.278 148.337L610.087 144.307L614.981 144.724L617.067 149.171L614.259 153.201Z",
    fill: "white"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M550.981 44.3344L546.086 43.9175L544 39.4703L546.808 35.4399L551.703 35.8568L553.789 40.3041L550.981 44.3344Z",
    fill: "white"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M605.741 147.266L600.846 146.849L598.76 142.402L601.569 138.372L606.463 138.789L608.549 143.236L605.741 147.266Z",
    fill: "white"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M542.463 38.3991L537.568 37.9822L535.482 33.535L538.29 29.5046L543.185 29.9214L545.271 34.3688L542.463 38.3991Z",
    fill: "white"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M597.223 141.331L592.328 140.914L590.242 136.467L593.05 132.436L597.945 132.853L600.031 137.301L597.223 141.331Z",
    fill: "white"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M533.944 32.4638L529.05 32.0469L526.964 27.5997L529.772 23.5693L534.667 23.9861L536.753 28.4335L533.944 32.4638Z",
    fill: "white"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M700.744 83.5645L695.849 83.1476L693.763 78.7004L696.571 74.67L701.466 75.0869L703.552 79.5342L700.744 83.5645Z",
    fill: "white"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M525.426 26.5283L520.532 26.1115L518.446 21.6643L521.254 17.6339L526.148 18.0507L528.235 22.498L525.426 26.5283Z",
    fill: "white"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M692.226 77.629L687.331 77.2122L685.245 72.765L688.053 68.7346L692.948 69.1514L695.034 73.5988L692.226 77.629Z",
    fill: "white"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M516.908 20.593L512.013 20.1762L509.927 15.729L512.735 11.6986L517.63 12.1154L519.716 16.5627L516.908 20.593Z",
    fill: "white"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M508.389 14.6576L503.494 14.2407L501.408 9.79357L504.216 5.76312L509.111 6.17998L511.197 10.6273L508.389 14.6576Z",
    fill: "white"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9188 499.674L20.0242 499.257L17.9378 494.81L20.7462 490.78L25.6408 491.196L27.727 495.644L24.9188 499.674Z",
    fill: "white"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4382 505.612L28.5407 505.195L26.4532 500.745L29.2632 496.712L34.1606 497.129L36.2481 501.579L33.4382 505.612Z",
    fill: "white"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M653.91 104.851L649.415 104.468L647.499 100.384L650.078 96.6823L654.573 97.0651L656.489 101.149L653.91 104.851Z",
    fill: "white"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M645.562 99.2786L640.668 98.8617L638.581 94.4144L641.39 90.3841L646.284 90.801L648.37 95.2481L645.562 99.2786Z",
    fill: "white"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M637.043 93.3432L632.149 92.9263L630.062 88.479L632.871 84.4487L637.765 84.8655L639.851 89.3127L637.043 93.3432Z",
    fill: "white"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M628.525 87.4078L623.63 86.991L621.544 82.5437L624.352 78.5134L629.247 78.9302L631.333 83.3774L628.525 87.4078Z",
    fill: "white"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M620.008 81.4724L615.113 81.0555L613.027 76.6084L615.835 72.5781L620.73 72.9949L622.816 77.4421L620.008 81.4724Z",
    fill: "white"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M611.489 75.5373L606.595 75.1204L604.509 70.6731L607.317 66.6426L612.211 67.0595L614.298 71.5068L611.489 75.5373Z",
    fill: "white"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M602.971 69.6018L598.077 69.1849L595.991 64.7378L598.799 60.7073L603.693 61.1242L605.78 65.5715L602.971 69.6018Z",
    fill: "white"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M594.453 63.6664L589.558 63.2495L587.472 58.8023L590.28 54.772L595.175 55.1889L597.261 59.6361L594.453 63.6664Z",
    fill: "white"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M585.935 57.7311L581.04 57.3142L578.954 52.8671L581.762 48.8366L586.657 49.2535L588.743 53.7008L585.935 57.7311Z",
    fill: "white"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M577.417 51.7957L572.522 51.3788L570.436 46.9316L573.244 42.9012L578.139 43.3181L580.225 47.7654L577.417 51.7957Z",
    fill: "white"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M632.177 154.727L627.282 154.311L625.196 149.863L628.004 145.833L632.899 146.25L634.985 150.697L632.177 154.727Z",
    fill: "white"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M568.899 45.8605L564.004 45.4436L561.918 40.9964L564.726 36.966L569.621 37.3829L571.707 41.8302L568.899 45.8605Z",
    fill: "white"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M623.659 148.792L618.764 148.375L616.678 143.928L619.486 139.898L624.381 140.315L626.467 144.762L623.659 148.792Z",
    fill: "white"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M560.38 39.9251L555.485 39.5082L553.399 35.061L556.207 31.0306L561.102 31.4474L563.188 35.8948L560.38 39.9251Z",
    fill: "white"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M615.14 142.857L610.245 142.44L608.159 137.993L610.967 133.962L615.862 134.379L617.948 138.827L615.14 142.857Z",
    fill: "white"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M551.862 33.9898L546.967 33.5729L544.881 29.1257L547.689 25.0953L552.584 25.5122L554.67 29.9595L551.862 33.9898Z",
    fill: "white"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M606.622 136.922L601.727 136.505L599.641 132.057L602.449 128.027L607.344 128.444L609.43 132.891L606.622 136.922Z",
    fill: "white"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M543.343 28.0543L538.449 27.6375L536.363 23.1903L539.171 19.1599L544.065 19.5767L546.152 24.024L543.343 28.0543Z",
    fill: "white"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M643.342 120.103L638.447 119.686L636.361 115.239L639.17 111.208L644.064 111.625L646.15 116.073L643.342 120.103Z",
    fill: "white"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M534.825 22.119L529.931 21.7022L527.845 17.255L530.653 13.2246L535.547 13.6414L537.634 18.0887L534.825 22.119Z",
    fill: "white"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M526.307 16.1837L521.413 15.7669L519.326 11.3197L522.135 7.28925L527.029 7.70612L529.116 12.1534L526.307 16.1837Z",
    fill: "white"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M15.122 503.236L11.1607 502.898L9.47221 499.299L11.7451 496.037L15.7064 496.374L17.395 499.974L15.122 503.236Z",
    fill: "white"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0377 510.019L19.1431 509.602L17.0567 505.155L19.8651 501.124L24.7597 501.541L26.8459 505.988L24.0377 510.019Z",
    fill: "white"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M646.443 88.934L641.549 88.5171L639.463 84.0698L642.271 80.0395L647.166 80.4564L649.252 84.9035L646.443 88.934Z",
    fill: "white"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M637.925 82.9984L633.03 82.5815L630.944 78.1344L633.752 74.1041L638.647 74.5209L640.733 78.9681L637.925 82.9984Z",
    fill: "white"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M629.406 77.0631L624.512 76.6463L622.426 72.199L625.234 68.1685L630.128 68.5854L632.215 73.0327L629.406 77.0631Z",
    fill: "white"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M620.889 71.1278L615.994 70.711L613.908 66.2638L616.716 62.2333L621.611 62.6502L623.697 67.0975L620.889 71.1278Z",
    fill: "white"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M621.342 61.1029L616.448 60.6861L614.361 56.2389L617.17 52.2084L622.064 52.6253L624.15 57.0726L621.342 61.1029Z",
    fill: "white"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M630.342 67.1029L625.448 66.6861L623.361 62.2389L626.17 58.2084L631.064 58.6253L633.15 63.0726L630.342 67.1029Z",
    fill: "white"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M639.342 63.1029L634.448 62.6861L632.361 58.2389L635.17 54.2084L640.064 54.6253L642.15 59.0726L639.342 63.1029Z",
    fill: "white"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M647.342 78.1029L642.448 77.6861L640.361 73.2389L643.17 69.2084L648.064 69.6253L650.15 74.0726L647.342 78.1029Z",
    fill: "white"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M657.342 75.1029L652.448 74.6861L650.361 70.2389L653.17 66.2084L658.064 66.6253L660.15 71.0726L657.342 75.1029Z",
    fill: "white"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M648.342 68.1029L643.448 67.6861L641.361 63.2389L644.17 59.2084L649.064 59.6253L651.15 64.0726L648.342 68.1029Z",
    fill: "white"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M612.37 65.1925L607.476 64.7756L605.389 60.3284L608.198 56.2982L613.092 56.715L615.179 61.1622L612.37 65.1925Z",
    fill: "white"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M603.852 59.2571L598.958 58.8402L596.871 54.3931L599.68 50.3626L604.574 50.7795L606.66 55.2268L603.852 59.2571Z",
    fill: "white"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M595.334 53.3217L590.439 52.9048L588.353 48.4576L591.161 44.4272L596.056 44.8441L598.142 49.2914L595.334 53.3217Z",
    fill: "white"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M586.815 47.3865L581.921 46.9696L579.835 42.5224L582.643 38.492L587.537 38.9089L589.624 43.3562L586.815 47.3865Z",
    fill: "white"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M578.298 41.4512L573.403 41.0343L571.317 36.5871L574.125 32.5567L579.02 32.9736L581.106 37.4209L578.298 41.4512Z",
    fill: "white"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M633.058 144.383L628.163 143.966L626.077 139.519L628.885 135.488L633.78 135.905L635.866 140.353L633.058 144.383Z",
    fill: "white"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M569.779 35.5158L564.885 35.0989L562.799 30.6517L565.607 26.6213L570.501 27.0381L572.588 31.4855L569.779 35.5158Z",
    fill: "white"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M624.54 138.448L619.645 138.031L617.559 133.583L620.367 129.553L625.262 129.97L627.348 134.417L624.54 138.448Z",
    fill: "white"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M561.261 29.5805L556.366 29.1636L554.28 24.7164L557.088 20.686L561.983 21.1028L564.069 25.5502L561.261 29.5805Z",
    fill: "white"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M616.021 132.512L611.127 132.095L609.04 127.648L611.849 123.618L616.743 124.035L618.83 128.482L616.021 132.512Z",
    fill: "white"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M552.743 23.645L547.848 23.2282L545.762 18.781L548.57 14.7506L553.465 15.1674L555.551 19.6147L552.743 23.645Z",
    fill: "white"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M544.225 17.7097L539.33 17.2929L537.244 12.8457L540.052 8.81526L544.947 9.23212L547.033 13.6794L544.225 17.7097Z",
    fill: "white"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M534.629 9.47755L532.262 9.27597L531.253 7.12549L532.611 5.17671L534.978 5.37828L535.987 7.52863L534.629 9.47755Z",
    fill: "white"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M638.772 72.5825L633.956 72.1723L631.904 67.7965L634.667 63.8308L639.483 64.241L641.535 68.6168L638.772 72.5825Z",
    fill: "white"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M613.252 54.8478L608.357 54.4309L606.271 49.9838L609.079 45.9533L613.974 46.3702L616.06 50.8175L613.252 54.8478Z",
    fill: "white"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M604.733 48.9125L599.839 48.4956L597.753 44.0485L600.561 40.018L605.455 40.4349L607.542 44.8822L604.733 48.9125Z",
    fill: "white"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M596.215 42.9772L591.321 42.5603L589.234 38.1131L592.043 34.0827L596.937 34.4996L599.023 38.9469L596.215 42.9772Z",
    fill: "white"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M587.697 37.0417L582.802 36.6249L580.716 32.1777L583.524 28.1473L588.419 28.5641L590.505 33.0115L587.697 37.0417Z",
    fill: "white"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M579.178 31.1065L574.284 30.6896L572.198 26.2424L575.006 22.212L579.9 22.6288L581.987 27.0762L579.178 31.1065Z",
    fill: "white"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M633.939 134.038L629.044 133.621L626.958 129.174L629.766 125.144L634.661 125.561L636.747 130.008L633.939 134.038Z",
    fill: "white"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M570.66 25.1712L565.766 24.7543L563.679 20.3071L566.488 16.2767L571.382 16.6935L573.469 21.1409L570.66 25.1712Z",
    fill: "white"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M625.421 128.103L620.526 127.686L618.44 123.239L621.248 119.208L626.143 119.625L628.229 124.073L625.421 128.103Z",
    fill: "white"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M562.142 19.2357L557.247 18.8189L555.161 14.3717L557.969 10.3413L562.864 10.7581L564.95 15.2054L562.142 19.2357Z",
    fill: "white"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M553.621 13.2952L548.732 12.8789L546.649 8.43675L549.454 4.41131L554.342 4.82769L556.426 9.26951L553.621 13.2952Z",
    fill: "white"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M614.132 44.5032L609.238 44.0863L607.152 39.6391L609.96 35.6087L614.854 36.0256L616.941 40.4729L614.132 44.5032Z",
    fill: "white"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M605.614 38.5679L600.72 38.151L598.634 33.7038L601.442 29.6734L606.336 30.0903L608.423 34.5376L605.614 38.5679Z",
    fill: "white"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M597.096 32.6325L592.201 32.2156L590.115 27.7684L592.923 23.738L597.818 24.1549L599.904 28.6022L597.096 32.6325Z",
    fill: "white"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M588.578 26.6971L583.683 26.2803L581.597 21.8331L584.405 17.8027L589.3 18.2195L591.386 22.6669L588.578 26.6971Z",
    fill: "white"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M580.06 20.7619L575.165 20.345L573.079 15.8978L575.887 11.8674L580.782 12.2842L582.868 16.7316L580.06 20.7619Z",
    fill: "white"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M571.542 14.8265L566.647 14.4097L564.561 9.96236L567.369 5.93206L572.264 6.34894L574.35 10.7961L571.542 14.8265Z",
    fill: "white"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M562.493 7.76141L558.842 7.45045L557.285 4.13303L559.38 1.12643L563.031 1.43739L564.588 4.75498L562.493 7.76141Z",
    fill: "white"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M615.014 34.1586L610.119 33.7417L608.033 29.2945L610.841 25.2641L615.736 25.681L617.822 30.1283L615.014 34.1586Z",
    fill: "white"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M606.496 28.2233L601.601 27.8064L599.515 23.3592L602.323 19.3288L607.218 19.7457L609.304 24.193L606.496 28.2233Z",
    fill: "white"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M597.838 21.99L593.271 21.601L591.324 17.4517L593.945 13.6912L598.511 14.0801L600.458 18.2296L597.838 21.99Z",
    fill: "white"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M589.458 16.3525L584.564 15.9357L582.478 11.4884L585.286 7.45807L590.18 7.87492L592.267 12.3221L589.458 16.3525Z",
    fill: "white"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M579.863 8.12038L577.496 7.91881L576.488 5.76846L577.845 3.81954L580.212 4.02111L581.221 6.1716L579.863 8.12038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakWithKashmir);
export default __webpack_public_path__ + "static/media/pakWithKashmir.cbe496b8e5af4879c597eaeae2bb132f.svg";
export { ForwardRef as ReactComponent };